export default {
  common: {
    noFace: 'Yüz yok',
    noPermissionTip: 'Bu özelliği kullanmak için izininiz yok. Devam etmek için lütfen satın alın veya yenileyin.',
    selected: 'Seçildi',
    continue: 'Devam et',
    open1: 'Aç',
    doubleClick: 'Çift tıkla',
    inputKeywordSearch: 'Arama anahtar kelimesi girin',
    inputKeywordStartSearch: 'Arama anahtar kelimesi girin',
    searchHistory: 'Arama geçmişi',
    clearHistory: 'Geçmişi temizle',
    notFoundRelatedResults: 'İlgili sonuçlar bulunamadı',
    switch: 'Değiştir',
    searchProductionLine: 'Üretim Hattı',
    selectProductionLine: 'Üretim Hattını Seç',
    rotateAngleTip: '{angle} Döndür',
    plankText: 'Panel',
    sendToEzSort: "EzSort'e gönder",
    downloadEzSort: "EzSort'i indir",
    notDownloadTip: "EzSort normal açılmazsa, indirmediğiniz anlamına gelebilir. EzSort'i indirmek için aşağıdaki düğmeye tıklayın",
    updateTip: "Yazılım güncellemesi algılandı. Guigui'yi yeniden başlatın!",
    betaTest: 'Beta test süresi için ücretsiz',
    ersortSpecail: 'Renk etiketleri için özel',
    exclusiveFeature: 'Özel özellik',
    elementCanBeDragTip: 'Eleman sürüklenir',
    checkPlankIsConflict: 'Panellerin durumu kontrol ediliyor',
    preferenceSaveErr: 'Tercihler kaydedilirken hata oluştu',
    guimen: 'Kabinet kapısı',
    preferenceLoadTip: 'Tercihler yükleniyor',
    preferenceLoadErrTip: 'Tercihler yüklenemedi. Lütfen yeniden yükleyin ve tercihlerinizin hatalı olmaması için yeniden deneyin!',
    localFileIsBeingWrite: 'Yerel dosya yazılıyor',
    unnamedFile: 'Adsız dosya',
    taskMonitor: 'Görev izleme',
    downloadByType: '{type} indir',
    slotKnifeErr: 'Belirtilen slot için işleme aleti eksik. Lütfen üretim hattı ayarlarını kontrol edin! 【{msg}】',
    anewChooseCatalog: 'Dizin tekrar seç',
    downloadSetting: 'İndirme ayarları',
    attention: 'Dikkat',
    unit: 'Adet',
    defaultUse: 'Varsayılan kullanım',
    defaultChooseUse: 'Varsayılan seçim',
    requestFail: 'İstek başarısız oldu',
    downloadDoneByType: '{type} indirildi',
    sysTip: 'Sistem bildirimi',
    pleaseChoose: 'Lütfen seçin',
    confirmDelete: 'Silmeyi onayla',
    notDataTipByType: 'Veri yok, lütfen önce {msg} yapın',
    paginationTotalTip: '{current}-{page} / {total} adet',
    chooseAmountData: '{number} adet veri seçildi',
    moreOperate: 'Daha fazla',
    transferByType: '{type} transfer et',
    clickCopy: '{type} kopyalamak için tıklayın',
    currentLine: 'Mevcut satır',
    remark: 'Notlar',
    customFunction: 'Özel Fonksiyon',
    limitedTimeTrial: 'Limited Free',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    startTime: 'Başlangıç zamanı',
    endTime: 'Bitiş zamanı',
    lastMonth: 'Son aylar',
    lastSixMonth: 'Son altı ay',
    lastYear: 'Son yıl',
    searchByType: '{type} aramak için lütfen girin',
    addTime: 'Zaman ekle',
    startArrange: 'Tipografi başlat',
    select: 'Seç',
    search: 'Arama',
    name: 'Ad',
    plankNo: 'Plate numarası',
    plankName: 'Plate adı',
    orderNo: 'Sipariş numarası',
    order: 'Sipariş',
    partNameWithoutRoomCabinet: 'Plate adı (oda/dolap hariç)',
    plankRemark: 'Plate notu',
    room: 'Oda',
    orderAddress: 'Sipariş adresi',
    matCode: 'Malzeme kodu',
    matCode2: 'Malzeme',
    plankMatCode: 'Plate malzeme',
    count: 'Adet',
    customer: 'Müşteri',
    customerInfo: 'Müşteri bilgileri',
    factoryOrderNo: 'Fabrika sipariş numarası',
    roomName: 'Oda adı',
    color: 'Renk',
    plankColor: 'Plate renk',
    plankThick: 'Plate kalınlığı',
    plankHighGloss: 'Highlight özellikleri',
    thick: 'Kalınlık',
    front: 'Ön yüz',
    back: 'Arka yüz',
    slot: 'Kanal',
    hole: 'Delik',
    hsInfo: '{hole} delik {slot} kanal',
    diameter: 'Çap',
    finishedWidth: 'Tamamlandığında genişlik',
    finishedHeight: 'Tamamlandığında uzunluk',
    finishedArea: 'Tamamlanmış ürün alanı (㎡)',
    remarks: 'Not',
    remark1: 'Not 1',
    remark2: 'Not 2',
    remark3: 'Not 3',
    remark4: 'Not 4',
    remark5: 'Not 5',
    remark6: 'Not 6',
    remark7: 'Not 7',
    remark8: 'Not 8',
    remark9: 'Not 9',
    remark10: 'Not 10',
    remark11: 'Not 11',
    remark12: 'Not 12',
    remark13: 'Not 13',
    remark14: 'Not 14',
    remark15: 'Not 15',
    remark16: 'Not 16',
    texture: 'Yüzey yapısı',
    normal: 'Dikey yapısı',
    reverse: 'Yatay yapısı',
    notCare: 'Yüzey yapısı yok',
    holeSlotsStastic: 'Delik ve Kanal Sayısı',
    edge: {
      title: 'Kenar',
      info: 'Kenar bilgileri',
      front: 'Ön kenar',
      back: 'Arka kenar',
      left: 'Sol kenar',
      right: 'Sağ kenar',
      up: 'Üst kenar',
      down: 'Alt kenar'
      },
    isSpecial: 'Özel şekilli',
    notSpecial: 'Özel değil',
    textOfDoorPlank: 'Kapı panosu',
    textOfNotDoorPlank: 'Kapı olmayan pano',
    isDoorPlank: 'Kapı panosu',
    notDoorPlank: 'Kapı panosu değil',
    width: 'Genişlik',
    long: 'Uzunluk',
    plankWidth: 'Panoyun genişliği',
    plankHeight: 'Panoyun uzunluğu',
    shortLong: 'Kısa kenar uzunluğu',
    shortWidth: 'Kısa kenar genişliği',
    plankShape: 'Panoyun şekli',
    detail: 'Detaylar',
    cancel: 'İptal et',
    confirm: 'Onayla',
    alreadyKnow: 'Zaten biliyorum',
    Noprompts: 'Bir daha gösterme',
    deep: 'Derinlik',
    other: 'Diğer',
    heighGloss: 'Yüksek গ্লস',
    heighGlossPlank: 'Yüksek গ্লস বোর্ড',
    heighGlossSide: 'Yüksek গ্লস বোর্ড',
    notHeighGloss: 'Yüksek গ্লস বোর্ড নয়',
    notHeighGlossPlank: 'Yüksek গ্লস বোর্ড নয়',
    saveSuccess: 'Kaydetme başarılı',
    deleteSuccess: 'Silme başarılı',
    addSuccess: 'Ekleme başarılı',
    editSuccess: 'Düzenleme başarılı',
    engraving: 'Kesme makinesi',
    electronicSaw: 'Elektrikli kesme makinesi',
    glassEquip: 'Cam kesme makinesi',
    labelingMachine: 'Etiket makinesi',
    copy: 'Kopyala',
    paste: 'Yapıştır',
    undo: 'Geri al',
    move: 'Taşı',
    PTP: 'PTP',
    dock56FDrill: '5/6-Face Drilling Machine',
    sideHoleDrill: 'Side hole drilling machine',
    combination: 'Combination Machine',
    integration: 'Integration Machine',
    standardPlank: 'Standard Board',
    standardMaterial: 'Standard Material',
    standardMaterialTip: 'Not: Büyük pano bilgilerini ayarlamayı tamamladıktan sonra, kabinet düzeni üretimi kullanan kullanıcılar, en son değişiklikleri uygulamak için kabinet istemcisini yeniden başlatmalıdır!',
    specialMaterial: 'Özel Malzeme',
    specialPlank: 'Özel Tahta',
    singlePlank: 'Tek Taraflı Levha',
    previous: 'Önceki',
    plankInfo: 'Büyük Tahta Detayları',
    moreResult: 'Daha Fazla Yerleşim Çözümü',
    moreResultTip: 'Büyük tahtada kenar işlemesi için yarıklar vardır; büyük tahta yeniden yerleştirmeye katılmayacaktır.',
    ok: 'Onayla',
    dispersePaibanTip: 'Bazı büyük tahtalar dağıtılarak yerleştirilemiyor; manuel ayarlama yapabilir veya yerleşim planını değiştirebilirsiniz, panonun kaymasını önleyin!',
    next: 'Sonraki',
    rate: 'Kullanım Oranı',
    paibanBatch: 'Yerleşim Partisi',
    return: 'Geri',
    FGNo: 'Sözleşme Numarası',
    refresh: 'Yenile',
    inde: 'Sıra Numarası',
    productionLine: 'Üretim Hattı',
    operation: 'İşlem',
    colorPlaceHolder: 'Renk kartı oluşturmak için Enter tuşuna basın',
    saveAndContinue: 'Kaydet ve Devam Et',
    reset: 'Sıfırla',
    check: 'Sorgula',
    inputPlaceholder: 'Lütfen girin',
    filter: 'Filtre',
    all: 'Tümü',
    exportPDF: 'PDF Dışa Aktar',
    exportPic: 'Resmi Dışa Aktar',
    add: 'Ekle',
    edit: 'Düzenle',
    delete: 'Sil',
    restore: 'Geri Al',
    save: 'Kaydet',
    saveSetting: 'Ayarları kaydet',
    isHeightGloss: 'Yüksek parlak levha olup olmadığını seçin',
    noSync: 'Senkronize değil',
    sync: 'Senkronize',
    formatSuccess: '{type} başarılı',
    dataLoading: 'Veriler yükleniyor...',
    warmTip: 'İyi hatırlatma',
    importantTip: 'Önemli hatırlatma',
    wellcome: 'Bulut dizilimine hoş geldiniz',
    timeOut: 'Dizilim zaman aşımına uğradı, yeniden dizmek ister misiniz?',
    notSawKnifeTip: 'Dikkat: Testere kesim oyma makinesinde "Enine kesim testere bıçağı" ayarlı olmadığı için yerleştirme yapılamıyor. Lütfen ekleyin!',
    doorFrameKnifeRadiusErr: '"Testere kesim oyma makinesi-Kapı kasası kesimi" özelliğini etkinleştirdiniz. Kesim bıçağı yarıçapı testere kalınlığından büyük, yerleştirme yapılamıyor!',
    doorFrameIrregularPlankErr: '"Testere kesim oyma makinesi-Kapı kasası kesimi" özelliğini etkinleştirdiniz. Bu özellik şu anda düzensiz panel yerleştirmeyi desteklemiyor!',
    warning: 'Uyarı',
    export: 'Dışa aktar',
    mark: 'İşaretle',
    noMark: 'İşaretsiz',
    sawArrange: 'Testere kesim dizilimi',
    directArrange: 'Doğrudan Yerleştirme',
    area: 'Alan',
    plankNum: 'Parça Barkodu',
    loc: 'Dolap',
    cutHeight: 'Kesme Uzunluğu',
    cutWidth: 'Kesme Genişliği',
    defaultProduction: 'Varsayılan Üretim Hattı',
    surplusNum: 'Artık Barkodu',
    tip: 'İpucu',
    history: 'Geçmiş',
    hinge: 'Menteşe Deliği',
    hingeScrew: 'Menteşe Paneli Kılavuz Delikleri',
    CCPXHole: 'Üçü Bir Eksen Delik',
    stretchHinge: 'Düzleştirici yuvası ve menteşe kap deliği',
    stretch: 'Düzleştirici',
    stretcher: 'Düzleştirici yuvası',
    eccHole: 'Eksantrik delik',
    preHole: 'Ön gömülü delik',
    clothole: 'Kıyafet çubuğu deliği',
    backPlank: 'Arka panel yuvası',
    ALS: 'Gizli çekme yuvası',
    doorSlot: 'Kapı metal yuvası',
    drawerSlot: 'Çekmece metal yuvası',
    lkSlot: 'Kilit yuvası',
    KC: 'Pantolon çekmece deliği',
    stealth: 'Görünmez bileşen',
    lightSlot: 'Işık yuvası',
    ConventionalHole: 'Geleneksel delik',
    Keyhole: 'Anahtar deliği',
    allHole: 'Özel tahtadaki tüm delikler',
    allSlot: 'Özel tahtadaki tüm yuvalar',
    freedomAllHoleSlot: 'Özel tahtadaki tüm delikler ve yuvalar',
    freedomAllHoleSlotTip: 'Özel tahta: doğru açılı köşe olmayan tahta',
    millInfo: 'Boynuz kolu',
    haiTang: 'Begonvil köşesi',
    FSDrill: 'Beş/Altı Yüzlü Delme Makinesi',
    engraving2: 'Oyma Makinesi',
    xyReverse: 'XY Ekseni Takas',
    autoXYReverse: 'Özel tahtadaki tüm yuvalar',
    autoXYReverseTip: 'Beş/Altı Yüzlü Delme Makinesi ve sıçrama makinesinin XY ekseni takasına uyumlu hale getirilir',
    autoXYReverseTip2: 'PTP desteklenmiyor',
    xyReverseTip: 'XY eksen takas işlevi henüz L-şekilli artık malzeme boşluğunun doğru yerleştirilmesi ile uyumlu değil, lütfen dikkatli kullanınız',
    rect: 'Dikdörtgen',
    Ltype: 'L-şekli',
    archive: 'Arşiv',
    tellPlaceholder: 'Lütfen cep telefonu numarası girin',
    knivesStore: 'Bıçak Depolama',
    roll: 'Panoyu çevir',
    pause: 'Duraklat',
    editTrans: 'Çeviriyi Düzenle',
    translateManager: 'Çeviri Yöneticisi',
    grating: 'Izgaralar',
    addressEditErr: 'Çok sayıda siparişte proje adresinin değiştirilmesi desteklenmiyor',
    customerEditErr: 'Çok sayıda siparişte müşteri bilgilerinin değiştirilmesi desteklenmiyor',
    factoryEditErr: 'Çok sayıda siparişte fabrika siparişi numarasının değiştirilmesi desteklenmiyor',
    roomNameEditErr: 'Çok sayıda siparişte oda adının değiştirilmesi desteklenmiyor',
    remarkEditErr: 'Çok sayıda siparişte sipariş notlarının değiştirilmesi desteklenmiyor',
    toMaterialList: 'Malzeme Listesine Git',
    deleteFail: 'Silme başarısız, lütfen daha sonra tekrar deneyin!',
    batchRestore: 'Toplu Geri Yükleme',
    batchDelete: 'Toplu Silme',
    workShop: 'İşçi Üretimi',
    FGAdrress: 'Proje Adresi/Sözleşme Numarası',
    cuttingSize: 'Kesme Boyutu',
    finishedSize: 'Tamamlanmış Boyut',
    labelImg: 'Etiket Resmi',
    layoutImg: 'Tasnif Diyagramı',
    file: 'Dosya',
    folder: 'Klasör',
    reName: 'Adını Değiştir',
    to: 'Kime',
    plankUnit: 'Sayfa',
    tagTemp: 'Etiket Şablonu',
    roomRemark: 'Odanın Devamında',
    noModificationPermission: 'Değiştirme İzni Yok',
    modificationRecord: 'Değişiklik Kaydı',
    page: 'Sayfa',
    strip: 'Şerit',
    jump: 'Atla',
    freeAgreement: 'Yazılım Sorumluluk Reddi Anlaşması',
    preStep: 'Önceki Adım',
    nextStep: 'Sonraki Adım',
    upload: 'Yükle',
    uploading: 'Yükleniyor',
    iAgree: 'Katılıyorum',
    pleaseSelectPlank: 'Lütfen en az bir beyaz tahta seçin',
    saveToStoreTip: 'Lütfen en az bir kesilmemiş parça seçin',
    fileIsNotExist: 'Dosya Yok',
    selectAll: 'Tümünü Seç',
    pdfTag: 'PDF Etiketi',
    tagImage: 'Etiket Görüntüsü',
    guigui: 'Guigui',
    gratingSlot: 'Izgara Yuvası',
    deleteTip: 'Veriler silindikten sonra kurtarılamaz, silmeyi onaylamadan emin misiniz?',
    deleteError: 'Bilinmeyen Hata Oluştu ve Silme Başarısız Oldu',
    cancelDelete: 'Silme İptal Edildi',
    confirmDeleteTip: 'Silindikten sonra tahta "Yazılacak Board - depolanmadı" bölümüne girecek, silmeyi onaylayın mı?',
    confirmDeleteBujianTip: 'Silindikten sonra parça "Parça Kütüphanesi"ne eklenecektir, silmeyi onaylıyor musunuz?',
    confirmSureDeleteTip: 'Mevcut mizanpaj kütüphanesinde aynı malzemeden küçük tahtalar bulunmuştur, bu büyük tahtayı silmeye devam etmeyi onaylayan mısınız?',
    deleteEmptyTip: 'Bu Büyük Paneli Silmek İstiyor Musunuz?',
    notCanDelete: 'Kesilen Kalan Malzeme Depolama Desteklemez',
    new: 'New',
    innerBluneFailure: 'Gömülü Bulut Düzenlemesi Bu Işlevi Etkinleştirmez',
    deleteBigPlankTip: 'Son Büyük Panelde Küçük Panel Vardır ve Silinemiyor!',
    continueExport: 'Göz Ardı Et ile Çıkış Dosyasına Devam Et',
    toCheck: 'Kontrol etmeye git',
    pleaseCheck: 'Mevcut yerleşim sonucunda delik-kanal çakışması / küçük plakanın dışarı çıkması / derinlik anormalliği var, lütfen kontrol edin!',
    clampHandCheck: 'Bazı parçalarınızdaki delik ve kanalların kelepçe konumundan kaçamadığı tespit edildi, lütfen manuel olarak ayarlayın',
    conflictPartDetail: 'Çakışan parçaların ayrıntıları',
    colorNotUndefined: 'Renk boş olamaz',
    materialNotUndefined: 'Malzeme boş olamaz',
    newSetting: 'Yeni özellik',
    downImageErrTip: 'Resim dışa aktarma başarısız oldu. Etiket resimleri büyük plakaya göre farklı klasörlere ayrıldığı için küçük plaka etiketlerini de birlikte seçmeniz gerekir.',
    downNcErrTip: 'NC indirme başarısız oldu. Etiket resimleri büyük plakaya göre farklı klasörlere ayrıldığı için küçük plaka etiketlerini de birlikte seçmeniz gerekir.',
    downNcErrTipForSurFolder: 'NC indirme başarısız oldu. Etiket resimlerini büyük plakaya göre farklı klasörlere ayırma ve artık büyük plaka dosyası ayarı aynı anda etkinleştirilemez.',
    yes: 'Evet',
    no: 'Hayır',
    checkColorPrint: 'Renkli etiket şu anda açık, lütfen yazdırmak için renkli yazıcı kullanın~',
    colorRules: "Renkli etiket oluşturma açıldıktan sonra siparişler/odalar/dolaplar/kapak panelleri renge göre ayrılır. Şu anda aynı tür veri için desteklenen renkli etiket üst sınırı 12'dir. Kurallar aşağıdaki gibidir:",
    greyPart: 'Sağdaki etiketteki gri kısım',
    region: 'Bölge',
    notSame: 'Farklı {regionName} bölgelerinin renkleri farklıdır',
    doorTip: 'Gri kapak panelini, beyaz ise kapak olmayan paneli gösterir',
    exist: 'Var',
    limitNotEffect: "Veri sayısı 12'yi aşarsa renkli etiket geçerli olmaz",
    hoverTip: 'Geçerli resim bmp uzantılıdır; kodlama siyah beyazdır ve renkli etiket resmi üretilemez',
    lock: 'Kilitle',
    unlock: 'Kilidi aç',
    batchLock: 'Toplu kilitle/kilit aç',
    surplusLock: 'Artık malzeme kilidi',
    surplusUnlock: 'Artık malzeme kilidini aç',
    is: 'Evet',
    not: 'Hayır',
    savingHistory: 'Geçmiş dosyası kaydediliyor',
    saveHistorySuccess: 'Geçmiş dosyası başarıyla kaydedildi',
    saveHistoryFail: 'Geçmiş dosyası kaydedilemedi',
    bw: 'Siyah beyaz etiket dışa aktarılsın mı',
    modular: 'Ünite dolabı',
    autoAdjust: 'Otomatik ayarla',
    cutOrderTip: '【{errorCutOrdersString}. büyük plakadaki】 kesim sıralamasında hata tespit edildi! Lütfen ayarladıktan sonra NC dosyasını indirin',
    lockedCutOrderTip: '【{errorCutOrdersString}. büyük plaka】 kilitlenmiştir, lütfen manuel olarak değiştirin',
    paibanImgCutOrderTip1: 'Sizin',
    paibanImgCutOrderTip: 'Kesim sıralamasında hata var! Lütfen yerleşim sayfasına gidip ayarladıktan sonra yerleşim görsel dosyasını dışa aktarın',
    goAdjust: 'Ayarlamaya git',
    autoAdjustWarning: 'Geçerli yerleşim sonucu otomatik ayarlamayı desteklemiyor',
    checkNetwork: 'Lütfen ağı kontrol edin',
    moreInfo: 'Daha fazla bilgi görüntüle',
    continueLayout: 'Yerleşime devam et',
    adjustPosition: 'Ayarları düzenle',
    specialAndFiveSix: 'Beş/altı yüzlü delme ile özel şekilli parça işlenirken, özel şekil iç içe yerleştirme açılırsa parçaya kesim gelebilir. Yerleşime devam etmek istediğinizi onaylıyor musunuz?',
    plankPathErr: 'Parça içindeki özel şekil verisinde hata var, lütfen alet özelliklerine uygun olup olmadığını kontrol edin! Parça no: 【{plankIDList}】',
    edgeCheck: 'Sistem, büyük plakanın kenar düzeltmesinin değiştirildiğini algıladı. Üretim doğruluğunu sağlamak için lütfen yeniden yerleştirin',
    iKnow: 'Anladım',
    versionErrTip: "Lütfen Guigui'yi en son sürüme güncelleyin!",
    annualFeeExpired: 'Yıllık aboneliğinizin süresi doldu, lütfen yenileyin!',
    holeEquipment: 'Delme ekipmanı {num}',
    customizedService: 'Size özel üretim planınızı oluşturmak için özelleştirilmiş hizmetleri destekler',
    exampleCombination1: 'Oyma makinesi + beş/altı yüzlü matkap + yan delik makinesi kombinasyonu',
    exampleCombination2: 'Elektronik testere + beş/altı yüzlü matkap + yan delik makinesi kombinasyonu',
    exampleCombination3: 'Tam otomatik entegre üretim hattı + beş/altı yüzlü matkap kombinasyonu',
    feedback: 'İhtiyaçlarınızı doğrudan Guigui yazılım satış veya satış sonrası personeline iletebilirsiniz',
    markModifiedBoards: 'Değiştirilen küçük plakaları işaretle',
    showMoveStep: 'Klavye hareket adımını belirle',
    moveStep: 'Klavye hareket adımı',
    existChangeBoards: 'Değişiklik bulunan küçük plakalar var',
    crossMaterialBoard: 'Çapraz malzeme-renk plakası',
    skipCrossMaterialTip: 'Bu düzende bir daha gösterme',
    crossMaterialConfirmTip: 'Farklı malzeme veya renkler arasında küçük bir levha taşıyorsunuz. {highlight} Devam edilsin mi?',
    crossMaterialConfirmTipHighlight: 'Üretilen levha bölünmüş siparişle tutarsız olabilir',
    exportHoleSlotPDF: 'Delik ve kanal diyagramını dışa aktar',
    pdfFormat: 'PDF biçimi',
    dxfFormat: 'DXF biçimi',
    specialShapeKnivesInfo: 'Özel şekil bıçak seçimi uyarısı',
    specialShapeKnivesInfoTips: '{stockNum}. parça:',
    specialShapeKnivesInfoTips2: 'Özel şekil için otomatik takım seçimi açıldı, yerleşim verisi anormal. Lütfen kesim listesinden yeniden yerleştirin veya özel şekil için otomatik takım seçimini kapatın',
    default: 'Varsayılan',
    exportLanguage: 'Dışa aktarma dili',
    exportLanguageTip: 'Not: Bazı metin bilgiler PDF olarak dışa aktarılırken çevrilemez',
    highGlossNameTip: 'Dolaptan senkronize edilen parlak paneller başka metinlerle açıklanabilir; bu, parlaklık özelliğini etkilemez',
    mixPaibanPlanSetting: 'Karışık yerleşim planı ayarı',
    mixPaibanPlanSettingTip: 'Sistem karışık yerleşim planı ayarının değiştiğini algıladı, lütfen bu kez kullanılacak planı yeniden seçin!',
    mixPaibanPlanSettingOk: 'Karışık yerleşim planını ayarla',
    mixPaibanPlanSettingCancel: 'Hayır, doğrudan yerleştir',
    noMixPaibanPlan: 'Kullanılabilir karışık yerleşim planı yok',
    mixColors: 'Karışık renkler',
    mixPai: 'Karışık yerleşim',
    plan: 'Plan',
    mixPaibanTitle: 'Farklı renklerdeki küçük plakaları birlikte yerleştir',
    mixColorsTip: 'Parçaların orijinal renk bilgisini değiştirmeden, hangi renk parçaların aynı renk olarak aynı büyük plakada üretilebileceğini tanımlayabilirsiniz.',
    mixColorsTip2: 'Plan eklendikten sonra etkili olması için kesim listesinde etkinleştirilmelidir',
    mixColorsTip3: 'Farklı renk kenar bantlama işleviyle çakışma var, bu işlev geçici olarak aynı anda etkin olamaz',
    mixErrTip: 'Karışık yerleşim planında zorunlu alanlar eksik, lütfen kontrol edin',
    addPlan: 'Plan ekle',
    chooseMatcode: 'Malzeme seç',
    chooseColor: 'Renk seç',
    defineColor: 'Seçilen rengi şöyle tanımla',
    confirmDeletePlan: 'Bu planı silmek istediğinizi onaylıyor musunuz?',
    trimmingMethod: 'Kenar düzeltme yöntemi',
    followStandardTrim: 'Orijinal plakadaki standart panelin kenar düzeltme değerini takip et',
    trimToast: 'Not: Artık malzeme için özel kenar düzeltme özelliğini kullanıyorsunuz; yalnızca testere kesim yerleşimi seçilebilir',
    individualTrimValue: 'Kenar düzeltme değerini ayrı ayrı ayarla',
    topTrimEmptyToast: 'Üst kenar düzeltme boş olamaz!',
    bottomTrimEmptyToast: 'Alt kenar düzeltme boş olamaz!',
    leftTrimEmptyToast: 'Sol kenar düzeltme boş olamaz!',
    rightTrimEmptyToast: 'Sağ kenar düzeltme boş olamaz!',
    topTrimBlurToast: 'Lütfen üst kenar düzeltme değerini girin',
    bottomTrimBlurToast: 'Lütfen alt kenar düzeltme değerini girin',
    leftTrimBlurToast: 'Lütfen sol kenar düzeltme değerini girin',
    rightTrimBlurToast: 'Lütfen sağ kenar düzeltme değerini girin',
    effectToast: '1. Özel kenar düzeltme özelliği yalnızca kaynaklı levhalar için geçerlidir',
    defaultTrimSetting: 'Artık malzeme varsayılan kenar düzeltme ayarı',
    enterHere: 'Buraya girin',
    permissionTipExportDxf: 'DXF Delik Yuvası Diyagramını Dışa Aktar',
    permissionTipSurplusRecycleBin: 'Artık Geri Dönüşüm Kutusu',
    permissionTipAdvancedNesting: 'Gelişmiş Düzensiz Yuvalama',
    permissionTipPanelGrainAlign: 'Panel Daneli Hizalama',
    permissionSeparator: ', ',
    missingPermissionTip: 'Şu izinler eksik: {permissions}'
    },
  home: {
    head: {
      production: 'Ürün Tanıtımı',
      resolve: 'Cozumler',
      about: 'Hakkimizda',
      equipment: 'Ekipman',
      tell: 'Sikayet Hatti',
      enter: 'Bulut Dizgisine Gir'
      },
    swiper: {
      case1: {
        tag: 'Yeni Yukseltildi',
        subTitle: 'Makinelerin Akilli Beyni',
        description: 'Sektoru donusturen bulut tabanli cevrim ici dizgi optimizasyon yazilimi'
        },
      case2: {
        title: 'Dolap Uretimi',
        subTitle: 'Teknolojik Yenilik',
        description: 'Cesitli etiketleme makineleri, kesim makineleri, yan delik makineleri, bes yuzlu PTP ve bes/alti yuzlu delme makineleriyle entegrasyonu destekler'
        },
      case3: {
        title: 'Endustriyel Beyin',
        subTitle: 'Cozumler',
        description: 'Akilli dizgi algoritmasi daha yuksek malzeme kullanim orani saglar'
        }
      },
    statistics: {
      today: 'Bugunku Dizgi Miktari',
      toMounth: 'Aylik Dizgi Miktari',
      outturn: 'Verim Orani',
      cumulative: 'Kumulatif Kullanicilar'
      },
    intro: {
      title: 'Kurumsal duzey buyuk veri bulut tabanli cevrim ici dizgi yazilimi',
      subTitle: 'Sektor trendlerini analiz eder, musteri ihtiyaclarina odaklanir, isletmelerin dijital donusumunu guclendirir ve internet mobilya uretim otomasyonunu ileri tasir. Mevcut panel mobilya uretim senaryolari icin AI destekli algoritmalar sunarak isletmelere surekli yeni buyume katkisi saglar.',
      menue: {
        case1: {
          title: 'Cevrim Ici Dizgi',
          subTitle: 'Her Zaman Dizgi Yapilabilir',
          description: 'Yazilim indirmenize gerek yok; istediginiz zaman dizgi yapabilir, uzaktan kontrolu bilgisayara bagli kalmadan gerceklestirebilirsiniz.'
          },
        case2: {
          title: 'Cok Hatli Uretim',
          subTitle: 'Uretim Hatlari Arasinda Hizli Gecis',
          description: 'Birden fazla uretim hattinda ayni anda hizli islemeyi destekler ve hatlar arasinda hizli gecis saglar.'
          },
        case3: {
          title: 'Hassas Uretim',
          subTitle: 'Hassas Dizgi ve Parametre Ayarlari',
          description: 'Hassas dizgi ve hassas parametre ayarlari, panel uretimini daha dogru hale getirir.'
          },
        case4: {
          title: 'Ozel Uretim',
          subTitle: 'Ozel Etiketler, Bes/Alti Yuzlu Delme, Artik Malzeme Sekilleri',
          description: 'Ozel etiketler, ozel bes/alti yuzlu delme, ozel artik malzeme sekilleri ve kombine ekipman isleme destegi.'
          }
        }
      },
    fangan: {
      title: 'Sektor Icin Profesyonel Cozumler',
      subTitle: 'Dusuk maliyet, yuksek verim; akilli algoritmalar panel kullanimini artirir, cesitli tasarim yazilimlariyla uyumludur ve kullanicilara en uygun uretim planini sunar.',
      menue: {
        case1: {
          title: 'Cevrim Ici Siparis ve Uretim Entegrasyonu',
          description: 'Uzaktan cevrim ici islem, mekan engellerini asar; siparisler her an fabrikaya senkronize edilir ve tasarim ile uretim es zamanli tamamlanir.'
          },
        case2: {
          title: 'Uretim Hatlari Arasinda Tek Tikla Gecis',
          description: 'Ozellestirilebilir uretim hatlari; birden fazla hatti ve farkli turde ekipman baglantilarini destekler.'
          },
        case3: {
          title: 'Akilli Algoritma Panel Kullanimini Artirir',
          description: 'Geleneksel algoritmalarda panel kullanim orani dusuktur; akilli algoritmalar hassas parametre ayarlari ve ozellestirilmis uretim planlari sunar.'
          },
        case4: {
          title: 'Profesyonel Kesim Cozumleri',
          description: 'Kesim sirasini ve baslangic noktalarini optimize ederek yolu kisaltir ve kesimi daha stabil hale getirir.'
          }
        }
      },
    aboutUs: {
      title1: 'Xingeer Yasam Teknolojisi',
      subTitle: 'Mobilya Uretim Sektorunde Donusumun Oncusu',
      description: 'Xingeer, geleneksel mobilya uretim sektorunun internet tabanli donusumunu gerceklestirmeye odaklanmistir.',
      culture: {
        case1: {
          title: 'Kurumsal Amac',
          subTitle: 'Fabrikalarin Uc Kat Buyumesine Yardim Etmek'
          },
        case2: {
          title: 'Kulturel Degerler',
          subTitle: 'Musteri odakli, emek verenleri temel alan, cok calisan ve topluma fayda saglayan anlayis'
          },
        case3: {
          title: 'Yonlendirici Dusunce',
          subTitle: 'Kitle cizgisi anlayisiyla; satis, urun ve organizasyon gucune sahip seckin bir ekip kurmak'
          }
        },
      feature: {
        case1: 'Profesyonel Ekip Bakimi',
        case2: 'Surekli Guncelleme ve Yineleme',
        case3: 'Bire Bir Satis Sonrasi Hizmet',
        case4: 'Ozel Fonksiyon Hizmeti'
        }
      },
    cooperation: {
      title: 'Samimi Is Birligiyle Gelecegi Birlikte Insaa Edelim',
      subTitle: "Baglanti kurulan ekipman markalari, yurt icinde yaygin kullanilan ekipmanlarin %90'ini kapsar; 107554 isletme bizimle birlikte ilerliyor."
      },
    footer: {
      contact: {
        title: 'Bize Ulasin',
        adrres: 'Adres: Jiangsu Eyaleti, Wuxi Sehri, Binhu Bolgesi, Xiuxi No.50',
        subAdrres: "K-park Hizmet Merkezi, 1 No'lu Bina, 16. Kat",
        tell: 'Telefon'
        },
      business: {
        title: 'Xingeer Temel Is Alanlari',
        department1: 'Kapi ve Pencere Yazilim Departmani',
        department2: 'Mobilya Yazilim Departmani',
        department3: 'Prefabrik Yapi Departmani',
        department4: 'Xingeer Resmi Merkez Web Sitesi'
        },
      brand: {
        title: 'Xingeer Markalari',
        brand1: 'Cai Shen Jin Fu',
        brand2: 'Mentu.com',
        brand3: 'Ding Xin Yatirim',
        brand4: 'San Zhang Tu Teknoloji',
        brand5: 'Shanghai Fen Mo Teknoloji'
        },
      organization: {
        title: 'Xingeer Global Subeleri',
        organization1: 'Xingeer - Guney Cin Bolgesi (Foshan Subesi)',
        organization2: 'Xingeer - Kuzey Bolgesi (Linyi Subesi)',
        organization3: 'Xingeer - Guneybati Bolgesi (Chengdu Subesi)',
        organization4: 'Xingeer - GG Bati Hizmet Merkezi',
        organization5: 'Xingeer - GG Dogu Hizmet Merkezi',
        organization6: 'Xingeer - Temsilci Kumesi',
        organization7: 'Xingeer - Uluslararasi Pazar Departmani'
        },
      follow: {
        title: "\"GG'yi Takip Et\" icin Tara"
        },
      friendLink: {
        link1: 'Xingeer Yazilim',
        link2: 'K Show Satin Alma Yazilimi',
        link3: 'Mentu.com',
        link4: 'Tum Aluminyum Dolap Yazilimi',
        link5: 'ZOL Yazilim Indirme',
        link6: 'Hua Jun Yazilim Parki',
        link7: 'Indirme Ana Sayfasi',
        link8: 'ZOL Yazilim Indirme',
        link9: 'Yesil Kaynak Agi',
        link10: 'Gardrop Bayiligi',
        link11: 'Ev Mobilyasi Bayiligi',
        link12: 'American Standard Banyo Bayiligi'
        }
      }
    },
  login: {
    title: 'Giris',
    tell: 'Telefon Numarasi',
    password: 'Sifre',
    passwordPlaceholder: 'Lutfen sifrenizi girin',
    forget: 'Sifremi Unuttum',
    registerAccount: 'Hesap Kaydet',
    backLog: 'Girise Don',
    verifyCode: 'Dogrulama Kodu',
    getVerifyCode: 'Dogrulama Kodunu Al',
    verifyCodeErr: 'Dogrulama Kodu Hatali',
    confimPassword: 'Sifreyi Onayla',
    confimPasswordPlaceholder: 'Lutfen Sifrenizi Onaylayin',
    editPassword: 'Sifreyi Degistir',
    register: 'Kaydol',
    reSend: 'Tekrar Al',
    loginLoadText: 'Giris yapiliyor, lutfen bekleyin...',
    loadingPageTextL: 'Giris basarili, sayfa yapisi yukleniyor...',
    loginSuccess: 'Giris Basarili',
    tellErr: 'Telefon numarasi formati hatali',
    passwordErr: 'Lutfen sifreyi girin'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'Gorev Al',
      arrange: 'Dizgi',
      surplus: 'Artik Malzeme',
      setting: 'Ayarlar',
      find: 'Kesfet',
      upgrade: 'Simdi Yukselt',
      editNickName: 'Takma Adi Duzenle',
      editPassword: 'Sifreyi Degistir',
      logout: 'Cikis Yap',
      notice: 'Duyuru',
      enterOfficial: 'Resmi Siteye Git',
      equipment: 'Ekipman',
      help: 'Yardim',
      importFunc: 'Ozel Ozellikleri Goster',
      enterThinkerOfficial: 'Xingeer Resmi Sitesine Gir',
      history: 'Gecmisi Kaydet',
      plankManager: 'Stok Yonetimi',
      tagManager: 'Etiket Yonetimi',
      suplumentManager: 'Ek Parca ve Bekleyen Dizgi Kutuphanesi',
      fileManager: 'Dosya Yonetimi',
      productionLine: 'Ekipman Entegrasyonu',
      workeShop: 'Bulut Uretimi',
      useLesson: 'Kullanim Egitimi',
      videoLesson: 'Video Egitimi',
      prolineManager: 'Uretim Hatti Yonetimi',
      materialManager: 'Parca Yonetimi',
      productManual: 'Urun Kilavuzu',
      medialRelated: 'Kademeli Yayin'
      },
    sideBar: {
      title: 'Uretim Optimizasyonu',
      materialList: 'Kesim Listesi',
      paibanTask: 'Dizgi Görev',
      paibanResult: 'Dizgi Plani',
      printTag: 'Etiket Yazdir',
      history: 'Gecmisi Kaydet',
      limitDate: 'Limited Free',
      surplusManager: 'Artik Malzeme Yonetimi',
      translateManager: 'Ceviri Yonetimi',
      moreSettings: 'Daha Fazla Ayar',
      deepSeekTitle: 'Danisman',
      paibanCommune: 'Dizgi Tartisma Grubu'
      },
    allRead: 'Hepsi Okundu',
    learnMore: 'Daha Fazla Bilgi',
    noticeEmpty: 'Henuz duyuru yok....',
    noticeErr: 'Ayrintili duyuru icerigi alinirken hata',
    feedBack: {
      tab1: 'Geri Bildirim Gonder',
      tab2: 'Geri Bildirim Kaydi',
      type: 'Geri Bildirim Turu',
      typePlaceholder: 'Lutfen bir ozellik secin',
      description: 'Aciklama',
      descriptionPlaceholder: 'Merhaba~ Lutfen en az 15 kelimelik ayrintili kullanim senaryosu aciklamasi girin, boylece size daha iyi yardim edebiliriz. Is birliginiz icin tesekkur ederiz!',
      uploadPic: "Resim ekle (en fazla 6 resim, her biri 10 MB'i gecmemelidir)",
      tell: 'Iletisim Numarasi',
      submit: 'Gonder',
      admin: 'Bulut Dizgi Yoneticisi:',
      picTip: 'Resim: (ayrintilari gormek icin tiklayin)',
      empty: 'Geri bildirim verisi yok',
      picErr: "Her resim 10 MB'i gecmemelidir",
      contentErr: 'Karakter sayisi 15 ile 300 arasinda olmalidir',
      necessary: 'Bu alan zorunludur'
      }
    },
  taskPage: {
    tab1: 'Uretim Gorevi',
    tab2: 'Toplu Uretim Kuyrugu',
    filter: {
      title: 'Filtrele',
      unArrange: 'Henuz Dizilmedi',
      arranged: 'Dizildi',
      allArranged: 'Hepsi Dizildi',
      preLayout: 'On Dizgi'
      },
    search: {
      placeholder: 'Lutfen arama icerigini girin',
      orderName: 'Siparis Adi',
      sender: 'Gonderen'
      },
    importTask: 'Gorevi Ice Aktar',
    refuseTask: 'Gorevi Reddet',
    refreshList: 'Listeyi Yenile',
    refuseRecord: 'Ret Kaydi',
    taskCard: {
      sender: 'Ice Aktarilan Malzeme Listesi',
      delivery: 'Teslim Tarihi',
      delete: 'Sil',
      addToBatch: 'Partiye Ekle',
      save: 'Arsivle',
      arrange: 'Dogrudan Diz',
      deleteTitle: 'Gorevi Sil',
      checkDetail: 'Ayrintilari Gormek Icin Tiklayin',
      refuse: 'Reddet',
      refuseTime: 'Ret Zamani',
      refuseReason: 'Ret Nedeni',
      refuseTask: 'Gorevi Reddet',
      refuseTaskPlaceholder: 'Lutfen ret nedenini girin',
      addErr: 'Ekleme basarisiz oldu, lutfen daha sonra tekrar deneyin!'
      },
    batchNo: 'Parti Numarasi',
    batchArrange: 'Toplu Dizgi',
    clearBatch: 'Kuyrugu Temizle',
    taskCount: 'Mevcut Gorev Sayisi:',
    checkAllTask: 'Tum Malzeme Listelerini Goster',
    clearSuccess: 'Temizleme Basarili',
    record: {
      batchNo: 'Parti',
      saveDate: 'Kaydetme Zamani',
      materialList: 'Malzeme Listesi',
      arrangedRecord: 'Dizgi Plani',
      searchPlaceholder: 'Lutfen parti numarasini girin',
      tipText: 'Bu arsivi silmek istiyor musunuz?'
      },
    errTip: 'Islenebilir gorev verisi yok, lutfen gorev listesine gidip ekleyin!',
    emptyErr: 'Bu gorev siparisinde panel verisi yok, dizgi uretimi yapilamaz!',
    operationSuccess: 'Islem Basarili',
    operationFail: 'Islem Basarisiz oldu, lutfen daha sonra tekrar deneyin!',
    saveSuccess: 'Arsivleme Basarili',
    plankMaxLimit: 'Kucuk panel sayisi maksimum dizgi limitini asti',
    batchWorning: 'Lutfen partiler halinde uretim yapin',
    batchEmptyErr: 'Siparis listesinde panel verisi yok, toplu uretim yapilamaz!',
    noRoomTip: 'Oda bulunmuyor, toplu uretim yapilamaz!',
    refuseHistory: 'Ret Gecmisi'
    },
  materialPage: {
    specialProcess: 'Ozel Islem',
    distanceFromTop: 'Ustten Mesafe',
    distanceFromRight: 'Sagdan Mesafe',
    hingeData: 'Mentese Verisi',
    labelBackProcTip: 'Bu guncellemede buyuk panelin arka yuz etiketleme yontemi optimize edildi. Artik etiket bilgisini izleyerek dogrudan kenar bantlama, delik acma ve kanal cekme yapabilirsiniz. Bilginize!',
    openDir: 'Acilis Yonu',
    edgeEmptyTip: 'Kenar payi bos olamaz',
    edgeNumberLimit: 'Kenar payina sadece sayi girilebilir',
    chooseSurplusQuantity: 'Kullanilabilir artik malzeme toplam {total} tur, secilen {quantity} tur',
    noCanSaveInfo: 'Kaydedilebilecek bilgi yok',
    chooseBujianStoreQuantity: 'Toplam {total} tamamlayici parca var, birlikte eklenebilecek tamamlayici panel {quantity} adet, secilen {chooseQuantity} adet',
    isConfirmPushToAwaitStore: 'Secilen panelleri bekleyen dizgi kutuphanesine eklemek istediginizi onayliyor musunuz?',
    enterAutoCreateMatCode: "Enter'a basildiginda malzeme otomatik olusturulur",
    chooseAwaitStoreQuantity: 'Bekleyen dizgi kutuphanesinde toplam {total} kucuk panel var, birlikte dizilebilecek panel {quantity} adet, secilen {chooseQuantity} adet',
    defaultFold: 'Panel Verileri Varsayilan Olarak Katli',
    startArrange: 'Dizgiyi Baslat',
    importMaterial: 'Kesim Listesini Ice Aktar',
    saveToHistory: 'Gecmise Kaydet',
    addPlank: 'Panel Ekle',
    addBujian: 'Tamamlayici Parca Ekle',
    deletePlank: 'Panel Sil',
    batchEdit: 'Toplu Duzenle',
    moreSetting: 'Daha Fazla Ayar',
    plankSize: 'Panel Boyutu',
    plankSize2: 'Boyut (Uzunluk*Genislik*Kalınlık)',
    searchPlaceholder: 'Panel adi/panel numarasi ara',
    checkArranged: 'Dizgiyi Gor',
    checkErr: 'Dizgi yapilmadi, goruntulenemiyor!',
    downloadSheet: 'Ornek Tabloyu Indir',
    downloadSheetShowScientific: 'Ornek Tabloyu Indir (Bilimsel Gosterimle)',
    exportHoleSlotPDF: 'Panel Delik ve Kanal Cizimini Disa Aktar',
    style1: 'Stil 1',
    style2: 'Stil 2',
    style2PDF: 'Stil 2 (PDF)',
    style2DXF: 'Stil 2 (DXF)',
    style3: 'Stil 3',
    importNoCover: 'Malzeme Listesi Ice Aktarma Uzerine Yazmaz',
    openBujianPlankRecommend: 'Tamamlayici Kucuk Panel Onerisini Ac',
    openAwaitStorePlankRecommend: 'Bekleyen Dizgi Kutuphanesi Kucuk Panel Onerisini Ac',
    openSurplusPlankRecommend: 'Artik Buyuk Panel Onerisini Ac',
    pushToAwaitStore: 'Bekleyen Dizgi Kutuphanesine Kaydet',
    setTableHead: 'Kesim Listesi Basligini Ayarla',
    syncConfirm: 'Dolap sistemi ile bulut dizgi orijinal panel verileri tutarsiz! Dolap sisteminin orijinal panel verileriyle senkronize etmek ister misiniz?',
    handleSync: 'Not: Orijinal panel yonetiminde manuel senkronizasyon yapilabilir',
    noMoreTip: 'Bir Daha Hatirlatma',
    checkMore: 'Daha Fazlasini Goster',
    noHistory: 'Kayitli Gecmis Yok...',
    sameOrder: 'Uretim dosyasi disa aktarilmis siparisler var, lutfen tekrarli uretim sorununa dikkat edin!',
    markOrder: 'Siparis sayfasinda uretildi olarak isaretlemek istiyor musunuz?',
    editErrTip: 'Coklu siparisler icin bilgi duzenleme simdilik desteklenmiyor',
    autoSaveSuccess: 'Gecmise otomatik kaydedildi!',
    goAdd: 'Eklemeye Git',
    noProductionLine: 'Bu kaydin uretim hatti silinmis, lutfen kesim listesine gidip yeniden dizin',
    fileErr: 'Dosya icerigi ayrıştırilamadi, lutfen dosya icerigini kontrol edin!',
    noCheckData: 'Veri bulunamadi!',
    noArrangeTip: "Dizgi plani dogrudan goruntulenemez, lutfen Dizgiyi Baslat'a tiklayin!",
    tooOld: 'Bes/Alti yuz matkap ayari cok eski',
    contactUs: 'Lutfen tekrar baglanti icin satis sonrasi ekiple iletisime gecin',
    pathErr: 'Panel icinde anormal veri var (Panel Numarasi: {errorPathPlankID}), lutfen kontrol edin!',
    sizeErr: 'Asiri buyuk panel mevcut! Kucuk panel boyutu: {width}-{height}',
    noKnife: 'Kesim bicagi capi ayarlanmamis, lutfen oyma makinesinde bicagi ayarlayin!',
    noKnifeDiameter: 'Bu uretim hattindaki kesim bicaginin ({name}) capi bos, lutfen ilgili bicak capini ekleyin',
    openDifferentMaterialCuttingKnives: 'Farkli malzeme kesim bicaklari etkinlestirildi',
    sendFactorySuccess: 'Atolyeye gonderme basarili',
    sendFactoryErr: 'Atolyeye gonderme basarisiz oldu, lutfen yardim icin satis sonrasi ekiple iletisime gecin',
    createTaskCard: 'Ilgili gorev kartini olusturmak istiyor musunuz?',
    surplusStatistics: 'Kullanilabilir Artik Malzeme Toplami',
    surplusStatistics2: 'Secildi',
    suplementStatistic: 'tamamlayici parca, birlikte kullanilabilecek tamamlayici panel toplami',
    expand: 'Genislet',
    packUp: 'Daralt',
    importErr: 'Lutfen dogru dosyayi secin!',
    sendLoadingText: 'NC dosyalari isleniyor ve gonderiliyor......',
    arrangeLoading: 'Toplam',
    arrangeLoading2: 'adet kucuk panel dizgi icin optimize ediliyor......',
    dealing: 'Isleniyor...',
    deleteConfirm: 'Silindikten sonra kalan malzeme Geri Dönüşüm Kutusuna taşınacaktır. Bu malzemeyi silmek istediğinize emin misiniz?',
    copyTip: 'Secilen artik malzeme kopyalanmak uzere',
    copyTip2: 'Lutfen kopyalanacak miktari onaylayin',
    surplusHead: {
      shape: 'Sekil',
      type: 'Tur',
      remark: 'Not',
      area: 'Alan(m²)',
      area1: 'Alan'
      },
    surplusTip: 'Su anda kullanilabilir artik malzeme yok, once sunaya gidebilirsiniz',
    creatSurplus: 'Yeni Artik Malzeme Olustur',
    orderInfo: 'Siparis Bilgisi',
    suplement: {
      statistic: 'Toplam {total} tamamlayici parca var, {useable} tamamlayici panel birlikte kullanilabilir, {selected} secildi',
      exportSuplement: 'Tamamlayici Parca Listesini Disa Aktar',
      suplementLoading: 'Tamamlayici Parca Verileri Yukleniyor',
      exportSuplementIng: 'Tamamlayici Parca Listesi Disa Aktariliyor',
      noMatchSup: 'Kullanilabilir eslesen tamamlayici veri bulunamadi',
      exportTip: 'Lutfen disa aktarmadan once en az bir tamamlayici parca secin'
      },
    empty: 'Panel Verisi Yok',
    paibanSetting: {
      title: 'Dizgi Ayarlari',
      createTask: 'Dizgi Görev Oluştur',
      selectProduction: 'Uretim Hatti Secimi',
      arrangeWay: 'Dizgi Plani Secimi',
      suitText: 'Icin Uygun：',
      surplusTrimTip: 'Not: Artik malzeme icin ozel kirpma ozelligini kullandiniz, yalnizca testere kesim dizgisi secilebilir',
      suitEquipmentNormal: 'Standart Oyma Makinesi',
      suitEquipmentSpecial: 'Cam Kesim Makinesi, Testere Kesim Makinesi',
      lessRoll: 'Daha Az Cevirme',
      computedSpecial: 'Ozel Sekilleri Hesapla',
      specialTip: 'Dizgi Hizini Etkiler',
      irregularNesting: 'Duzensiz Ic Ice Dizilim',
      primaryNesting: 'Normal Ic Ice Dizilim',
      specialShapedPanel: 'Ozel Sekilli Paneli Normal Panele Gom',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'Gelismis Ic Ice Dizilim',
      heteromorphicInlay: 'Ozel Sekilli Ic Ice Gomulu',
      autoCutSurplus: 'Artik Malzemeyi Otomatik Kes',
      cutWay: 'Kesim Yontemi',
      maxRect: 'Maksimum Dikdortgene Kes',
      fixedRect: 'Sabit Boyuta Kes',
      minRectSetting: 'Minimum Kesim Boyutu',
      firstCutL: 'Oncelikle L Sekilli Artik Olustur',
      firstCutLTip: 'Acildiginda, kosullari saglayan dikdortgen paneller once L seklinde artik malzemeye kesilir',
      shortLine: 'Kisa Kenar Buyuklugu',
      longLine: 'Uzun Kenar Buyuklugu',
      setDifferentThickness: 'Farkli Kalinliktaki Paneller Icin Minimum Kesim Boyutu Ayarla',
      defaultRuleTip: 'Panel kalinligi kurala uymadiginda varsayilan kurala gore kesin',
      panelThickness: 'Buyuk Panel Kalinligi',
      duplicateMinCutSize: 'Bu kalinlik icin ayni minimum kesim boyutu zaten mevcut',
      templateEmpty: '"Farkli kalinliktaki paneller icin minimum kesim boyutu ayarla" sablon verisi bos olamaz!',
      duplicateThicknessData: '"Farkli kalinliktaki paneller icin minimum kesim boyutu ayarla" sablonunda yinelenen kalinlik verisi var!',
      atLeastOne: 'En Az Bir Tane Birakilmali!',
      maxAddFive: 'En Fazla Bes Tane Eklenebilir!',
      surplusTemplate: 'Artik Malzeme Ortak Sablonu',
      add: 'Ekle',
      templateErr: 'Ortak boyuta kesmeyi secmek icin en az bir veri sablonu secilmelidir',
      cutLong: 'Kesim Uzunlugu',
      cutWidth: 'Kesim Genisligi',
      baseInfo: 'Temel Bilgiler',
      continue: 'Onayla ve Devam Et',
      standardSelect: 'Standart Buyuk Panel Secimi',
      customPlankOrder: 'Buyuk Panel Dizgi Sirasini Ozellestir',
      customPlankOrderDetail: 'Dizilmemis Kucuk Panel Listesi',
      customPlankOrderTip: 'Gomulu bulut dizgisi bu ozellikte gecerli degildir',
      customPlankOrderBrandTip: 'Dizgi bekleyen siparislerde marka renk karti panelleri var, bu ozellik varsayilan olarak kullanilir',
      surplusPlank: 'Kalan Kucuk Panel Listesi',
      overSizePlank: 'Asiri Buyuk Panel Listesi',
      plankOrder: 'Dizgi Sirasi',
      plankType: 'Panel Turu',
      plankSize: 'Panel Boyutu',
      plankEdgeOff: 'Kenar Kirpma Degeri',
      amount: 'Kesim Miktari',
      amountMax: 'Maksimum Kesim Miktari',
      numAndOverSizeTip: 'Asiri buyuk kucuk paneller var ve buyuk panel miktari yetersiz, dizgi yapilamaz',
      numErrorTip: 'Buyuk panel miktari yetersiz, dizgi yapilamaz',
      overSizeTip: 'Asiri buyuk kucuk panel mevcut, dizgi yapilamaz',
      restPartList: 'Dizilmemis Kucuk Panel Listesi',
      layoutOrder: 'Dizgi Sirasi',
      arrangeAmount: 'Kesim Miktari',
      specialShapeTip: 'Ozel sekilli artik malzeme testere kesim dizgisinde kullanilamaz',
      surplusConflictTip: 'Artik malzeme kesimi panel konturu ile cakışiyor, lutfen yeniden kesin',
      stackingMethod: {
        title: 'Yığma Yöntemi',
        long: 'Uzun kenarına göre yığınla',
        short: 'Kısa kenarına göre yığınla'
        },
      seniorShapeTip: '【Gelişmiş İç İçe Yerleşim】Ücretsiz deneme süresi doldu, gelişmiş iç içe yerleşim sonucunu önizleyebilirsiniz (normal üretim için normal iç içe yerleşime de geçebilirsiniz); gelişmiş iç içe yerleşim üretim dosyasını dışa aktarmanız gerekiyorsa, satın almak için satış ekibiyle iletişime geçin~'
      },
    filter: {
      title: 'Panel Filtreleme',
      search: 'Ara',
      all: 'Tumunu Sec',
      diskSize: 'Filtreyi Iptal Et',
      resetFilter: 'Filtreyi Iptal Et'
      },
    edit: {
      title: 'Toplu Duzenleme',
      target: 'Duzenlenecek Nesne',
      onlineSelectRow: 'Yalnizca Secili Satirlar',
      allRow: 'Tum Satirlar',
      editKey: 'Duzenlenecek Icerik',
      editValue: 'Sununla Degistir',
      warningTip: 'Dikkat: Degisiklikten sonra delik, kanal ve ozel sekiller otomatik olarak temizlenecektir',
      allEdge: 'Tum Kenarlari Bantla'
      },
    add: {
      title: 'Panel Ekle',
      continue: 'Onayla ve Devam Et',
      matCodeErr: 'Malzeme bos olamaz',
      thickErr: 'Kalinlik bos olamaz',
      colorErr: 'Renk bos olamaz',
      longErr: 'Bitmis urun uzunlugu bos olamaz',
      widthErr: 'Bitmis urun genisligi bos olamaz',
      countErr: 'Miktar en az 1 olmali'
      },
    delete: {
      tip: 'Bu veri silindikten sonra geri yuklenemez, silmeyi onayliyor musunuz?',
      errTip: 'Lutfen once bu islemi yapmadan en az bir panel secin!',
      errTip1: 'Lutfen dizgiden once en az bir panel secin',
      confirm: 'Silmeyi Onayla'
      },
    restore: {
      confirm: 'Geri yüklemeyi onayla'
      },
    restoreConfirm: 'Geri yüklendikten sonra kalan malzeme, artık listesine veya stokuna geri taşınacaktır. Bu malzemeyi geri yüklemek istediğinize emin misiniz?',
    restoreBatchConfirm: 'Seçilen kalan malzemeleri geri yüklemek istediğinize emin misiniz?',
    save: {
      errTip: 'Kaydedilecek bilgi yok!',
      title: 'Şemayı Kaydet',
      subTitle: '(Dikkat: Geçmiş yalnızca bir yıl saklanır)',
      name: 'Şema Adı',
      historyName: 'Tarihsel şema',
      successTip: 'Başarıyla kaydedildi!',
      fieldTip: 'Kaydetme başarısız!'
      },
    exportErr: 'Şu anda dışa aktarılacak pano yok',
    exportPicErr: 'Pano delik yuvası diyagramı dışa aktarılırken bilinmeyen bir hata oluştu. Lütfen çözüm için bizimle iletişime geçin',
    plankNotFound: 'İlgili pano bulunamadı! Lütfen panoyu çizip çizmediğinizi onaylayın!',
    noPlankName: 'Pano adı bulunamadı',
    plankDataErr: 'Pano verileri hatalı. Üretim kayıplarını önlemek için lütfen dikkatlice kontrol edin',
    exportThreeViewErr: 'Delik yuvası üç görünüm dışa aktarma başarısız oldu. Lütfen satış sonrası hizmetle iletişime geçin',
    heighGlossWarning: 'Dikkat: Malzeme parlak yüzeyli plaka olduğunda, malzemeyi değiştirdikten sonra pano parlak yüzeyli plakaya geri yüklenemez!',
    reset: 'Varsayılanı geri yükle',
    settingHead: {
      title: 'Kesim listesi başlığını ayarla',
      head: 'Başlık',
      customHeadName: 'Özel başlık adı',
      example: 'Örnek',
      tip: 'İşlem ipucu: Başlık veri etiketini konumunu değiştirmek için sola veya sağa sürükleyebilirsiniz',
      headerNameEmpty: 'Başlık boş olamaz',
      duplicateHeader: 'Yinelenen başlık'
      },
    copyLine: 'Mevcut satırı aşağıya kopyalamak için tıklayın',
    copySuccess: '{name} verisi kopyalama başarılı',
    arranging: 'Toplam {count} küçük pano yerleşim için optimize ediliyor......',
    overSize: {
      title: 'Pano boyutu aşımı',
      subTitle: 'Büyük boyutlu pano listesi',
      overSizeTip: 'Pano boyutu aşımı uyarısı',
      nonWorkInfo: 'İşlenemeyen pano detayları',
      mergeFrameDoorWholeTip: 'Not: Bu parça birleştirilmiş çerçeve kapının tamamıdır',
      conflictWorkInfo: 'Çakışan panoların detayları',
      warning: 'Küçük pano boyutunun çok uzun olduğu tespit edildi, yerleşim yapılamıyor! Lütfen küçük pano boyutunu ayarlayın veya uygun boyutta orijinal levha ekleyin',
      checkInfo: 'Pano detaylarını görüntüle',
      tipContent: 'Sistem yerleşim şablonunda büyük boyutlu panolar tespit etti. Özel panolar ekleme önerileri aşağıdadır. Panoların uzunluk ve genişliğini manuel olarak değiştirip tablonun altındaki Tek Tıkla Ekle düğmesine tıklayabilir veya Orijinal Levha Ayarları - Özel Panolar bölümünden manuel ekleyebilirsiniz',
      add: 'Tek tıkla ekle',
      addPlank: 'Orijinal levha ekle',
      error: 'Pano boyutu aşımı, yerleşim başarısız',
      successTip: 'Pano başarıyla eklendi! Yeniden yerleştiriliyor',
      warningTip: 'Lütfen panonun uzunluk ve genişliğini doldurun!'
      },
    arrangeErr: 'Pano iç verilerinde anormallikler var, yerleşim üretimi yapılamıyor',
    nonDelete: 'Silinemez',
    addOverSizeTip: 'Boyut aşımı mevcut, lütfen tekrar ekleyin',
    addPlankSuccess: 'Özel büyük pano başarıyla eklendi',
    addPlankFail: 'Özel büyük pano ekleme başarısız',
    paibanFeedback: 'Yerleşim geri bildirimi',
    cuttingAndPaoban: 'Kesim ve yerleşim',
    lowUtilizationRate: 'Düşük kullanım oranı',
    unreasonableLayout: 'Mantıksız yerleşim',
    feedbackSuccessTip: 'Geri bildirim başarılı!',
    feedbackFailTip: 'Geri bildirim başarısız!',
    mixedLayoutScheme: 'Bu karışık yerleşim şeması'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'Pano verileri değişti ancak plan kaydedilmedi. Sonraki işlemlere devam etmeden önce lütfen planı kaydetmek için Tamam butonuna tıklayın',
    paibanRequestFailed: 'Dizilim isteği başarısız oldu, lütfen tekrar deneyin',
    accordingPlankCountOrder: 'Büyük pano sayısına göre yüksekten düşüğe sırala',
    editOrder: 'Sıra numarasını düzenle',
    dragOrder: 'Sıralamak için sürükle',
    inputOrder: 'Giriş sırası',
    editOrderTip: 'Sırayı ayarla',
    range: 'Aralık',
    unsupportRotateTip: 'Bazı büyük panolar döndürülmüş, yeniden yerleşim şu anda desteklenmiyor. Döndürülmüş büyük pano numaraları:',
    slotErrTip: 'Mevcut panelde kenar işleme olukları var, yeniden yerleşim desteklenmiyor!',
    lockedPaibanTip: 'Büyük pano kilitli, yeniden yerleştirilemez',
    batchBujianErrTip: 'Mevcut parça orijinal malzeme listesi verisinde yok, yeniden yerleşim için tamamlama/bekleyen yerleşim kütüphanesinden seçebilirsiniz',
    useFolderIsNot: 'Dosya indirme kayıt konumunuz "{type}" mevcut değil! Lütfen klasörün silinip silinmediğini kontrol edin. USB sürücü kullanıyorsanız bağlantıyı kontrol edin',
    useFolderIsNot1: 'Dosya indirme konumu ayarlanmadığı tespit edildi, lütfen önce bir dizin seçin',
    downloadNC: 'NC indir',
    downloadNC1: 'NC dosyası indir',
    reArrange: 'Yeniden yerleştir',
    reArrangeSpecifiedMaterialGroup: 'Belirtilen panel gruplarını yeniden düzenle',
    specifiedMaterialRelayoutMoreResultTip: 'Belirtilen panel grupları yeniden düzenlendikten sonra daha fazla yerleşim sonucu sunulmayacaktır',
    searchMaterialGroup: 'Panel gruplarını ara',
    saveToHistory: 'Geçmişe kaydet',
    moreSetting: 'Daha fazla',
    cutIndexRe: 'ctrl+z tuşunu kullanarak önceki işlemi geri alın',
    followExportTag: 'NC indirirken etiket dosyası dışa aktar',
    followExportPaibanImg: 'NC indirirken yerleşim çizim dosyasını dışa aktar',
    followExportWorkerShop: 'NC indirirken satın alma siparişini dışa aktar',
    tagTemplateSelect: 'Etiket şablonu seçimi',
    showCuttingSequence: 'Kesim sırasını göster',
    showPlankSize: 'Küçük pano boyutunu göster',
    sendToFactory: {
      title: 'Üretim için atölyeye gönder',
      fileType: 'Etiket dosya türü'
      },
    checkData: 'Veri bütünlüğü kontrol ediliyor...',
    dataLoading: 'Yükleniyor...',
    addToBujianStore: 'Yedek parça deposuna ekleniyor...',
    updateTaskStatus: 'Görev durumu güncelleniyor...',
    sending: 'Atölyeye gönderiliyor...',
    waitLoadding: 'Bekleniyor',
    loadding: 'Yükleniyor',
    finish: 'Tamamlandı',
    loadSetting: 'Ayarları yükle',
    loadPreference: 'Tercihleri yükle',
    dealTemplate: 'Şablonu işle',
    initTagData: 'Etiket verisini başlat',
    prepareDrawData: 'Etiket çizim verisini hazırla',
    drawDataText: 'Etiket çizim verisi',
    genPdfTagFile: 'PDF etiket dosyası oluştur',
    genPicTagFile: 'Etiket resim dosyası oluştur',
    uploadFile: 'Dosya yükle',
    dealNCFile: 'NC dosyasını işle',
    zipFile: 'Yerel zip dosyası oluştur',
    plankCount: 'Büyük levha sayısı',
    rollCount: 'Tekrar baskı sayısı',
    totalRate: 'Genel optimizasyon oranı',
    rate: 'Optimizasyon oranı',
    useArea: 'Optimize edilmiş alan',
    materialList: 'Malzeme listesi',
    saveSurplus: 'Artık malzemeyi depoya al',
    workeShop: 'Satın alma siparişi',
    batchTagging: 'Toplu etiket tamamlama',
    batchTaggingTip: 'Aşağıdan ek etiket gerektiren levhaları seçin',
    holeSlotErr: 'Parçada anormal delik/oluk derinliği tespit edildi!',
    knivesErr: 'Parça algılandığında işleme takımı bulunamıyor!',
    checkDetail: 'Ayrıntıları görüntüle',
    deepErr: {
      title: 'Levha delik/oluk derinliği anormalliği',
      errStatistic: 'Alt levhada {count} anomali',
      errText: 'Anormal bölüm',
      markErrPart: 'Anormal bölümü çerçevele'
      },
    warningTip: 'Çift yüz yüksek parlak levhalar: Önce <span class="font-style">parlak yüzü</span> işleyin, ardından <span class="font-style">mat yüzü</span>; Tek yüz yüksek parlak levhalar: Doğrudan <span class="font-style">mat yüzü</span> işleyin.',
    showDetail: {
      tip1: 'Tek tıklamayla tek levha seçin',
      tip2: 'Levha etiketini görüntüle'
      },
    arrangeTip: '(Düzensiz iç içe yerleşimi desteklenir)',
    plankOpration: 'Levha işlemleri',
    rotate: '90° döndür',
    notCare: 'Levhada doku yok',
    editRemark: 'Notu düzenle',
    clearRemark: 'Notu temizle',
    recalcIndex: 'Kesim başlangıcı ve sırasını yeniden hesapla',
    recalcIndexSuccess: 'Kesim başlangıcı ve sırası yeniden hesaplandı',
    storageArea: {
      title: 'Levha geçici alanı',
      empty: 'Geçici levha yok',
      storageTip: 'Levhaları geçici depolamak için buraya sürükleyin'
      },
    subtleArrange: 'İnce yerleşim',
    addPlank: 'Büyük levha ekle',
    deletePlank: 'Büyük levha sil',
    deletePlankErr: 'Bu büyük levhada küçük levha var; büyük levha silinemez!',
    useSurplus: {
      title: 'Artık malzemeyi kullan'
      },
    dragWarning: 'Lütfen levhayı büyük levhaya sürükleyin!',
    areaWarning: 'Levha yerleştirilemiyor; boş alan boyutuna dikkat edin',
    subtlePage: {
      cut: 'Artık malzeme kesimi',
      lineTip: 'Artık malzeme kesimi',
      cancelCut: 'Kesimi bitir',
      cutPoint: 'Artık kesim yapışma noktası',
      storageArea: 'Levha yerleşim bekleme alanı',
      cutErr: 'Kesim yalnızca büyük levhada yapılabilir; küçük levhaya dokunmayın!',
      saveErr: 'Önce kesilecek bir artık malzeme seçin',
      cutErr2: 'Kesim yalnızca büyük levhada yapılabilir; büyük levhayı aşmayın!',
      selectTip: 'Kesim için bir artık levha parçası seçin',
      noCutPath: 'Özel şekilli bölümler dikdörtgen kesilemez',
      cutOperate: 'Artık malzeme kesim işlemi',
      line: 'Manuel kontur',
      cutErrtip: 'Kesim noktalarında kesişim var; yeniden kesin',
      cutErrtip2: 'Kesim noktası sınırı aşacak: 9; yeniden kesin'
      },
    shortCut: 'Kısayollar',
    updownRoll: 'Yukarı-aşağı kaydır',
    leftRightRoll: 'Sol-sağ kaydır',
    zoomScale: 'Yakınlaştır-uzaklaştır',
    dragCanvas: 'Sayfayı sürükleyin',
    mouseRoll: 'Fare tekerleği',
    mouseRight: 'Sağ tık',
    mouseMultiSelect: 'Birden fazla levhayı seçin',
    mouseLeft: 'Sol tık',
    doublePlank: 'Büyük levhaya çift tıklayın',
    keyboard: 'Klavye',
    picSymble: 'Lejant',
    funished: 'Tamamlanmış ürün',
    holeSlotConflict1: 'Delik-oluk çakışması',
    plankErr: 'Levha çakışması',
    frontSlot: 'Ön yüz oluk',
    backSlot: 'Arka yüz oluk',
    frontHole: 'Ön yüz delik',
    backHole: 'Arka yüz delik',
    resetScale: 'Yakınlaştırmayı sıfırla',
    maxLong: 'Maksimum uzunluk',
    tempErr: 'Ekleme başarısız; şablon konumu hatalı veya şablon çok büyük!',
    sendErr: 'Atölyeye gönderilemedi; etiket şablonu ve levha verilerini kontrol edip yeniden gönderin',
    someTips: 'Bulut yerleşim düzensiz artık/iç içe yerleşim deniyorsunuz; üretim risklerinden kaçının!',
    nestingTips: '[Gelişmiş Düzensiz İç İçe Yerleşim] özelliği için sınırlı süreli ücretsiz deneme süresi doldu. Kullanmaya devam etmek için satış ekibiyle iletişime geçip satın alın!',
    frameDoorTip: 'Kafes kapısı işleme sırasında uyarı göster',
    cutOrderErr: 'Kesim sırası yanlış; kesim noktası ve sırasını yeniden hesaplamak için tıklayın!',
    holeSlotConflict: 'Delik-oluk çakışması veya küçük levha fırlaması algılandı',
    exportSetting: 'Dışa aktarma ayarları',
    currentTagTemp: 'Geçerli etiket şablonu',
    specialPaibanErr: 'Özel işlem veya kenar oluklu levhalar var; yeniden yerleşim şimdilik desteklenmiyor!',
    moreResult: 'Daha fazla sonuç',
    moreResultTip: 'Büyük levhada kenar işleme oluğu var; büyük levha yeniden yerleşime katılmaz',
    batchBujian: 'Toplu parça tamamlama',
    batchOperation: 'Toplu işlem',
    batchEditPlankSize: 'Büyük levha boyutunu toplu düzenle',
    editPlankSize: 'Boyutu düzenle',
    editWay: 'Düzenleme yöntemi',
    editByType: 'Türe göre düzenle',
    editByPlankNumber: 'Büyük levha numarasına göre düzenle',
    editContent: 'İçeriği düzenle',
    editContentTip: 'Düzenlenecek büyük levha türünü seçin',
    editContentTip1: 'Düzenlenecek büyük levha numarasını seçin',
    editStart: 'Başlangıç',
    editEnd: 'Bitiş',
    bigPlank: 'Büyük levha',
    editSize: 'Boyut şu şekilde değiştirildi',
    bigPlankWidth: 'Büyük levha genişliği',
    bigPlankHeight: 'Büyük levha uzunluğu',
    bigPlankLengthMarking: 'Büyük levha uzunluk işareti',
    markedAs: 'Şu şekilde işaretlendi',
    maxAddTen: 'En fazla 10 eklenebilir',
    minValue: 'Minimum değer',
    differentKnifeErr: 'Farklı kesim bıçaklarına sahip büyük levhalar seçili; boyut değiştirilemez',
    noEditablePlank: 'Değiştirilebilecek uygun büyük levha yok',
    skipBrandPlankTip: 'Seçili aralıkta boyut değişikliğini desteklemeyen {count} marka büyük levha var ve atlandı',
    nonBrandToBrandTip: 'Bu küçük levha markalı renk kartı büyük levhaya sürüklenemez!',
    brandToNonBrandTip: 'Bu küçük levha markasız renk kartı büyük levhaya sürüklenemez!',
    brandToOtherBrandTip: 'Bu küçük levha başka markalı renk kartı büyük levhaya sürüklenemez!',
    editNo: 'No.',
    editAllPlank: 'Tüm büyük levhalar',
    editBigPartSize: 'Büyük levha boyut düzenlemesi',
    disPlaySetting: 'Görüntü ayarı',
    stored: 'Depoda',
    onlySurplus: 'Yalnızca artık malzemeyi göster',
    UnuseSurplus: 'Artık malzeme kullanım oranına dahil edilmez',
    usePlankAdsorption: 'Levha yapışma özelliği',
    dataDefaultCollapsed: 'Veriler varsayılan olarak daraltılmış',
    unit: 'adet',
    cutSurplus: 'Artık malzemeyi kes',
    frontWarningTip: 'Çift yüz parlak levha: Önce <span class="font-style">mat yüzey</span>, sonra <span class="font-style">parlak yüzey</span>; Tek yüz parlak levha: Doğrudan <span class="font-style">parlak yüzey</span> işleyin.',
    selectTip: 'Aşağıdan ek parça gerektiren küçük levhaları seçin',
    plankKeyWordPlaceholder: 'Levha adı veya numarasını girin',
    surplusStoreSuccess: 'Depoya alma başarılı',
    editCutOrder: 'Kesim sırasını düzenle',
    setCutPoint: 'Bıçak iniş noktasını ayarla',
    specialPaibanChangeErr: 'Özel işlem veya kenar oluklu levhalar var; yerleşim şeması değiştirme şimdilik desteklenmiyor',
    storedSuccess: 'Ek parça başarılı! Seçilen levhalar ek parça yönetimine eklendi',
    noSurplus: 'Kullanılabilir artık bulunamadı',
    selectErrTip: 'Artık levhalar tamamlanamaz; önce normal küçük levha seçin',
    noRoomIDTip: 'Bu levhada oda ID yok; tamamlama depoya alınamaz, önce başka küçük levha seçin',
    noPlank: 'Levha bulunamadı',
    noPaibanData: 'Yerleşim verisi yok; işlem yapılamıyor',
    historyNameErr: 'Plan adını girin',
    tempErrTip: '5/6 yüz delik şablonu eklenmediği için işleme dosyası dışa aktarılamıyor. Not: ekledikten sonra yeniden yerleşim gerekir',
    changeDataTip: 'Verilerinizde değişiklik algılandı; bu değişiklikleri kaydetmek için yeni bir geçmiş dosyası oluşturulsun mu?',
    upgrade: 'Yükselt',
    upgradeTip: ', sürümü yükseltmek için aşağıdaki düğmeye tıklayabilirsiniz',
    plankOverEdge: 'NC indirilemedi! Levha çakışması veya levhanın büyük levha dışında olup olmadığını kontrol edin',
    useSurplusTip: 'Artık malzeme düşülsün mü?',
    noDataExport: 'Dışa aktarılacak yerleşim verisi yok',
    noPlankExport: 'Dışa aktarılacak küçük levha verisi yok',
    lockTip1: 'Kilidi açmak için tıklayın; açtıktan sonra',
    lockTip2: 'küçük levha konumunu ve özelliklerini düzenleyebilirsiniz',
    unlockTip1: 'Kilitlemek için tıklayın; kilitlendikten sonra',
    unlockTip2: 'küçük levha konumu ve özellik düzenlemesi yapılamaz',
    plankLockErr: 'Bu büyük levha kilitli; yerleştirilemez',
    lockPartEditTip: 'Levha kilitli; düzenlenemez',
    glassEquipmentTip: 'Üretim hattı cam kesim makinesi ise levha taşınamaz',
    expandedTip: 'Levhanın özel oluk işlemi var; düzenleme desteklenmiyor',
    sameWidthPlankTip: 'Aynı bıçak genişliği yerleşimi açık; levha taşınamaz',
    expandedArrangeTip: 'Özel oluk işlemi var; yeniden yerleşim gerekir',
    dragErrTip: 'Yerleştirilemez; levha malzeme, renk ve kalınlığını kontrol edin',
    subtleSaveTip: 'Levhada kaydedilmemiş değişiklik var; çıkmak istiyor musunuz?',
    rollTip: 'Büyük levhada tam delik/oluk var; ters çevirme önerilmez',
    glossRollErr: 'Parlak levhaların çevrilmesi yasaktır',
    lockDeleteErr: 'Levha kilitli; silinemez',
    deleteConfirmTip: 'Silme işlemi geri alınamaz',
    deleteContinueTip: 'Devam etmek istiyor musunuz?',
    deleteConfirm: 'Silmeyi onaylayın',
    selectPlankTip: 'Bu işlemden önce levha seçin',
    storeFailTip: 'Artık depoya alınamadı! Çakışma veya levhanın büyük levha dışında olup olmadığını kontrol edin',
    repeatStoreErr: 'Bu kesilen artık levha zaten depoya alınmış',
    surplusStoreFail: 'Depoya alınamadı; levhaların dikdörtgen veya L şeklinde olduğunu kontrol edin',
    plankConfilictErr: 'Bu konuma nokta konulamaz; diğer levhalarla çakışır',
    surplusErrTip: 'Bu konuma nokta konulamaz; hatalı artık oluşur',
    changeArrageSuccess: 'Yerleşim şeması başarıyla değiştirildi',
    trialProduction: {
      trialProductionSample: 'Deneme üretim örnek dolabı',
      trialProduced: 'Deneme üretim yaptım',
      trialWarning: '{fontStyleStart}Eğer{fontStyleEnd} örnek dolap üretim doğrulamasını yapmamanız nedeniyle kendiniz, başkaları ve bulut dizgi yazılımı üzerinde doğan tüm zarar ve olumsuz sonuçların sorumluluğu tamamen şahsen size aittir.',
      trialSlotTip: 'Deneme üretimde ön ve arka yüzdeki delik/oluk boyutunu, derinliğini, hangi yüzde ve konumunu dikkatlice kontrol edin',
      trialSlotTip1: 'dolap ayna görüntüsünü önleyin',
      trialSlotTip2: 'sorunu',
      pleaseUploadTrial: 'Monte edilmiş deneme üretim örnek dolabının fotoğrafını yükleyin',
      uploadTrial: 'Örnek dolabı yükle'
      },
    awaitPlankStore: {
      store: 'Levha sıra bekleme ambarı',
      notTip: 'Depoya alınmadı uyarısını bir daha gösterme',
      justLookCurrent: 'Yalnızca geçerli sipariş küçük levhaları',
      notInPushStorage: 'Depoda değil',
      beInStorage: 'Depoda',
      searchPlaceholder: 'Sipariş girerek sıra bekleme ambarında ara',
      plankUploading: 'Levha kaydediliyor',
      oneClickStorage: 'Tek tıkla sıra bekleme ambarına kaydet',
      notUsePlank: 'Kullanılabilir küçük levha yok',
      notPlank: 'Geçici levha yok',
      dragPlankInHere: 'Levhaları geçici saklamak için buraya sürükleyin',
      surplusCannotBeStorage: 'Artık malzeme depoya alınamaz',
      plankHasBeenDeduction: 'Küçük levha düşüldü veya kaynak veri yok; depoya alınamaz',
      plankLoadErr: 'Levha bilgisi yüklenemedi',
      taskTitle: 'Sıra bekleme ambarındaki levhaları yükle',
      dataGenErr: 'Veri üretim hatası',
      pushSuccess: 'Depoya alma başarılı',
      pushErr: 'Bilinmeyen hata; depoya alınamadı',
      awaitBoxExistPlank: 'Sıra bekleme ambarında depoya alınmamış küçük levhalar var; önce depoya almanız önerilir',
      mergeFrameDoorWholeTip: 'Bu parça birleşmiş çerçeve kapı bileşeni, depoya kaydedildikten sonra sistem otomatik olarak tek parçaya bölünür ve yönetilir',
      checkPlankStatus: 'Levha durumu doğrulanıyor...'
      },
    batchSetCut: 'Toplu bıçak iniş noktası ayarı',
    applyTo: 'Geçerlidir:',
    ncDownloadLifeText: {
      checkData: 'Veri kontrol ediliyor',
      checkDone: 'Veri kontrolü tamamlandı',
      checkDataText: 'Veri kontrolü',
      loadSetting: 'Ayarlar yükleniyor',
      settingLoadDone: 'Ayarlar yüklendi',
      loadSettingText: 'Ayar yükleme',
      downloadNc: 'NC indiriliyor',
      ncDownloadDone: 'NC indirme tamamlandı',
      downloadText: 'NC indir',
      loadPreferenceSetting: 'Tercih ayarları yükleniyor',
      PreferenceSettingLoadDone: 'Tercih ayarları yüklendi',
      loadPreferenceText: 'Tercihleri yükle',
      dealTemp: 'Şablon işleniyor',
      TempDealDone: 'Şablon işleme tamamlandı',
      dealTempText: 'Şablonu işle',
      beBeingGenTagFile: '{fileType} dosyası oluşturuluyor',
      genTagFileDone: '{fileType} dosyası oluşturuldu',
      genTagFileText: '{fileType} dosyası oluştur',
      zip: 'Yerel sıkıştırılmış dosya oluşturuluyor',
      zipDone: 'Yerel sıkıştırılmış dosya oluşturuldu',
      genZipText: 'Sıkıştırılmış dosya oluştur',
      fileTypeText: 'Görüntü'
      },
    surplusCommonTemp: 'Artık malzeme ortak şablonu',
    plankErrTip: 'Mevcut malzeme planında, yerleşime uygun büyük levhası olmayan küçük levhalar var',
    brandPlankErrTip: 'Mevcut malzeme planında yerleşime uygun marka levhası olmayan marka parçalar var!',
    overSizeTip: 'Büyük levha yetersiz veya ölçü aşımı',
    uselessPart: 'Geçerli büyük levhada kullanılabilir küçük levha yok, lütfen yeniden düzenleyin',
    splitArranged: 'Çok fazla küçük levha; lütfen yeniden düzenleyin veya partiler halinde yerleştirin',
    arrangedErrTip: 'Yerleşim başarısız; büyük levha yetersiz veya küçük levha ölçü aşımı',
    knivesModalTitle: 'Bazı delik/oluklarda takım bulunamıyor',
    cannotDownloadByKnivesErr: 'NC indirilemiyor; aşağıdaki delik/oluklarda takım bulunamadı',
    viewPart: 'Sorunlu levhayı görüntüle',
    deductionModalTitle: 'Lütfen kesinti nesnesini seçin',
    bujianDeduction: 'Ek parça küçük levhayı düşür',
    paibanDeduction: 'Geçici alandaki küçük levhayı düşür',
    surplusDeduction: 'Artık malzeme büyük levhayı düşür',
    unlockPaiban: 'Yerleşime dahil artığın kilidini kaldır',
    maintain: 'Yerleşime dahil artığın kilidini koru',
    lockModalText: 'Kullanılan artık levha başka siparişte; yeniden yerleştirilsin mi?',
    lockNewSModalText: 'Artık levha başka siparişte; NC indirmeye devam edilsin mi?',
    rePaibanWarn: 'Artık levha başka siparişte; kullanılabilir büyük levha yetersiz, kesim listesinden yeniden yerleştirin',
    sawRePaiban: 'Dikkat: Testere ile kesim kullanıyorsunuz; düzensiz parça yerleşimi eklendi, NC çıktısı için yeniden yerleştirme gerekir',
    togglePlankTip: 'Özel oluk nedeniyle ön-arka yüz değiştirme desteklenmiyor',
    stepCuttingMsg: 'Katmanlı kesim derinliği levha kalınlığından küçük olmalı',
    stepCuttingMsg2: "Katmanlı kesim derinliği yalnızca 0'dan büyük bir sayı olabilir",
    flipPlankTip: 'Delik-akış panel işlemi açık; levha çevirme yapılamaz',
    genNoCutTagNotSupportExportPic: 'Kesilmez etiket oluşturma açık; görüntü dışa aktarımı desteklenmiyor',
    allSmallPlanksAreNoCutNotInLayout: 'Tüm küçük levhalar kesilmez; yerleşime dahil değil',
    canStillExportHoleSlotOrPrintTag: 'Delik/oluk işleme dosyasını dışa aktarmaya veya etiket yazdırmaya devam edebilirsiniz',
    desMaterialNoCutNotSupportSwitchLine: 'Belirlenmiş küçük levha malzemesi kesilmez modu açık; doğrudan hat değiştirme desteklenmiyor',
    desMaterialNoCutSettingChanged: 'Sistem belirlenmiş küçük levha kesilmez ayarının değiştiğini algıladı; üretim doğruluğu için yeniden yerleştirin',
    continueDownload: 'İndirmeye devam et',
    desMaterialNoCutErrorTip: 'Kesilmez malzemeli levhalar oyma makinesine atanmış delik/oluk/şekil içeriyor; bu indirmede hepsi 5/6 yüz matkaba yönlendirildi. Dosya indirmeye devam edilsin mi?',
    clearReuseRelation: 'Yeniden kullanım ilişkisini temizlemek için tıklayın',
    layoutReuseTip: 'Büyük panel yerleşimini hızla kopyalayın; panel değişiklikleri yeniden kullanım ilişkisini otomatik kaldırır',
    hasBeenReused: 'Yeniden kullanıldı',
    layoutReuse: 'Yerleşim yeniden kullanımı',
    specialProcessNotSupported: 'Panelde özel işlem var, bu işlem desteklenmiyor',
    conflictNotSupported: 'Panel çakışması var, bu işlem desteklenmiyor',
    noAvailablePlankForReuse: 'Yeniden kullanım için uygun panel yok',
    noMatchingPlankFound: 'Eşleşen panel bulunamadı',
    reuseBoard: '{number} numaralı panel yeniden kullanım',
    influenceTip: {
      title: 'Optimizasyon oranını etkileyen özellikler',
      empty: 'Yok',
      groupParams: 'Yerleşim parametreleri',
      surplusNoRoll: 'Artık malzeme çevrilmez',
      surplusCustomTrim: 'Ayrı kenar kesim değeri',
      otherPlateCustomTrim: 'Özel büyük panel için ayrı kenar değeri',
      knifeDiameter: 'Kesici disk çapı',
      surplusNoFlip: 'Artık malzeme çevrilmez',
      surplusNotLayout: 'Artık malzeme belirtilen panelleri yerleştirmez',
      plankEdgeOff: 'Kenar kesim',
      surplusCustomTrim2: 'Artık kalanı özel ayarla',
      other: 'Etkilenebilecek diğer özellikler',
      enabled: 'Etkin',
      plankThicknessStacking: 'Tahta kalınlığı yığılması',
      edgePreMilling: 'Tahta kalınlığı yığılması',
      multiMaterialCuttingBlade: 'Tahta kalınlığı yığılması',
      sawSpecialShapePart: 'Testere kesim ve oyma makineleri için özel şekilli çentikli levhalar',
      longPlankCutting: 'Uzun tahta ikinci işleme'
      }
    },
  paibanImg: {
    title: 'Yerleşim diyagramı yönetimi',
    exportCustomPaibanImg: 'Özel yerleşim diyagramını dışa aktar',
    customPaibanImg: 'Özel yerleşim diyagramı',
    isCustomName: 'Özel yerleşim adı',
    template: 'Yerleşim şablonu',
    addTem: 'Şablon ekle',
    canvasIndexSearch: 'Büyük levha sıra numarası ara',
    symbol: 'Yerleşim diyagramı simgesi',
    frontSlot: 'Ön oluk',
    backSlot: 'Arka oluk',
    frontHole: 'Ön delik',
    backHole: 'Arka delik',
    printNum: 'Bir sayfada en çok gösterim',
    printUnit: 'yerleşim diyagramı (sayı birimi)',
    edit: 'Yerleşim şablonu düzenleme',
    temName: 'Şablon adı',
    rotate: 'Yerleşim diyagramını döndür',
    showOverflow: 'Metin taşarsa işaret çizgisi küçük levha verisini gösterir',
    showHoleSlot: 'Delik ve oluk bilgisini göster',
    bigPartCss: 'Büyük levha yerleşim stilini ayarla',
    partCss: 'Küçük levha yerleşim stilini ayarla',
    addTemTip: 'En fazla 10 yerleşim şablonu eklenebilir',
    exportTip: 'Dışa aktarmak için en az bir şablon seçin',
    editSaveTip: 'Kaydetmeden önce zorunlu alanların doldurulduğunu doğrulayın',
    exportDXF: 'DXF Dışa Aktar',
    exportDxfGeneral: '2D Genel DXF',
    exportDxf3d: '3D Özel DXF',
    exportDxfGeneralTip: 'Elle işleme, çizime bakarak kesim yapma veya yerleşim sonuçlarını kontrol etme için uygundur',
    exportDxf3dTip: 'Üretim için üçüncü taraf sistemlere aktarılmaya uygundur; Huiya lazer kesim entegre makinelerini destekler'
    },
  historyPage: {
    matchErrBySpecialTip1: 'Aşağıdaki özel büyük levhalar için eşleşme yok; yerleşim sayfasında yeniden yerleştirmede sorun olabilir. Karma şema kullanıldıysa bu uyarıyı yok sayın',
    specialPlankInfoErrTip2: 'Özel büyük levha bilgisi alınamadı; yerleşim sayfasının yeniden yerleştirme işlevi etkilenir',
    download: 'Yerel indir',
    allType: 'Tümünü kaydet',
    handleSave: 'Manuel kaydet',
    specialPlank: 'Özel',
    surplusPlank: 'Fazla',
    autoSave: 'Otomatik kaydet',
    allArrange: 'Tüm yerleşim',
    searchPlaceholder: 'Sipariş adı / dizgi partisi / sipariş numarası ara',
    saveHistoryName: 'Kaydedilen geçmiş adı',
    trailProduction: {
      title: 'Deneme üretim örnek dolabı',
      lastTime: 'Son deneme üretim tarihi',
      recordList: 'Deneme üretim kayıtları',
      start: 'Deneme üretimini başlat',
      date: 'Zaman',
      outputFrom: 'Çıktı konumu',
      empty: 'Veri yok',
      record: 'Yüklenen deneme üretim örnek dolabı görüntü kayıtları',
      tip1: 'Dikkat: Geçerli deneme üretim siparişi varsayılan üretim verilerini kullanıyor',
      tip2: 'Dikkat: Deneme üretim siparişi en güncel proses parametrelerini kullanmıyor; deneme odasına gidip yeniden kaydedin',
      download: 'İşleme dosyasını indir'
      },
    deleteTip: 'Aşağıdaki geçmiş kayıtlarını silmeyi onaylıyor musunuz?',
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',
    lastWeek: 'Son bir hafta',
    lastMonth: 'Son bir ay',
    lastSeason: 'Son üç ay',
    toArrangePage: 'Yerleşim sayfasına gidiliyor',
    notArrangedTip: 'Bu kayıt yerleştirilmedi; önce kesim listesine gidin',
    toMaterialPage: 'Kesim listesi sayfasına gidiliyor',
    lessSelectTip: 'Bu işlem için en az bir kayıt seçin',
    downloadNc: 'İşleme dosyasını indir'
    },
  workShopPage: {
    warningTip: 'Bu özellik süreli denemedir; sipariş üretiminizi makul planlayın',
    fileManager: 'Üretim dosyası yönetimi',
    selected: 'seçildi',
    suplement: 'Tamamlama deposu',
    size: 'Boyut',
    saveToStore: 'Tamamlama deposuna ekle',
    enterArrange: 'Yerleşime giriliyor...',
    deleteTip: 'Bu veri silindikten sonra geri yüklenemez. Silmeyi onaylıyor musunuz?',
    arrangeTip: 'Ek parça verisi çözümleniyor, lütfen bekleyin...',
    store: 'Tamamlama deposu',
    downloadFile: 'Üretim dosyasını indir',
    notBujianFile: 'Ek parça dosyası bulunamadı',
    productLineDelete: 'Bu üretim hattı silindi; NC dosyası indirilemez!'
    },
  basePlankManager: {
    saveTip: 'Not: Kaydetmek için Enter tuşuna basın',
    offsetSize: 'Kenar düzeltme ölçüsü',
    overSizeTip: 'Ölçü çok büyükse yerleşim için otomatik olarak daha büyük levha seçilir',
    addTip: 'Yerleşimde parça ölçü aşımında özel büyük levha ekleme penceresi açılır',
    defaultOversizePlankValue: 'Ölçü aşımı büyük levhalar yalnızca ölçü aşımı küçük levhaları sıralar',
    onlyLayoutTooBig: 'Ölçü aşımı büyük levhalar yalnızca ölçü aşımı küçük levhaları sıralar',
    settingRemark: 'Not: Bu bölümdeki işlev sağ ayarlara taşındı',
    searchPlaceholder: 'Levha malzeme/rengi ara',
    syncData: 'Guigui dolap verilerini eşitle',
    syncDataM: 'Dolap kapısı verilerini eşitle',
    deletePlank: 'Özel büyük levha sil',
    addPlank: 'Yeni özel levha oluştur',
    matCodePlaceholder: 'Levha seçin',
    thickPlaceHolder: 'Kalınlık seçin',
    widthErr: 'Levha genişliği boş olamaz',
    heightErr: 'Levha uzunluğu boş olamaz',
    matCodeErr: 'Levha malzemesi boş olamaz',
    colorErr: 'Levha rengi boş olamaz',
    editPlank: 'Levhayı düzenle',
    deleteTip: 'Bu veri silindikten sonra geri alınamaz. Silmeyi onaylıyor musunuz?',
    plankKnifeSelect: 'Ham levha kesim bıçağı seçimi',
    plankKnifeSelectTip: 'Birden fazla kural eşleşince levha kalınlığı, malzemeden önceliklidir',
    knifeSelectTip: 'Not: İç içe yerleşimde bu işlev desteklenmez',
    knife: 'Kesim takımı',
    matcodeInput: 'Levha malzemesini girin',
    thickInput: 'Levha kalınlığını girin',
    default: 'Sistem varsayılanı',
    unessential: 'Bu sütun: zorunlu değil',
    emptyTip: 'Not: Bu alan boşsa ham levha eşleştirmede bu veri dikkate alınmaz',
    defaultUse: 'Varsayılan seçim',
    editMatcode: 'Malzemeyi düzenle',
    syncTip: '{fromMc} verileri alınacak ve mevcut bulut yerleşimindeki ham levha yönetimi verilerinin üzerine yazılacak. Eşitlensin mi?',
    sameErr: 'Aynı veri zaten var',
    cancelDelete: 'Silme iptal edildi',
    syncErr: 'Eşitleme başarısız',
    syncSuccess: 'Eşitleme başarılı',
    syncDataTip: '{fromMc} verilerini eşitle',
    editErrTip: 'Doldurulmamış bilgiler var, kontrol edin!',
    numberCheck: '{type} yalnızca sayı girilebilir',
    deleteStandardPlate: 'Standart levha kaldır',
    createStandardPlate: 'Yeni standart levha',
    editStandardPlate: 'Standart levhayı düzenle',
    trimmingDimension: 'Kenar düzeltme boyutu',
    front: 'Üst',
    back: 'Alt',
    left: 'Sol',
    right: 'Sağ',
    frontTrim: 'Üst kenar düzeltme',
    backTrim: 'Alt kenar düzeltme',
    leftTrim: 'Sol kenar düzeltme',
    rightTrim: 'Sağ kenar düzeltme',
    customTrim: 'Özel kenar düzeltme değeri',
    trimValue: 'Kenar düzeltme değeri',
    notEmpty: '{type} boş olamaz',
    edgeDir: 'Kenar düzeltme ({type})',
    brandPlank: 'Marka Levha',
    brandPlankTip: 'Not: Marka levhalarin silinmesi ve degistirilmesi Cabinet istemci panel kaynak kutuphanesinde yapilir',
    brand: 'Marka',
    supplier: 'Tedarikçi',
    brandPlaceholder: 'Marka seçin',
    supplierPlaceholder: 'Tedarikçi seçin',
    brandInput: 'Marka girin',
    supplierInput: 'Tedarikçi girin',
    addBrandPlank: 'Marka levha ekle',
    deleteBrandPlank: 'Marka levha sil',
    editBrandPlank: 'Marka levha düzenle',
    searchBrandPlaceholder: 'Marka/tedarikçi/malzeme/renk ara'
    },
  bujianAndStore: {
    bujianStore: 'Bujian deposu',
    awaitStore: 'Yerleşim bekleyen levha deposu',
    depositAwaitStore: 'Yerleşim bekleyen depoya kaydet',
    pushToAwaitStore: 'Yerleşim bekleyen depoya koy',
    useTwoTableArrange: 'İki form ile yerleşim',
    confirmUseTwoTableTip: 'Seçili küçük levhalar hem ek parça hem yerleşim bekleyen depodan; yerleşime devam edilsin mi?',
    confirmAddPlankToAwaitStore: 'Seçili levhalar yerleşim bekleyen depoya eklensin mi?',
    pushStoreSuccess: 'Depoya giriş başarılı',
    dataGenErr: 'Veri oluşturma hatası',
    unknownErr: 'Bilinmeyen hata; depoya eklenemedi'
    },
  surplusPage: {
    surplusMaterial: 'Artık malzeme listesi',
    surplusStore: 'Artık malzeme deposu',
    recycleBin: 'Artık malzeme deposu',
    recycleBinTip: 'Artık malzeme verileri 90 gün boyunca geri dönüşüm kutusunda kaldıktan sonra otomatik olarak silinir',
    "deleteReason-0": 'Elle yapılan silme',
    "deleteReason-1": 'Dizgi kesintisi',
    "deleteReason-2": 'Guigui mobil işlemi ile stok çıkışı',
    surplusShape: 'Artık malzeme şekli',
    batchTransfer: 'Toplu aktarım',
    createNewSurplusStore: 'Yeni artık malzeme deposu',
    pushStoreSetting: 'Artık malzeme depo ayarları',
    surplusStoreName: 'Artık depo adı',
    surplusStoreName2: 'Artık depo adı',
    addSurplusStore: 'Artık depo ekle',
    inventoryCeiling: 'Stok üst sınırı',
    autoTransferTip: 'Silindikten sonra depodaki artıklar otomatik olarak artık malzeme listesine aktarılır',
    asIndexPushStore: 'Depo doluluk durumuna göre sırayla depoya al',
    pushToSurplusMaterial: 'Artık malzeme listesine kaydet',
    surplusStoreTable: {
      number: 'Numara',
      name: 'Artık depo adı',
      quantity: 'Saklanan artık adet (adet)',
      capacity: 'Artık stok üst sınırı (adet)',
      rules: 'Artık malzeme depo kuralları',
      remark: 'Not',
      operation: 'İşlem'
      },
    editSurplusStore: 'Artık depoyu düzenle',
    addSurplus: 'Artık malzeme ekle',
    importSurplus: 'Artık malzeme içe aktar',
    downloadSurplusTemplate: 'Artık içe aktarma şablonunu indir',
    batchExportSurplus: 'Geçerli artık listesini dışa aktar',
    surplusBatchImportExport: 'Artık malzeme toplu içe/dışa aktarma',
    surplusMaterialStorageCode: 'Artık malzeme depo kodu',
    generateQRCodeSuccess: 'QR kodu oluşturuldu',
    generateQRCodeFailed: 'QR kodu oluşturulamadı',
    refreshQRCode: 'QR kodunu yenile',
    refreshQRCodeFailed: 'QR kodu yenilenemedi',
    cancelRefresh: 'Yenileme iptal edildi',
    refreshQRCodeTip: 'QR kodunu yenilemek istiyor musunuz? Yenilemeden sonra mevcut kod geçersiz olur.',
    refreshQRCodeConfirm: 'Onayla',
    refreshQRCodeCancel: 'İptal',
    wechatScanTip: 'WeChat ile tarayıp artık malzemeyi elle depoya ekleyebilirsiniz',
    deletSurplus: 'Artık malzemeyi sil',
    editSurplus: 'Artık malzemeyi düzenle',
    surplusNoRoll: 'Yeniden haddelenmeden artık malzeme işlemesini etkinleştir',
    type: {
      all: 'Tüm şekiller'
      },
    allMatcode: 'Tüm malzemeler',
    allThick: 'Tüm kalınlıklar',
    surplusName: 'Artık malzeme adı',
    rectSurplus: 'Dikdörtgen artık',
    LTypeSurplus: 'L şeklinde artık',
    noMatchSup: 'İlgili veri bulunamadı',
    jumpTo: 'Git',
    page: 'Sayfa',
    newMatcode: 'Yeni malzeme oluştur',
    newColor: 'Yeni renk oluştur',
    autoCreateColor: 'Enter tuşuna basınca renk kartı otomatik oluşturulur',
    nameLimit: 'Artık ad en fazla 10 karakter',
    nameLimitNameErr: 'Artık ad boş olamaz',
    tempLongTip: 'Levha uzunluğunda yalnızca sayı',
    minLongLimit: 'Kısa kenar uzunluğunda yalnızca sayı',
    minLongEmptyTip: 'Kısa kenar uzunluğu boş olamaz',
    minLongLimitMax: 'Kısa kenar uzunluğu levha uzunluğunu aşamaz',
    widthLimit: 'Levha genişliğinde yalnızca sayı',
    minWidthLimit: 'Kısa kenar genişliğinde yalnızca sayı',
    minWidthEmptyLimit: 'Kısa kenar genişliği boş olamaz',
    minWidthLimitMax: 'Kısa kenar genişliği levha genişliğini aşamaz',
    thickLimit: 'Levha kalınlığında yalnızca sayı',
    thickEmptyLimit: 'Levha kalınlığı boş olamaz',
    countInputLimit: 'Miktar yalnızca pozitif tam sayı',
    countEmptyLimit: 'Miktar boş olamaz',
    remarkMaxlimit: 'Not en fazla 50 karakter',
    orderAddressMaxlimit: 'Kaynak sipariş adresi en fazla 100 karakter',
    orderIdMaxlimit: 'Kaynak sipariş no en fazla 100 karakter',
    createTime: 'Eklenme zamanı',
    deleteTime: 'Silme zamanı',
    deleteReason: 'Silme nedeni',
    branchName: 'Bulunduğu artık deposu',
    orderAddress: 'Kaynak sipariş adresi',
    orderId: 'Kaynak sipariş numarası',
    lockStatus: 'Kilit durumu',
    lockOrder: 'Kilitli sipariş',
    enableSurplusLock: 'Artık malzeme kilidini etkinleştir',
    isCloseSurplusLock: 'Kapatılınca tüm artıkların kilidi açılır. Devam edilsin mi?',
    confirm: 'Kapatmayı onayla',
    surplusTransfer: 'Artık malzeme aktarımı',
    targetSurplusStore: 'Hedef artık deposu',
    enableSurLockTip: 'Açıkken her yerleşimde kullanılan artık kilitlenir; başka siparişler kullanamaz',
    addMainRule: 'Ana kural ekle',
    surplusRules: 'Artık malzeme depo kuralları',
    mainRulesTip: 'Ana kurallar VEYA ilişkisindedir; bir ana kural sağlanırsa malzeme depoya girer',
    mainRulesTip1: 'Kural eklendikten sonra eşleşen artıklar önce bu depoya alınır; dolunca diğer boş depolara gider',
    rule: 'Kural',
    addSubRule: 'Alt kural ekle',
    subRuleTip: 'Alt kurallar VE ilişkisindedir; ana kural altındaki tüm alt kurallar aynı anda sağlanmalıdır',
    bigPlankMatCode: 'Büyük levha malzemesi',
    bigPlankThick: 'Büyük levha kalınlığı',
    bigPlankColor: 'Büyük levha rengi',
    greaterEqual: 'Büyük veya eşit',
    lessEqual: 'Küçük veya eşit',
    capNumberCheck: 'Stok üst sınırı yalnızca tam sayı olabilir',
    capEmptyCheck: 'Stok üst sınırı boş olamaz',
    surNameEmptyCheck: 'Artık depo adı boş olamaz',
    mainRuleLimit: 'Ana kural üst sınıra ulaştı',
    delMainRuleTip: 'Bu ana kural silinsin mi?',
    matCodeEmptyCheck: 'Büyük levha malzemesi boş olamaz',
    thickEmptyCheck: 'Büyük levha kalınlığı boş olamaz',
    textureEmptyCheck: 'Büyük levha rengi boş olamaz',
    enableWarehouseSecondCon: 'Artık depo için ikinci onayı etkinleştir',
    surplusWarehouseConfirm: 'Artık malzeme depo onayı',
    surplusWarehouseConfirm1: 'Depo onayı',
    closeSurplusConfirm: 'Depo onayını kapat (artık yönetim sayfası ayarlarından yeniden açılabilir)',
    position: 'Saklama konumu',
    nameRepeatTip: 'Bu artık adı zaten var; düzenleyip yeniden depoya alın',
    surLimitTip: 'Artık depo dolu veya depo kurallarını karşılamıyor',
    surFailTip: 'Depoya alınamadı: yinelenen ad, kapasite üst sınırı veya kurallar uyumsuz',
    surplusExistTip: 'Bazı artık parçalar zaten depoda; işlem başarısız',
    surplusExistTip2: 'Mevcut artık parça zaten depoda; depoya alınamaz',
    currentPage: 'Geçerli sayfa',
    totalPage: 'Tümünü seç'
    },
  printPage: {
    goto: 'Hemen git',
    surplusSizeTittle: 'Artık boyut çok küçük uyarısı',
    surplusSizeErrTip: 'Artık boyut çok küçük; ilgili üretim hattında minimum artık boyutunu ayarlayın',
    opacityTip: 'Teknik destek: EZsort',
    opacityTip2: 'Hesapta Smart Color Labels yok; satın alındıysa Color Label yazılımında dolap hesabını bağlayın',
    loadFontTip: 'Gerekli yazı tipi kaynakları yükleniyor, lütfen bekleyin',
    leftAlign: 'Sola hizala',
    rightAlign: 'Sağa hizala',
    topAlign: 'Üste hizala',
    bottomAlign: 'Alta hizala',
    horizontalAlign: 'Yatay ortala',
    verticalAlign: 'Dikey ortala',
    horizontalSplit: 'Yatay eşit böl',
    verticalSplit: 'Dikey eşit böl',
    norTag: 'Normal etiket',
    surTag: 'Artık büyük levha etiketi',
    genTag: 'Etiket oluştur',
    all: 'Tümünü seç',
    deleteWarning: 'Nazik hatırlatma',
    print: 'Yazdır',
    defaultTemplate: 'Varsayılan şablon (60 x 40)',
    editTemplate: 'Şablonu düzenle',
    deleteTip: 'Bu şablon silindikten sonra geri yüklenemez. Silmek istediğinizden emin misiniz?',
    tagSetting: 'Etiket ayarları',
    rememberSetting: 'Değişiklikten sonra ayar hatırlanacak',
    genCutingTag: 'Kesim tahtası parçası etiketi oluştur',
    genSurplusTag: 'Artık malzeme etiketi oluştur',
    genPlankTag: 'Büyük tahta etiketi oluştur',
    genPartTag: 'Küçük tahta etiketi oluştur',
    genNoCutTag: 'Kesilmeyen tahta etiketi oluştur',
    tagPosition: 'Etiket konumu',
    tagPositionTip: '(Yalnızca etiketleme makinesi aşağıdaki X/Y koordinatlarını doldurmalıdır)',
    Xposition: 'X koordinatı',
    Yposition: 'Y koordinatı',
    genPlankSuffix: 'Büyük tahta etiketi için dosya adı son eki',
    arrangeMirror: 'Etiket görüntüsü aynalama',
    drillPlankBase: 'Beş veya altı yüz delik yerleştirme plakası referansı',
    drillPlankBaseTip: 'Plaka yerleştirme temel verileri alınamadı. Lütfen daha sonra tekrar deneyin!',
    suitAuto: 'Etiket sıralaması otomatik yükleme/boşaltmaya uyarlanır:',
    colorLabel: 'Renkli etiket oluştur',
    colorRevert: 'Küçük tahtalar için ters renkli etiket oluştur',
    displayEnAndZh: 'Oda/dolap/panel adını İngilizce ve Çince göster',
    displayEnAndZhTip: 'Yalnızca varsayılan oda/dolap/panel adları desteklenir; özel adlara geçince bu özellik çalışmaz',
    up: 'Yukarı',
    down: 'Aşağı',
    default: 'Varsayılan',
    printSetting: 'Yazdırma ayarları',
    oneToMore: 'Bir sayfada birden çok',
    perPage: 'Her biri',
    coloumn: 'Sütun',
    tagMargin: 'Etiket aralığı',
    coloumnMargin: 'Sütun aralığı',
    specialMark: 'Özel işaret',
    opacity: 'Şeffaflık',
    opacityTip3: 'BMP görsellerinde şeffaflık için gerçek renk seçilmelidir',
    suite: 'Uyarlanabilir',
    svgListTip: 'Küçük tahta etiketi oluşturma açık değil; soldan işaretleyin',
    size: 'Boyut',
    lightSide: 'Görünen ışık kenarı',
    locFrontSide: 'Dolabın ön yüzü',
    openSide: 'Açılış yönü',
    extraTip: ' İpucu: Doğrudan yazdırmayı ilk kez kullanırken yazıcı ayarlarına, aynı boyutta ancak uzunluk ve genişliği ters çevrilmiş yeni bir kağıt ekleyin; ardından bu kağıtla yazdırın (örn. eski 60×40, yeni 40×60).',
    noMore: 'Başka yok',
    prepareData: 'Veriler hazırlanıyor...',
    genTagFile: 'Etiketler oluşturuluyor; sayfa değiştirmeyin, tarayıcıyı küçültmeyin veya etiketleri kaydırmayın!',
    waitGen: 'İndirmeden önce etiketlerin tamamen yüklenmesini bekleyin',
    tempLoading: 'Etiket şablonu yükleniyor, lütfen bekleyin',
    front: 'Ön',
    open: 'Aç',
    toEdit: 'Düzenlemeye git',
    simplifyOneCodeTip: 'Dikkat: Bu etiket şablonundaki barkod özellikleri Basit Barkod işlevini desteklemez; barkod özelliklerini değiştirin (önerilen: CODE128)',
    plankTemp: 'Küçük tahta etiket şablonu',
    surplusTemp: 'Artık malzeme etiket şablonu',
    enableSubTag: 'Alt etiketi etkinleştir',
    enableSubTagTip: 'Diğer ayarlar > Küçük levha alt etiketi ayarları > Alt etiket oluşturma için geçerli veri kaynağını ayarla bölümünden ayarlayabilirsiniz. Açıldıktan sonra yalnızca ayarlanan veri kaynağının alt etikette değeri varsa alt etiket oluşturulur; aksi halde oluşturulmaz.',
    goSet: 'Ayarlara git',
    mainTag: 'Küçük levha ana etiketi',
    subTag: 'Küçük levha alt etiketi',
    downloadSubTagTip: 'Dışa aktarılan etiketlerde alt etiket var. Otomatik etiketleme üretim hattı şu anda alt etiket oluşturamıyor. Çıktıya devam etmek istiyor musunuz?',
    embeddedSubTagTip: 'Alt etiket fonksiyonu desteklenmiyor. Lütfen web tabanlı bulut düzenini açarak kullanın.',
    subTagPerSaveTip: 'Alt etiket izni süresi doldu. Lütfen alt etiketi kapatın ve yeniden kaydedin.',
    subTagPerexportTip: 'Dışa aktarılan üretim dosyasında ödeme yapılan alt etiket izni içerir. Bu özellik süresi doldu ve yeniden kapatılması ve çıktıya çıkarılması gerekiyor.',
    tempNamePlaceHolder: 'Şablon adını girin',
    editTip: 'İhtiyacınıza göre soldaki düğmeleri sağdaki etiket kağıdına sürükleyerek şablonu düzenleyebilirsiniz',
    oneCode: 'Barkod',
    image: 'Görüntü',
    arrow: 'Ok',
    editPage: {
      digitLimitation: 'Basamak sınırı',
      title: 'Etiket şablonu düzenleme',
      reset: 'Varsayılana döndür',
      exit: 'Düzenlemeden çık',
      tagInfo: 'Etiket bilgisi',
      tagName: 'Etiket adı',
      tagSize: 'Etiket boyutu',
      tagData: 'Etiket verisi',
      dragTip: 'Veri etiketi oluşturmak için sol fare düğmesini basılı tutup sürükleyin',
      dataTip: 'Veri bilgisini sağdaki özellik panelinden seçin',
      text: 'Metin',
      dataSource: 'Veri kaynağı',
      graph: 'Grafik',
      typograpyPic: 'Dizgi diyagramı',
      barCode: 'Barkod',
      QRCode: 'QR kodu',
      plankMark: 'Plaka işareti',
      holeSlotPic: 'Delik ve oluk diyagramı',
      edgeBandPic: 'Kenar bantlama diyagramı',
      visibleEdgePic: 'Görünen kenar',
      holeSlotPicZoom: 'Delik/oluk görseli yakınlaştırma',
      rotateDeg: 'Dönüş açısı',
      colorDeep: 'Renk derinliği',
      surplusMark: 'Artık malzeme işareti',
      surplusSizePic: 'Artık malzeme boyut görseli',
      dataSize: 'Veri boyutu',
      extraList: 'Ek liste',
      QRCodeFormat: 'QR kodu biçimi',
      formatQR: 'QR biçimi',
      formatDM: 'DM biçimi',
      locIndex: 'Dolap sıra numarası',
      plankFrontSign: 'Panel işareti',
      genNCSuffix: 'NC son eki oluştur',
      table: 'Tablo',
      inputPlaceholder: 'Metin girmek için çift tıklayın',
      attribute: 'Özellik',
      fontFamily: 'Yazı tipi ailesi',
      fontSize: 'Yazı tipi boyutu',
      fontWeight: 'Yazı tipi kalınlığı',
      flipOverProcessing: 'Çevirme işlemi',
      showSideMachiningSequenceDiagramBorder: 'Çevirme işlemi ve aynı şekilde çevirme işlemi',
      showSideMachiningSequenceNumber: 'Çevirme işlemi ve aynı şekilde çevirme işlemi',
      autoRow: 'Metni otomatik kaydır',
      rowMargin: 'Satır aralığı',
      autoFontSize: 'Taşmada yazı tipi boyutunu otomatik ayarla',
      statisticsDimension: 'İstatistik boyutları',
      noLimit: 'Sınırsız',
      sameOrderNo: 'Aynı sipariş',
      sameRoom: 'Aynı oda',
      sameWardrobe: 'Aynı dolap',
      alignWay: 'Hizalama',
      JustifyLeft: 'Sola hizalı',
      JustifyRight: 'Sağa hizalı',
      JustifyCenter: 'Ortalanmış',
      otherOpration: 'Diğer işlemler',
      attributeReset: 'Özellikleri sıfırla',
      barCodeSize: 'Barkod boyutu',
      installPic: 'Kurulum şeması',
      plankCode2: 'Plaka barkodu (noMark)',
      frontCode: 'Ön barkod',
      backCode: 'Arka barkod',
      orderRemark: 'Sipariş notları',
      NCFileName: 'Kesim dosya adı',
      NCFileNameTip: 'NC dosya adı Çince karakter içermemeli ve uzunluğu 10 karakteri geçmemelidir',
      showOpenSide: 'Kapı açılış yönünü göster',
      limitFixed: 'Ondalık basamak sayısını sınırla',
      showFrontHS: 'Ön yüz delik/olukları göster',
      showBackHS: 'Arka yüz delik/olukları göster',
      showPartEdge: 'Plaka bantlamayı göster',
      showPlankSize: 'Plaka boyutunu göster',
      tempNamePlaceholder: 'Etiket adını girin',
      deleteAreaTip: 'Silinecek alanı seçin',
      suitShunt: 'Plaka bantlamayı göster',
      suitShuntTip: 'Seçildikten sonra, sonraki işlemi olmayan delik/oluk parçaları barkod oluşturmaz',
      noHoleSlot: 'Delik/oluk olmasa da barkodu göster',
      rotate: 'Barkodu döndür',
      barcodeAtrribute: 'Barkod özellikleri',
      imgSize: 'Görüntü boyutu',
      graphStyle: 'Grafik stili',
      noEdgeDisplay: 'Bant 0 ise gösterme',
      allEdgeNoDisplay: 'Bantlamayı gösterme',
      isShowDiffEdgeColor: 'Her bant rengini göster',
      hideSameEdgeColorAsPlank: 'Bant rengi panele eşitse gösterme',
      hideSameEdgeColorAsPlankTip: 'Gömülü bulut düzeni henüz desteklenmiyor',
      imgRotate: 'Görüntüyü döndür',
      circleD: 'Daire çerçeve çapı',
      roomNo: 'Oda numarası',
      roomOrder: 'Dolap sırası (odaya göre sıralı)',
      alphabetically: 'Alfabetik sırala',
      numberOrder: 'Sayısal sırala',
      specialMarkup: 'Özel işaretleme sembolleri',
      smallPlateMarking: 'Küçük plaka işareti',
      arrow: 'Ok',
      triangle: 'Üçgen köşe işareti',
      sixSideDrillPlankBase: 'Altı yüz delik yerleştirme tabanı',
      boldSettingTip: 'PDF kalın yazı tipi desteklenmiyor',
      frontEdge: 'Dolabın önünü göster',
      visibleEdge: 'Görünen ışık kenarını göster',
      lineCount: 'Satır başına karakter sayısı'
      },
    autoSaveToHistory: 'Geçmişe otomatik kaydedildi!',
    firstPrintTip: 'Doğrudan yazdırmayı ilk kullanımda yazıcı ayarlarına uzunluk ve genişliği yer değiştirmiş yeni bir kağıt ekleyin, ardından bu kağıtla yazdırın',
    tagDownloading: 'Etiket indiriliyor...',
    cutLaveEnd: 'Kesim artığı etiketleri her büyük plakanın arkasında oluşturulur',
    deleteTemplate: 'Şablonu kaldır',
    copyTemplateRenderUrl: 'Şablon bağlantısını kopyala',
    noPermission: 'Şablon bağlantısını kopyalamaya izin yok, şablonu silmek istediğinizden emin misiniz?',
    moreOperation: 'Daha fazla işlem',
    importTemplate: 'Şablonu içe aktar',
    importTemplateLink: 'Şablon bağlantısını kopyala, şablonu silmek istediğinizden emin misiniz?',
    importTemplateLinkPlaceholder: 'Şablon bağlantısını kopyala, şablonu silmek istediğinizden emin misiniz?',
    noDeleteTemplate: 'Varsayılan şablon silinemez',
    tip1: 'Şablon bağlantısını kopyalamaya izin yok',
    tip2: 'Şablon bağlantısını kopyalamaya izin yok',
    tip3: 'Şablon bağlantısını kopyalamaya izin yok',
    tip4: 'İçe aktarılan şablon bağlantısı tanınamadı. Lütfen yeniden indirip tekrar içe aktarın.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'Malzeme, renk, kalınlık ve büyük plaka boyutuna göre farklı klasörlere ayırın (etiket dosyaları dahil)',
    notOpeFolderPermission: 'Bu dizin için yetkisiz işlem',
    notFindFolder: 'Bu dizin geçerli istemcide algılanamıyor',
    productLineUniversal: 'Tüm üretim hatları için geçerli',
    effectCondition: 'Bu ayar yalnızca yeniden yerleşimden sonra geçerli olur',
    addPath: 'Yol ekle',
    downloadPositionChangeByType: 'Oluşturulan dosyaların indirme konumu {type} olarak değiştirildi',
    isDeleteFolder: 'Kullanılan dosya depolama konumunu silmek istediğinizden emin misiniz?',
    netWorkIsNotSafe: 'Ağ ortamınız güvenli görünmüyor; bu özelliği etkinleştiremiyoruz, bize geri bildirim gönderebilirsiniz',
    NotSupportBrowse: 'Tarayıcınız bu özelliği desteklemiyor. Kullanmak için <a href="https://www.microsoft.com/en-us/edge/download" target="_blank">Edge</a> tarayıcısının en son sürümünü indirin.',
    notSupportDisk: '[Masaüstü] ve [C sürücüsü] gibi sistem düzeyi dizinler seçilemez',
    useFolderDownload: 'Üretim dosyaları sıkıştırılmamış biçimde indirilir',
    downloadPosition: 'Dosya indirme konumu',
    changeUseFolder: 'Değiştir',
    folderNameSetting: 'Klasör ayarları',
    mainFolder: 'Birincil klasör',
    exportNameSetting: 'İşlenmiş dosyaları sipariş numarasına göre dışa aktar',
    fileMax: 'Dosya adı en fazla',
    char: 'Karakter',
    overTip: 'Fazla kısım gösterilmez (etiket zip ve json dosyaları birincil klasör adını izler)',
    example: 'Örnek',
    engravingFolder: 'Oyma makinesi klasörü',
    electronicSawFolder: 'Elektronik testere klasörü',
    labellingFolder: 'Etiketleme makinesi klasörü',
    sideHoleDrillFolder: 'Yan delik makinesi klasörü',
    fiveDrillFolder: 'Beş yüz delik makinesi klasörü',
    sixDrillFolder: 'Altı yüz delik makinesi klasörü',
    PTPFolder: 'PTP klasörü',
    labellingTagFolder: 'Etiket görüntü klasörü',
    surplusFolder: 'Artık malzeme dosyası büyük plaka ayarı',
    surplusBigPlankSetting: 'Artık büyük plaka kesim dosyaları/etiket görselleri/etiket dosyaları ayrı konur',
    surplusBigPlankSettingTip: 'Açıldığında artık NC dosyaları, etiket görselleri ve etiket dosyaları ayrı bir klasörde toplanır',
    folderMergeSetting: 'Klasör birleştirme ayarları',
    folderMerge: 'Klasör birleştirme',
    mergeName: 'Birleştirilmiş ad',
    subMergeFolder: 'Malzeme, renk ve kalınlığa göre alt klasörlere birleştir:',
    subFolderName: 'Alt klasör adı',
    splitChar: 'Ayırıcı',
    splitTip: '(/ : ? < > | . " * gibi karakterler desteklenmez)',
    folderAutoAdd: 'Klasör sayısı otomatik artış başlangıç değeri',
    resetTip: '(Her gün gece yarısı başlangıç değerine sıfırlanır)',
    emptyErrTip: 'Bilgi boş olamaz',
    repeatErrTip: 'Dosya adı yineleniyor',
    mergeDataTip: 'Plaka malzemesi, renk, kalınlık, uzunluk/genişlik veya dosya sayısı artışı veya malzeme-renk-kalınlık bilgisi olmalıdır',
    engravingFileSetting: 'Oyma makinesi dosya ayarları',
    engravingSplitZF: 'Oyma makinesinin ön/arka dosyalarını farklı klasörlerde saklayın',
    engravingSplitZFTip: '123 otomatik etiketleme makineleri için uygundur',
    engravingSplitWorkstation: 'Oyma makinesi pozisyonuna göre klasörler',
    engravingSplitWorkstationTip: 'Oyma makinesi ve kesme oyma makinesi desteklenir',
    holeFileSetting: 'Delik dosyası ayarları',
    holeFileSingle: 'Delik dosyaları farklı siparişlere göre ayrı klasörlerde konur'
    },
  moreSettings: {
    generalSetting: 'Genel ayarlar',
    outSyncTip: 'Bulut dizgi özgün film verisi dolapla senkron değilken uyarı penceresi göster',
    secondarySwitchShow: 'Oyma ayarındaki anahtarın kapattığı alt içerik yine de gösterilir',
    isFrameDoorTip: 'Kafes kapısı işleme sırasında uyarı göster',
    exPaibanTip: 'Düzensiz artık/düzensiz iç içe yerleşim kullanılırken uyarı penceresi oluştur',
    isDesMaterialNoCutTip: 'Kesilmeyen küçük plaka malzemesinde oyma makinesine atanmış delik/oluk/şekil varken uyarı göster',
    surpTagThresholdTextHalf1: 'Artık malzeme (kesim artığı değil) alanı şundan küçük olduğunda',
    surpTagThresholdTextHalf2: 'artık malzeme etiketi oluşturulmaz',
    innerShapeToolMatch: 'Oyma makinesi iç düzensiz şekiller için uygun takımı otomatik seçer',
    innerShapeToolMatchTip: '(İç düzensiz şekil, kesim takım çapından küçük olduğunda boyut hatası/işlenememe olursa bu özellik açılabilir)',
    innerShapeToolMatchTip2: 'Dikkat: Açıldığında en küçük oluk frezesi kullanılır; en küçük oluk frezesinin takım uzunluğu ve tek seferde maksimum işleme derinliğini uygun ayarlayın; yalnızca bulut dizgide geçerlidir',
    surNotLayout: 'Artık büyük plakada belirtilen plaka parçalarını yerleştirme',
    surNotLayoutTip: 'Açılınca: 1) Artık büyük plaka, aşağıdaki adları içeren küçük plakaları sıraya alamaz. 2) Dizgi sırasında bu işlevin bu sefer geçerli olup olmayacağını seçebilirsiniz',
    addPlank: 'Plaka adı ekle',
    addPlankTip: 'En az bir küçük plaka adı ekleyin',
    thisInput: 'Buraya girin',
    surNotLayoutMat: 'Artık malzeme belirtilen küçük plakalara yerleştirilmez',
    subTagSetting: 'Küçük levha alt etiketi ayarları',
    subTagDataSource: 'Alt etiket oluşturma için geçerli veri kaynağını ayarla',
    subTagDataSourceTip: 'Açıldıktan sonra alt etiket oluşturmayı kontrol eden veri kaynakları eklenebilir. Alt etikette bu veri kaynağı varsa ve değeri varsa alt etiket oluşturulur.',
    addSubTagDataSource: 'Veri kaynağı ekle',
    addSubTagDataSourceTip: 'Yinelenen veri kaynağı eklenemez',
    addSubTagDataSourceTip1: 'Lütfen en az bir veri kaynağı ekleyin',
    addSubTagDataSourceTip2: 'Veri kaynağı boş olamaz, lütfen seçin',
    reuseMatchingPlankName: 'Tahta adına göre yeniden kullanım eşleştirme',
    reuseMatchingPlankNameTip1: 'Bu özellik devre dışı bırakıldığında, düzen yeniden kullanımı aynı malzeme, renk, kalınlık, boyutlar, doku ve yüksek parlaklık özelliklerine sahip panelleri eşleştirir',
    reuseMatchingPlankNameTip2: 'Bu özellik etkinleştirildiğinde, yukarıdaki eşleştirme koşullarına ek olarak, tahta adı eşleştirme de eklenir'
    },
  lineManager: {
    add: 'Üretim hattı ekle',
    engraving: 'Kesim ekipmanı',
    holeSlotEquip: 'Delik ve oluk işleme ekipmanı',
    workSetting: 'İşleme ayarları',
    noUse: 'Etkin değil',
    warningTip: '* Dikkat: Aşağıdaki işlevler ayarlandıktan sonra dolap istemci cihaz eşleştirme sayfasında kaydetmeyin; parametre sıfırlanmasını önleyin!',
    engravingSetting: 'Kesim makinesi ayarları',
    workWay: 'İşleme yöntemi',
    cutedSpecial: 'İşlenecek özel delik/oluklar:',
    noWork: 'Bu seçenek beş/altı yüz delik varsayılan şablonunda geçerli değildir',
    onlyCut: 'Yalnızca kesim',
    onlyFrontHoleSlot: 'Yalnızca plakanın ön yüzündeki delik/oluklar işlenir',
    onlyHoleSlot: 'Yalnızca plakanın ön ve arka delik/olukları işlenir',
    sideHoleSetting: 'Yan delik makinesi ayarları',
    cutHoleSlot: 'İşlenen delik ve oluklar',
    minSize: 'Kısa kenar boyutu',
    maxSize: 'Uzun kenar boyutu',
    minSize2: 'mm plakadaki tüm',
    minSize3: 've düzensiz kısımlar',
    onlyFrontHoleSlotTip: 'Dizgi sayfasında yalnızca önde delik/oluk olan küçük plakalar',
    onlyFrontHoleSlotTip2: 'Yan delik/yan oluk dahil değil',
    holeAndSlot: 'Delik ve oluk',
    empty: 'Boş',
    singleHole: 'Tek delik',
    singleSlot: 'Tek oluk',
    diameterRange: 'Delik çap aralığı',
    hDeepRange: 'Delik derinlik aralığı',
    widthRange: 'Oluk genişlik aralığı',
    sDeepRange: 'Oluk derinlik aralığı',
    to: '-e kadar',
    specialHS: 'Özel delik, oluk ve şekiller',
    allowRoll: 'Kesim makinesinin plakayı çevirerek özel delik/oluk işlemesine izin ver',
    engravingPath: 'Kesim makinesinde plaka düzensiz kısımlarının işlenmesi',
    curve_range: 'Düzensiz kısmın uzun kenarı şundan büyük',
    curve_range2: 'plakanın tüm düzensiz kısımları',
    curveArea: 'Düzensiz alan',
    drillSetting: 'Beş/altı yüz delik ayarları',
    engravingCuted: 'Kesim makinesinde işlenmiş delik/oluklar beş/altı yüz delikte',
    engravingCutedSpecial: 'Düzensiz kısımlar işlenmiş kısımlar beş/altı yüz delikte',
    genCuttingPath: 'Kesim verisi oluştur',
    otherCuted: 'Diğer ekipmanın işlediği delik/oluklar beş/altı yüz delikte',
    noGen: 'Oluşturulmaz',
    genCut: 'Oluştur ve işle',
    genNoCut: 'Oluştur ama işleme',
    cutTip: ' Not: Bu seçenek yalnızca özelleştirilmiş beş/altı yüz delik dosyalarında geçerlidir',
    maxShortSize: 'Maksimum kısa kenar boyutu',
    maxLongSize: 'Maksimum uzun kenar boyutu',
    normalSlot: 'Normal oluk',
    specialSlot: 'Özel oluk',
    combinSetting: 'Birleşik ekipman ayarları',
    allowShortSize: 'Kısa kenar boyutuna izin ver',
    equipment1: 'Ekipman 1',
    equipment2: 'Ekipman 2',
    noSameTip: 'Not: İki ekipman aynı seçilemez',
    workRange: 'Ekipman 1 delik/oluk işleme aralığı',
    rangeWarning: 'Not: Yalnızca Ekipman 1 işleme aralığı ayarlanabilir; Ekipman 1 dışındaki tümü Ekipman 2 üzerinde işlenir, dikkatli işlem yapın!',
    deleteWarning: 'Bu üretim hattı silindikten sonra geri yüklenemez (altındaki tüm ayarlar silinir). Silmek istediğinizden emin misiniz?',
    top: 'Üst',
    inputCheck: '{msg} minimum değeri maksimumdan büyük olamaz',
    lockTip: 'Üretim hattı kilitli, işlem yasak!',
    reNameTip: 'Varsayılan üretim hattının adı değiştirilemez',
    permissonTip: 'Kimlik bilgisi süresi doldu; lütfen bu sayfayı dolaptan yeniden açın',
    permissonErr: 'Bu izin yok; lütfen hesap sürümünü yükseltin!',
    permissionOneMacErr: 'Şu anda entegre makine için {idx} üretim hattı kullanabilirsiniz; artırmak için satışla iletişime geçin',
    permissionSawErr: 'Testere/oyma kullanım izniniz yok; tam alüminyum testere kesim ek paketi için satışla iletişime geçin',
    getAuthError: 'Cihaz izinleri alınamadı!',
    sawAddNumber: 'Kullanılabilir elektronik testere üretim hatlarınız doldu; artırmak için satışla iletişime geçin',
    newLine: 'Yeni üretim hattı {idx}',
    deleteCheck: 'Tümünü silmek mümkün değil',
    deving: 'Geliştirme aşamasında',
    combinTip: 'Aşağıdaki birleşik ekipman ayarına tıklayarak yapılandırın',
    noUseEquip: 'İşleme ekipmanı etkin değil',
    equipmentSelectTip: 'Birleşik ekipmanda kesim makinesi seçildiğinde kesim ekipmanı elektronik testere olamaz',
    lineLoading: 'Veri yükleniyor',
    strenchType: 'Düzleştirici oluk tipi',
    aioProcessTip: 'Tüm-bir arada cihazı etkinleştirdiniz; varsayılan işleme plakanın ön ve arka delik/oluklarıdır',
    aioProcessTip2: 'Tüm-bir arada açıldıktan sonra oyma bölümünde işlenen özel delik/oluklar',
    aioProcessTip3: 'Dikkat: Bu işlev XY eksen takası açık oyma makineleriyle uyumlu değildir; dikkatli kullanın',
    specialHoleTip: 'Dikkat: Yukarıdaki özel delik/oluk işlemini kullanırken delikten geçirme ve oluktan geçirme yöntemlerini bir seferde tam delme olacak şekilde ayarlayın',
    specialHoleTip2: 'Dikkat: Yukarıdaki özel delik/oluk işlemini kullanırken oyma makinesinde delikten geçirme ve oluktan geçirme yöntemlerini bir seferde tam delme olacak şekilde ayarlayın',
    fiveSixNotTake: 'Bu seçenek beş/altı yüz delik varsayılan şablonlarında geçerli değildir',
    onlyFrontSide: 'Yalnızca ön yüzü işle',
    onlyBackSide: 'Yalnızca arka yüzü işle',
    less: 'Daha küçük',
    equal: 'Eşittir',
    greater: 'Büyüktür',
    or: 'Veya',
    and: 'Ve',
    bothFrontBack: 'Ön ve arka yüzleri işle',
    shareDataErrTip: 'Bu kayıt {operatorPhone} uygulamasıyla, IP: {actionIp}',
    restoreParams: 'Parametreleri geri yükle',
    loadMore: 'Daha fazla yükle',
    currentCombinationEquipment: 'Birleşik ekipman seçiliyken kesim ekipmanı cam kesim makinesine geçirilemez',
    selectEquipmentType: 'Ekipman türünü seçin',
    ruleRemark: 'Kural notu',
    remarkPlaceholder: 'Kural notu: hangi işlemlerin uygulandığını yazın; unutmamak için. Doldurup üretim hattını kaydedince geçerli olur',
    onlyNoSideHoleSlotSmallPlank: 'Yalnızca yan delik/oluk olmayan küçük plakalar'
    },
  cuttingDock: {
    title: 'Kesim makinesi eşleştirme',
    autoStockCode: 'Otomatik yükleme/boşaltma kodu',
    stationStart: 'İstasyon başlangıcı',
    stationStartCode1: 'İstasyon 1 başlangıç kodu',
    stationStartCode1Placeholder: 'İstasyon 1 başlangıç kodunu girin',
    stationStartCode2: 'İstasyon 2 başlangıç kodu',
    stationStartCode2Placeholder: 'İstasyon 2 başlangıç kodunu girin',
    stationEnd: 'İstasyon bitişi',
    stationEndCode1: 'İstasyon 1 bitiş kodu',
    stationEndCode1Placeholder: 'İstasyon 1 bitiş kodunu girin',
    stationEndCode2: 'İstasyon 2 bitiş kodu',
    stationEndCode2Placeholder: 'İstasyon 2 bitiş kodunu girin',
    frontBackStart: 'Ön-arka başlangıç',
    frontBackEnd: 'Ön-arka bitiş',
    frontStartCode: 'Ön yüz başlangıç kodu',
    frontStartCodePlaceholder: 'Ön yüz başlangıç kodunu girin',
    frontEndCode: 'Ön yüz bitiş kodu',
    frontEndCodePlaceholder: 'Ön yüz bitiş kodunu girin',
    backStartCode: 'Arka yüz başlangıç kodu',
    backStartCodePlaceholder: 'Arka yüz başlangıç kodunu girin',
    backEndCode: 'Arka yüz bitiş kodu',
    backEndCodePlaceholder: 'Arka yüz bitiş kodunu girin',
    plankStart: 'Plaka çevirme başlangıcı',
    plankEnd: 'Plaka çevirme bitişi',
    plankRollCode1: 'İstasyon 1 çevirme kodu',
    plankRollCode1Placeholder: 'İstasyon 1 çevirme kodunu girin',
    plankRollCode2: 'İstasyon 2 çevirme kodu',
    plankRollCode2Placeholder: 'İstasyon 2 çevirme kodunu girin',
    autoBaitingCode: 'Otomatik parça düşürme kodu',
    autoBaitingCode1: 'İstasyon 1 parça düşürme kodu',
    autoBaitingCode1Placeholder: 'İstasyon 1 parça düşürme kodunu girin',
    autoBaitingCode2: 'İstasyon 2 parça düşürme kodu',
    autoBaitingCode2Placeholder: 'İstasyon 2 parça düşürme kodunu girin',
    thickMarkPermission: 'Şu anda Büyük pano kalınlığı işareti izniniz yok, kullanmadan önce satış ile iletişime geçerek satın alın',
    thickMark: 'Büyük pano kalınlığı işareti',
    preStartEquipment: 'Ön başlatma ekipmanı',
    firstKnifePreCode: 'İlk bıçak ön başlatma kodu öne alınır',
    secondKnifePreCode: 'İkinci ve sonraki bıçaklar ön başlatma kodu öne alınır',
    rowInsert: 'Satır ekleme',
    pumpPause: 'Vakum pompası duraklatma',
    pumpPauseTip: 'Dikkat: Tek istasyonlu cihazlarda istasyon 1 ve 2ye aynı otomatik yükleme kodu ve çift taraflı ön yüz not kodunu girin',
    pumpPause2Tip: 'Dikkat: Tek istasyonlu cihazlarda istasyon 1 ve 2ye aynı vakum pompası duraklatma kodunu girin',
    pumpPauseCode1: 'İstasyon 1 vakum pompası duraklatma kodu',
    pumpPauseCode1Placeholder: 'İstasyon 1 vakum duraklatma kodunu girin',
    pumpPauseCode2: 'İstasyon 2 vakum pompası duraklatma kodu',
    pumpPauseCode2Placeholder: 'İstasyon 2 vakum duraklatma kodunu girin',
    annotationCode1: 'İstasyon 1 çift taraflı işleme ön yüz not kodu',
    annotationCode1Tip: 'Otomatik yüklemede ön yüzde farklı komutlar kullanan cihazlar için uygundur',
    annotationCode1Placeholder: 'İstasyon 1 çift taraflı ön yüz not kodunu girin',
    annotationCode2: 'İstasyon 2 çift taraflı işleme ön yüz not kodu',
    annotationCode2Placeholder: 'İstasyon 2 çift taraflı ön yüz not kodunu girin',
    upSpeedTip: 'Ortak kenar hızlanma hızını girin',
    cutThickTip: 'Ortak kenar kesim kalınlığını girin',
    sizeErrTip: 'Lütfen etiketleme makinesinde dışa aktarılan yerleşimin doğru boyutunu ayarlayın!',
    offEdgeKnifeDiameter: 'Kenar düzeltme bıçağı çapını girin',
    slowDownSpeedTip: 'Köşe kesim yavaşlatma parametresi girişi hatalı',
    permissionErr: 'Ücretsiz sürüm; kayıt yapılamaz',
    labellingTempErr: 'Etiket makinesi şablonu seçin',
    autoRollInputTip: 'Etiket otomatik dönüş için geçerli değer girin',
    offlineTempFormat: 'Mevcut etiket dosya biçimi kullanımdan kaldırıldı; onaylayın',
    autoStockCode1: 'İstasyon 1 otomatik yükleme kodu',
    autoStockCode1PlaceHolder: 'İstasyon 1 otomatik yükleme kodunu girin',
    autoStockCode2PlaceHolder: 'İstasyon 2 otomatik yükleme kodunu girin',
    autoStockCode2: 'İstasyon 2 otomatik yükleme kodu',
    pauseCode: 'Duraklatma kodu',
    pauseCodePlaceHolder: 'Duraklatma kodunu girin',
    cuttingToolMaxDepthTip: 'Bıçak kütüphanesindeki {errKey} bıçağının tek seferdeki maksimum işleme derinliği bıçak uzunluğundan büyük olamaz',
    cuttingParams: {
      title: 'Kesim parametreleri',
      stationWidth: 'İş alanı genişliği',
      stationWidthTip: 'Artık büyük levha kullanılırken, genişlik yönünde küçük levhalar yalnızca ayarlanan boyut aralığında yerleştirilebilir',
      holeSlotMainSide: 'Delik ve olukların yoğun olduğu yüz',
      holeMainSide: 'Deliklerin yoğun olduğu yüz',
      slotMainSide: 'Olukların yoğun olduğu yüz',
      workPriority: '(İşlev önceliği: özel delik/oluk işleme yüzeyi özelleştirmesi > delinmiş delik/olukların bulunduğu yüz, küçük plakadaki delinmemiş delik/oluklara göre izler > oluk yönlendirmede ayarlanan özel delik/oluklar büyük plaka ön yüzünde önceliklidir > oluk yoğun yüzü > delik yoğun yüzü)',
      holeSlotSet: 'Delinmiş delik/oluk işleme ayarı',
      hingeRollWork: 'Düzleştirici ve menteşe kovan delikleri büyük plakanın ters yüzünde işlenir',
      followWork: 'Delinmiş delik/oluk yüzü, küçük plakadaki delinmemiş delik/oluklara göre izler',
      autoMatchSide: 'Ön ve arka delik/olukları orantılı dağıt',
      backHSRate: 'Arka yüz delik/oluk oranı',
      matchTip: '(Parlak panel, anormal şekil hesaplamalı yerleşim veya desen eşleştirme açıksa bu ayar geçerli olmaz)',
      specIalHoleAndSlotSurface: 'Özel delik/oluk işleme yüzeyi özelleştirmesi',
      specialRuleTip: 'Lütfen özel delik/oluk seçin',
      specialSlotsHoles: 'Delik ve oluk türü',
      holeType: 'Delik türü',
      specialRules: 'Kural',
      normalHole: 'Geleneksel delik',
      normalSlot: 'Geleneksel oluk',
      holeDiam: 'Delik çapı',
      slotLongSide: 'Oluk uzun kenarı',
      slotShortSide: 'Oluk kısa kenarı',
      FixedmachSurface: 'Sabit işleme yüzeyi',
      deleteRuleTip: 'Bu kural silinsin mi?',
      blankFront: 'Büyük plaka ön yüzü',
      blankBack: 'Büyük plaka arka yüzü',
      addRules: 'Kural ekle',
      addRulesTip: 'Aynı küçük plaka birden çok kurala uyduğunda en küçük geçerli sıra numaralı kural uygulanır; sırayı değiştirmek için satırları sürükleyebilirsiniz',
      highGlossSetting: 'Parlak panel ayarları',
      heighGlossFront: 'Yerleşimde küçük plakanın parlak yüzü büyük plakaya yerleştirilir',
      highGlossPlankNoRotate: 'Parlak yüzlü pano dönmez',
      highGlossAutoRoll: 'Yalnızca arka yüzde delik/oluk olan büyük plakalar otomatik çevrilir',
      highGlossAutoRollTip: "<span class='color-o-4'>(Açıldığında yalnızca arka delik/oluklu büyük plakalar yerleşimde otomatik çevrilir ve tek yüzlü plaka olur. Özel dosya adı verisi «Parlak yüz çevirerek plaka yerleştirme» ile birlikte kullanın)</span>",
      customHighGlossReverse: 'Parlak yüz çevirerek plaka yerleştirme',
      sideSlotPut: 'Kenara yakın plaka oluk yerleşimi',
      optimize: 'İşlev iyileştiriliyor',
      sysDefault: 'Sistem varsayılanı',
      plankInSide: 'Büyük plaka iç taraf',
      plankOutSide: 'Büyük plaka dış taraf',
      specialNotWork: 'Bu işlev anormal şekilli plakalara uygulanmaz',
      commonSide: 'Ortak kenar kesim',
      commonSetting: 'Ortak kenar ayarları',
      plankThickRange: 'Plaka kalınlığı şundan küçük veya eşit',
      useCommonSide: 'Ortak kenar kesimi uygulanır',
      zeroTip: 'Yerleşim aralığını elle 0 yapın; zaten kesilmiş kenara gelindiğinde bıçak kaldırılıp o kenar atlanır. Bu işlev açıkken eğik aşağı inme kesimi desteklenmez!',
      useTip: 'Bu işlev açıldıktan sonra eğik aşağı inme kesimi desteklenmez; dikkat!',
      commonSpeed: 'Ortak kenar hızlandırma',
      highSpeed: 'Yüksek hız süpürme freze hızı',
      min: 'Dakika',
      notWorkTip: 'Plaka işleme ortak kenar kesim koşullarını sağladığında ortak kenar hızlandırma etkisiz olur',
      changeStartPoint: 'Çift istasyon başlangıç noktası değiştirme',
      changeStartPointTip: 'Çift istasyon başlangıç değiştirme açıldığında XY eksen değişimi ile uyumlu değildir; dikkatli kullanın',
      flatOffset: 'Tezgâh düzlemi ofseti',
      xRowChange: 'X ekseni koordinat referansını değiştir',
      bigplankPointChange: 'Büyük plaka arka yüz koordinat referansını değiştir',
      reverseXRowChange: 'X koordinatlarını değiştir',
      changebigplankPointTips: 'Bu işlev açıldığında «XY eksen değişimi» ve «çift istasyon başlangıç değiştirme» ile uyumlu değildir; dikkatli kullanın',
      reverseYRowChange: 'Y koordinatlarını değiştir',
      plankMirrorTip: 'Kesim makinesinde işlenen plakaları aynalarken bu işlevi kullanın',
      notSameSize: 'Çift istasyon tezgâhı farklı boyutlar',
      maxSize1: 'İstasyon 1 maksimum boyutu',
      notSameSizeTip: 'Farklı boyutlu çift istasyon tezgâhı açıldığında çift istasyon dosya birleştirme ile uyumlu değildir; dikkatli kullanın',
      maxSize2: 'İstasyon 2 maksimum boyutu',
      autoSelectTip: 'Çift istasyon cihazında iki tezgâh boyutu farklıyken bu işlev büyük plaka için uygun istasyonu otomatik seçer',
      bigFlatLimit: 'Büyük istasyon yalnızca küçük istasyonun işleyemediği büyük plakaları işler:',
      surplusSetting: 'Artık malzeme ayarları',
      surplusPosition: 'Artık malzeme yerleşim konumu',
      cutHoleWay: 'Kesim ve delme yöntemi',
      knifeFlat: 'Bıçak referans düzlemi',
      flat: 'Tezgâh yüzeyi',
      plankFlat: 'Büyük plaka yüzeyi',
      freeHeightZ: 'Boşta Z yüksekliği',
      relativeHeight: 'Büyük plaka üst yüzeyine göre göreli yükseklik',
      cutDeepZ: 'Tam kesim Z derinliği',
      cutDeepH: 'Delikten geçirme delme yöntemi',
      setDisableDoubleSidedThroughHole: 'Çift taraflı iki kez çevirerek delikten geçirmeyi devre dışı bırak (ayar)',
      addHolesToRulesDisableDoubleSided: 'Karşılık gelen delik geçişlerini (delinen delikler) aşağıdaki kurallara ekledikten sonra, iki kez çevirerek delikten geçirme uygulanmaz',
      onceThrough: 'Tek seferde delikten geçir',
      rollThrough: 'İki kez çevirerek delikten geçir',
      cutDeepS: 'Oluk delikten geçirme yöntemi',
      plankCutDirection: 'Küçük plaka kesim yönü',
      clockDirSwitch: 'Özel freze delik/oluk ve iç profil kesim yönü',
      millHoleSlotDir: 'Freze delik/oluk yönü',
      millInternalCurveDir: 'İç profil kesim yönü',
      sDirection: 'Saat yönü',
      nDirection: 'Saat yönünün tersi',
      curveReplenish: 'Yay enterpolasyon komutu ile yay şekilli plaka kesimi',
      curveReplenishTip: 'Yay şekilli plaka kesiminde tırtıklanma olursa bu işlevi seçin',
      noGen: 'G17/G18/G19 düzlem komutları üretme',
      arcInstruction: 'Yay işleme komutu öneki',
      example: 'Örnek',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'Yay kesimi I ve J ile gösterilir',
      coverRate: 'Oluk frezelenirken kesim örtüşme oranı:',
      roughTip: 'Takım oluk frezelenirken oluk içinde tırnak/burrs kalırsa bu işlevi kullanın',
      clearCurve: 'Freze oluk sırasında tam açılmamış oluklarda köşeleri otomatik temizle:',
      curveUseTip: 'Oluk frezelenirken köşe temizliği gerekiyorsa bu işlevi seçin; bağlantı parçalarına uygulanmaz',
      slotCutWay: 'Oluk freze kesim yolu',
      outToIn: 'Dıştan içe oluk frezele',
      inToOut: 'İçten dışa oluk frezele',
      zShapProcess: 'Geçiş olukta üst-alt Z şeklinde freze',
      zShapProcessTip: 'Yalnızca önden-arkadan çekilerek açılan geçiş oluk frezelemede geçerlidir; takım yolu örtüşmesi varsayılan olarak takım yarıçapıdır',
      zSlotCuttingOverlapRate: 'Z şekilli oluk kesim örtüşme oranı',
      zSlotCuttingOverlapRateTip: 'Mevcut örtüşme oranı işlem hızını düşürebilir; makineyi denedikten sonra işleyin',
      slotWorkLimit: '(Yalnızca oluk kesim katman sayısı>1 iken geçerli)',
      minKnifeChange: 'İşlemde kesim kırılması azaltma',
      preventBreakage: 'Kenar oluk ayırıcı kırılma önleme',
      preventBreakageTip: 'Bu ayar yalnızca yerleştirme sırasında ön yüzde bulunan oluklar için geçerlidir ve "Özel delik/oluk işleme yüzeyi özelleştirmesi" işleviyle birlikte kullanılabilir',
      preventBreakageTip1: 'Oluk panel kenarına çok yakın olduğunda, kesim sırasında bu konumdaki ayırıcı çubuğun (kalan bağlantı kısmının) gerilim yoğunlaşması nedeniyle kolayca kırılması sorununu çözebilir',
      preventBreakageDistance: 'Panel kenarından mesafe',
      preventBreakageLength: 'Kenara yakın bölüm uzunluğu',
      preventBreakageSlot: 'oluklar',
      preventBreakageCutDeep: 'İlk kesim derinliği',
      workSpeedOp: 'İşlem hızı optimizasyonu',
      obliqueCut: 'Kesimde eğik aşağı inme',
      obliqueCutTip: 'Eğik aşağı inme hızı optimizasyonu',
      obliqueThickLabel: 'Özel eğik aşağı inme etkili levha kalınlığı',
      obliqueThick: 'Eğik aşağı inme hızı optimizasyonu',
      backObliqueThick: 'Eğik aşağı inme hızı optimizasyonu',
      effectiveThickness: 'Eğik aşağı inme hızı optimizasyonu',
      effectiveThicknessTip: 'Eğik aşağı inme hızı optimizasyonu boş olamaz, lütfen giriniz!',
      effectiveThicknessDuplicateTip: 'Etkin kalınlık tekrarlanamaz, lütfen düzenleyin',
      obliqueCutData: 'Eğik aşağı inme mesafesi',
      backOblique: 'Arka yüz kenar düzeltmede eğik aşağı inme',
      obliqueSpeed: 'Eğik aşağı inme hızı',
      obliqueSpeedTip: 'Eğik aşağı inme hızı',
      arcSpeed: 'Eğri işleme hızı',
      cuttingPreDistance: 'Kesimden önce bıçak öne alma mesafesi',
      backKnife: 'Kesimde bıçak çekme yavaşlatma',
      openKnifeSpeed: 'Bıçak çekme hızı',
      retractionCompensation: 'Kesim bıçak çekme mesafesi telafisi',
      retractionCompensationTip: 'Maksimum değer 20',
      cutCornerSlow: 'Kesim köşesinde yavaşlatma',
      addRow: 'Satır ekle',
      bettwenDistance: 'Köşe öncesi ve sonrası mesafe',
      cuttingSpeed: 'Kesim hızı',
      stepCutting: 'Katmanlı kesim',
      splitSlot: 'Oluk iki aşamada kesilir',
      splitPlank: 'küçük plakayı iki kez kes',
      splitPlank2: 'Küçük plakayı iki kez kes',
      minSafeThick: 'Kalınlık şundan büyük',
      splitPlankTip: '(Anormal şekilli plakalarda bu işlev geçerli değildir)',
      splitPlankTip2: '(Uyumsuz: Kesim bıçak çekme ödemesi)',
      cutPlankMethod: 'Küçük plakayı iki kez kes',
      cutPlankMethodTip: 'Dört tarafı iki kez kes',
      cutPlankMethodTip2: 'Son kenardan bir kez ve iki kez kes',
      specialShapCut: 'Anormal şekilli plaka iki kez kesilir',
      specialShapCutTip: '(Açıldığında tüm anormal şekilli plakalar iki kez kesilir)',
      bridgeRetention: 'Köprü tutma noktası yöntemi',
      bridgeRetentionTip: '(Not: 1. Bu özellik geçici olarak dış anormal şekilli panoları desteklemez. 2. Eğik aşağı kesimi desteklemez. 3. Bağlantı köprüsü oluşturmak için parça minimum boyutu 30mm.)',
      bridgeRetentionDesc: 'Levha içinde çok sayıda oyuk alan varken kesim yolu yeterli destek alamadığında levhanın titremesi veya kayması sorununu çözmeye yardımcı olur.',
      bridgePunchArea: 'Delinen kısım toplam alanı aşıyor',
      bridgeSize: 'Köprü boyutu',
      bridgeGenMethod: 'Oluşturma yöntemi',
      bridgeAddTip: 'En fazla 10 veri ekleyebilirsiniz',
      bridgeCount: 'Köprü sayısı',
      bridgePlankLength: 'Levha uzunluğu (L)',
      maxWH: 'Uzunluk veya genişlik şundan küçük',
      areaLimit: 've alan şundan küçük',
      secondDeep: 'İkinci kesim derinliği',
      splitPlankThickSetting: 'Ham kesim katmanlı kesim ayarları',
      saveCustomSpeedTip: 'İşlem hızı boş olamaz',
      saveLayeredCuttingTip: 'Üç katmanlı kesimlerin toplamı plaka kalınlığına eşit olmalıdır',
      saveLayeredRepeatTip: 'Aynı malzeme için parlak özellik kalınlığında farklı katman verileri önerilmez; fazla verileri silin!',
      splitPlankThick: 'Farklı kalınlıkta katmanlı kesim',
      movePlankSetting: 'Plaka kayması önleme ayarları',
      newCutSequence: 'Yeni kesim algoritması',
      newCutSequenceText: 'Varsayılan olarak büyük plakanın merkezinde vakum çekişi en güçlüdür; bu bölgedeki küçük plakalar en son kesilir',
      positionTip: 'İlgili alana tıklayarak seçim yapabilirsiniz',
      suctionPosition: 'Güçlü vakum çekiş konumu',
      strongArea: 'Güçlü çekiş bölgesi',
      minSuctionPlank: 'Tutulabilen minimum plaka',
      safeWidth: 'Genişlik',
      safeHeight: 'Uzunluk',
      safeTip: 'Tutulamayan plakalar önce kesilir',
      scattered_layout: 'Küçük plakalar dağıtık yerleşim',
      lastCutPointEnable: 'Büyük plakadaki son kesilen küçük plaka kesim noktası özelleştirme',
      lastCutPointEnableTip: 'Etkinleştirildiğinde, her büyük plakadaki son kesilen küçük plakanın kesim noktası, ayarlanan nokta konumuna göre oluşturulacaktır',
      lastCutPoint: 'Kesim noktası konumu',
      lastCutPointTip: 'Etkinleştirildiğinde, her büyük plakadaki son kesilen küçük plaka bu kesim noktasını kullanacaktır',
      leftTop: 'Sol üst',
      rightTop: 'Sağ üst',
      leftBottom: 'Sol alt',
      rightBottom: 'Sağ alt',
      specifyTheMaterial: 'Malzemeyi belirt',
      shapeSecondCutenable: 'Anormal plaka ikinci kesim',
      addMaterial: 'Malzeme ekle',
      plankMaterial: 'Plaka malzemesi',
      specifyTheMaterialTip: 'Açıldığında yalnızca tablodaki malzeme koşulunu sağlayan plakalarda ikinci kesim uygulanır',
      dispersePaibanTipOne: '1. Açıldığında her büyük plakada en az bir adet minimum tutulabilir boyutu sağlayan plaka yerleştirilir',
      dispersePaibanTipTwo: '2. Kullanımdan sonra büyük plaka miktarı artabilir; dikkat',
      totalThickLimit: 'Üç katmanlı kesimlerin toplamı plaka kalınlığına eşit olmalıdır',
      offsetFollowStep: 'Kenar düzeltme de katmanlı kesimi izler',
      longPlankTip1: '1. Bu işlev açılıp kapatıldıktan sonra geçmişte kayıtlı yerleşim kayıtları NC indirilirken yeniden yerleştirilmelidir',
      longPlankTip2: '2. Bu işlev açıldıktan sonra [Kesim makinesi eşleştirme - Vakum pompası duraklatma] bölümünde vakum duraklatma kodu ayarlanmalıdır; aksi halde uzun plaka eğilmesi giderilemez',
      longPlankTip3: '3. Aşağıda etkin filtre koşulları seviye seviye sırayla doğrulanır; yalnızca bir önceki seviyenin filtre koşullarını karşılayan plakalar, bir sonraki seviyenin filtre koşullarına geçerek değerlendirilir.',
      secondCutting: 'İkinci kesim hedefi',
      normalPlank: 'standart plaka',
      normalPlankTip: 'Standart plaka: gövdede yatay/dikey bölmeler gibi dolap kapısı olmayan parçalar ve kesim listesine doğrudan eklenen plakalar',
      designatedTarget: 'Belirlenen nesneler',
      filterLevel1Label: '1. seviye filtre',
      filterLevel1Category: 'plaka tipi',
      filterLevel2Label: '2. seviye filtre',
      filterLevel2Category: 'boyut sınırı',
      filterLevel3Label: '3. seviye filtre',
      filterLevel3Category: 'diğer',
      specifiedBoardForceEnable: 'Boyut/diğer filtreleri yoksay, zorla etkinleştir',
      curveMaterialFilterTip: '("Düzensiz plaka" işaretlendikten sonra malzeme filtresinden önce düzensiz plaka olmalı)',
      cuttingSettings: 'Kesim ayarları',
      plankSizeLimitSuffix: ' plakalar',
      specifiedBoard: 'Plaka adına göre kesim',
      specifiedBoardTip: 'Açıldığında plaka adı aşağıya eklenen adı içeriyorsa ikinci kesim uygulanır',
      addPlankName: 'Plaka adı ekle',
      plankNameEmpty: 'Plaka adı boş olamaz; girin',
      plankNameRequired: 'En az bir plaka adı ekleyin',
      plankLongLimit: 'Uzun plakanın uzun kenarı şunu aştığında',
      plankShortLimit: 'Kısa kenar şunu aştığında',
      cuttingSplit: 'İki aşamada kes',
      longExpand: 'İlk kesim payı: uzun kenar payı',
      firstExpand: 'İlk kesim payı',
      longExpandTip: 'Uzun kenar payı',
      longLimit: 'Uzun kenar şunu aştığında',
      cuttingSplitTip: 'Uzun plaka iki aşamada kesim koşulu',
      shortExpand: 'Kısa kenar payı',
      expandTip: 'Uzun/kısa kenar boyutlarına her biri X mm eklenir; anormal uzun plakada kısa ve uzun kenar payı uzun kenar payı değeridir',
      pumpOffWay: 'Vakum kapatma yöntemi',
      afterOnePlank: 'Tek uzun plaka kesildikten sonra',
      afterAllPlank: 'Tüm büyük plaka kesildikten sonra',
      numberFixed: 'Ondalık basamak sayısı',
      bufferCode: 'Bıçak inişi tampon komutu ayarı',
      layoutGap: 'Yerleşim aralığı ayarı',
      layoutGapTip: 'Dikkat: Yerleşim aralığı 0 yapılırsa yerleşim üst üste binebilir',
      wasteCutting: 'Atık otomatik kesim',
      zkPointCustomize: 'Z kilit eğik delik işleme dönüş referans noktası özelleştirme',
      sawSetting: 'Testere kesim ayarları',
      cuttingLimit: 'Kesim boyutu şundan büyük',
      waste: 'atık',
      wasteSizeLimit: 'Minimum boyut 100 mm’den küçük olamaz',
      topLeft: 'Sol, üst',
      topLeftD: 'Sol üst köşe',
      bottomLeft: 'Sol, alt',
      bottomLeftD: 'Sol alt köşe',
      topRight: 'Sağ, üst',
      topRightD: 'Sağ üst köşe',
      bottomRight: 'Sağ, alt',
      bottomRightD: 'Sağ alt köşe',
      firstTime: 'Birinci',
      secondTime: 'İkinci',
      thirdTime: 'Üçüncü',
      startCutting: 'Kesim başladı',
      thickRange: 'Kalınlık ≥',
      longCut: 'Uzun plaka işleme',
      edgeSetting: 'Kenar düzeltme ayarları',
      cuttingOrder: 'Kesim sırası:',
      cuttingOrderTip: 'Bu yöntemde plaka kayması riski vardır; dikkatli kullanın',
      plankFirst: 'Önce küçük plakaları kes',
      wasteFirst: 'Önce atığı kes',
      offTip: 'Kapalıyken kesim parametrelerindeki kenar düzeltme ayarlarını izler',
      edgeCutDirection: 'Kenar düzeltme yönü',
      lGapTip: 'L şeklinde artık malzeme büyük plakadaki boşluk konumu, parlak artık hariç, konumlama silindirinin çapraz yönünde otomatik ayarlanır; xy eksen değişimi ile uyumlu değildir',
      cylinderDir: 'Konumlama silindiri yönü',
      onlyLong: 'Yalnızca uzun kenarı düzelt',
      backCutOrder: 'Arka yüz kenar düzeltme sırası',
      backFirst: 'Önce arka yüzü düzelt',
      backSecond: 'Arka delik/oluk işlendikten sonra kenar düzelt',
      frontReCut: 'Ön yüzü yeniden düzelt',
      frontReCutTip: 'Konumlama silindiri kenarını daha pürüzsüz yapmak ve iz bırakmayı önlemek için',
      useNewCut: 'Yeni kenar düzeltme kurallarını kullan',
      newCutTip: 'Çift taraflı büyük plaka işlemde ön yüzde ek bir kenar payı gerektiğinde bu işlevi kullanın',
      fixedTip: 'Dikkat: Ondalık basamak 0 veya 1 tutulursa yerleşim üst üste binebilir',
      cuttingSlow: 'Kesilen parçaların yüzeyinde tampon',
      holeSlow: 'Delinen parçaların yüzeyinde tampon',
      slotSlow: 'Oluk / freze deliği / freze oluk parçalarının yüzeyinde tampon',
      slowCode: 'Tampon komutlarının kullanımı',
      code: 'Komut',
      bufferOffset: 'Parça yüzeyi tampon yüksekliği ofseti',
      zkRotatePoint: 'Döndürme referans noktası',
      zkRotateDir: 'Dönüş açısı artış yönü',
      restSizeLimit: 'Kalan boyut şundan küçük',
      useSaw: 'Testere bıçağı kullan',
      unGenSawPath: 'Boyuna testere kesim yolu oluşturma',
      suitMachine: 'Tam alüminyum kaynaklı plaka işlemeye uygundur',
      plankBack: 'Büyük levhın arka tarafı',
      plankLeft: 'Büyük levhın sol tarafı',
      plankRight: 'Büyük levhın sağ tarafı',
      plankFront: 'Büyük levhın ön tarafı',
      frontSide: 'Ön taraf',
      backSide: 'Arka taraf',
      rightSide: 'Sağ taraf',
      leftSide: 'Sol taraf',
      singleMachineLimit: 'Tek yüz işlenmiş plakaların önünde kenar düzeltme yolu oluştur ve önce kenar düzelt',
      singleMachineLimitTip: 'Bu işlev entegre makineler veya testere bıçağı kesimi için geçerli değildir',
      setBatchPositionWaring: 'İpucu: Kesim noktası hızlı değiştirme modunu iptal etmek için sağdaki «Kesim Noktasını Değiştir» kutusunun işaretini kaldırın',
      setBatchPosition: 'Kesim noktalarını toplu değiştir',
      setBatchPositionAs: 'Kesim yönünü şu şekilde değiştir:',
      activeBatchPosition: '{activePartCount} küçük levh seçildi',
      specialFrontSide: 'Oluk yönlendirmede ayarlanan özel oluklar büyük levhın ön yüzünde önceliklidir',
      rollCountTip: 'Oluk yönlendirme açıldıktan sonra oyma makinesinde gerçekten işlenen arka yüz oluklarına göre çevirme sayısını hesaplayın',
      specialFrontSideTip: 'Mevcut üretim hattı, oluk yönlendirmede büyük levhın önünde özel oluklara öncelik verme veya oluk yönlendirme açıldıktan sonra oyma makinesindeki gerçek arka yüz oluk işlemesine göre çevirme sayısını hesaplama işlevlerinden biri etkin olduğu için hat değiştirmeyi desteklemez',
      doubleTrim: 'Çift taraflı panel kenar düzeltme',
      trim: 'Kenar düzeltme',
      trimTwoSide: 'İki kenarı düzelt',
      trimFourSide: 'Dört kenarı düzelt',
      rightInmShow: 'Sağdaki şekilde gösterildiği gibi',
      currentTrimDir: 'Şu anda seçili kenar düzeltme yönü için',
      cylinderTip: 'silindiri konumlandırmak için',
      onlyShort: 'Yalnızca kısa kenarları düzelt',
      singleTrim: 'Tek panel kenar düzeltme yolu oluştur',
      hierarchyCutTwice: 'Oluk frezelemeye göre katmanlı kesim',
      knifeDia: 'Bıçak çapı şuna eşit veya daha küçük',
      slotDeep: 've oluk derinliği şuna eşit veya daha büyük',
      cutTwiceSlot: 'olduğunda, olukta katmanlı kesim',
      twiceSlotDeep: 'İkinci katman kesim derinliği',
      cutTwiceCondition: 'Kesim koşulları',
      zkPointCustomizeTip: 'XY eksen takasını etkinleştirmek işleme yönünü ve referans noktasını tersine çevirir',
      zkPointCustomizeTip1: 'XY eksen takası açık olan cihazlarda bu işlev çalışmaz',
      isCustom: 'Özelleştirmeyi etkinleştir',
      useCutCon: 'Testere kesim koşullarını kullan',
      singleSetPlankSizeSpeed: 'Belirli levha boyutu aralığı için işleme hızını ayarla',
      singleSetPlankSizeSpeedTip: '(1. Aşağıdaki boyut ayarlarını sağlayan küçük levh belirtilen hızda işlenir. 2. Küçük levha aynı anda birden çok kuralı sağlarsa, daha erken sıra numaralı kural geçerlidir. 3. Bu özellik testere bıçağı kesimi için geçerli değildir.)',
      addSpeedRules: 'Kural ekle',
      speedRules: 'Kural',
      shortSideSize: 'Kısa kenar boyutu',
      lessThanEqual: 'Küçük veya eşit',
      and: 'Ve',
      longSideSize: 'Uzun kenar boyutu',
      processingSpeed: 'İşleme hızı',
      trimLenCompensation: 'Kenar düzeltme uzunluk telafisi:',
      trimGenerateAPath: 'Kenar düzeltme değeri 0 yol oluşturmaz:',
      cuttingMethod: 'Kesim yöntemi',
      horizontalCutting: 'Yatay kesim',
      verticalCutting: 'Dikey kesim',
      openKnifeDistance: 'Panoya eklemek için pano barkodunu girin'
      },
    labelingSettings: {
      title: 'Etiket ayarları',
      output: 'Otomatik etiket dosyasını dışa aktar',
      specification: 'Etiket dosya biçimi',
      codeFrontGenerate: 'Etiket kodundan önce besleme kodunu otomatik oluştur',
      templateOffline: 'Kullanılan şablon çevrimdışı!',
      templateNotSupport: 'Bu şablon desteklenmiyor, lütfen yeniden seçin!',
      rollLabelling: 'Çevirmeli etiketleme ayarları',
      flipSetting: {
        title: 'Çevirme ayarları',
        engravingFlipProcess: 'Oyma makinesi çevirmeli işleme etiket modunu etkinleştir',
        flipTip: 'Oyma makinesinin işlem için çevrilmesi gerektiğinde bu işlevi etkinleştirin'
        },
      rotateSetting: {
        title: 'Etiket döndürme ayarları',
        rotateTip: 'Levha genişliği veya yüksekliği ayarlanan değerden küçük olduğunda etiket saat yönünde 90° döner',
        horizontal: 'Levha genişliği',
        vertical: 'Levha yüksekliği',
        either: 'Levha genişliği VEYA yüksekliği'
        },
      countertopSetting: {
        title: 'Tezgah ayarları',
        startPoint: 'İstasyon başlangıç noktası:',
        upLeft: 'Sol üst',
        upRight: 'Sağ üst',
        downLeft: 'Sol alt',
        downRight: 'Sağ alt',
        baseExchange: 'Koordinat tabanı değişimi:',
        exchangeX: 'X ekseni değişimi',
        exchangeY: 'Y ekseni değişimi'
        },
      offset: 'Etiket koordinat ofseti',
      offsetTip: 'Genellikle etiket koordinatı küçük levhın merkezindedir; bazı cihazlarda ayar gerekir',
      label_rotate_offset: 'Döndürmeden sonra etiket koordinat ofseti',
      label_rotate_offset_tip: 'Döndürme öncesi ve sonrası ofset konumu belirgin şekilde farklıysa ayarlayın',
      label_rotate_offset_err_tip: 'Etiket döndürme koordinat ofseti açıldığında X ve Y ekseni koordinat ofsetleri zorunludur',
      imgSetting: {
        title: 'Etiket görseli ayarları',
        suffix: 'Etiket görseli son eki:',
        code: 'Görüntü kodlama yöntemi:',
        codeTip: 'Png ve jpeg düzen görüntüsü kodlama biçimini eşzamanlı değiştirir; gömülü bulut düzeni bu özelliği desteklemez',
        imgRatio: 'Etiket görseli çözünürlüğü:',
        slowDown: 'Etiket görüntülerini dışa aktarma verimini düşürür',
        color: 'Gerçek renk',
        bit: 'Siyah beyaz',
        resolution: 'Etiket görüntüsü çözünürlüğü',
        resolutionPlaceholder: 'Çözünürlük',
        labelPool: 'Veri etiket havuzu',
        showKey: 'Alanları göster',
        dragTip: 'Etiket havuzundaki etiketleri sürükleyip bırakabilirsiniz',
        labelImgName: 'Etiket görseli adı',
        labelImgNameErrTip: 'Etiket görseli adı boş olamaz',
        labelTip1: 'Özelleştirirken [Levha Barkodu] veya [Etiket Sıra Numarası] değerlerinden biri kullanılmalıdır, aksi halde görüntü üst üste binme sorunları olabilir',
        labelTip3: '【Etiket Sıra Numarası】, kesim listesinden yukarıdan aşağıya doğru olan dizin numarasıdır, ve düzenleme sayfasına eklenen küçük levha bu veriye sahip değildir',
        labelTip2: '3. Bu özellik etiketleme makinesi sistem şablonu için geçerli değildir',
        delimiter: 'Ayırıcı:',
        inputTip: '/ : ? < > | . ” * gibi karakterlerin girilmesi desteklenmez',
        numStart: 'Etiket sıra numarası başlangıç değeri',
        example: 'Özel etiket görseli adı (örnek)',
        stockNumOffset: 'Büyük levha seri numarası telafi basamak sayısına',
        divideFolders: 'Etiket görsellerini büyük levhaya göre farklı klasörlere ayır',
        foldersTip1: 'Dikkat: 1. Bu özellik Malzeme Kesim Makinesi Dosyalarını Birleştir özelliği ile birlikte kullanılamaz',
        foldersTip2: '2. Bu özellik gömülü bulut düzeni için henüz geçerli değildir',
        stickIntoFolders: 'Etiketleme dosyalarını ilgili büyük levhın etiket görseli klasörlerine ekleyin:',
        stickTip1: 'Dikkat: 1. Bu özellik NC İndirirken Etiketleri Dışa Aktar özelliği ile birlikte kullanılmalıdır',
        stickTip2: '2. Özellik yalnızca kullanılan etiket şablonunda dosya oluşturma kuralı Tek Dosya Oluştur seçildiğinde geçerlidir',
        stickTip3: '3. Bu özellik gömülü bulut düzeni için henüz geçerli değildir'
        },
      paibanImgSetting: {
        title: 'Düzen görüntüsü ayarları',
        tip: 'Özel düzen görüntüsü dışa aktarma açık; aşağıdaki sablon dışa aktarılamaz. Dışa aktarmak için düzen sayfasında daha fazla ayarlardan özel düzen dışa aktarmayı kapatın',
        reparation: 'Düzen görüntüsü sıra numarası otomatik telafisi',
        figure: 'Basamak',
        inputTip: 'Lütfen 1-99 arası bir sayı girin',
        paibanImg: {
          export: 'Düzen görüntüsünü dışa aktar',
          prefix: 'Düzen görüntüsü adı öneki',
          size: 'Düzen görüntüsü boyutu',
          format: 'Düzen görüntüsü biçimi',
          directional: 'Düzen yönü',
          vertical: 'Dikey',
          horizontal: 'Yatay'
          }
        },
      autolabel: 'Otomatik etiketleme sırası ayarı',
      customTemp: 'Yalnızca özel şablonlar için geçerlidir',
      cuttingLabelOder: 'Kesim sırasına göre etiketleme',
      labelToUp: 'Düzen sonucuna göre alttan üste etiketleme',
      labelToDown: 'Düzen sonucuna göre üstten alta etiketleme',
      labelDodge: 'Otomatik etiket kaçınma',
      nolabelForsurplus: 'Kalan malzeme levhası için etiket dosyası oluşturulmaz',
      settingValue: 'Ayar değerini seç',
      enabelTip: 'Açıldığında küçük levha aşağıdaki değerleri sağlarsa etiket döner',
      fixedHori: 'Etiket yatay kenarını küçük levhın sabit kenarına paralel seç',
      fixedHoriTip: 'Yalnızca dokusuz küçük levhalar için geçerlidir. Açıkken etiketlemede etiket yatay kenarı küçük levhın sabit kenarıyla hizalanacak şekilde döner',
      tagHori: 'Etiket yatay kenarı',
      effectiveTarget: 'Geçerlilik hedefi',
      allPlank: 'Tüm küçük levhalar',
      notcarePlank: 'Yalnızca dokusuz levhalar'
      },
    drillSettings: {
      title: 'Sıra matkap ayarları',
      enable: 'Sıra matkap paketini etkinleştir',
      toolTable: {
        use: 'Etkinleştir',
        number2: 'İstasyon 2 sıra matkap numarası',
        number: 'Sıra matkap numarası',
        diameter: 'Matkap ucu çapı',
        xOffset: 'X ofseti',
        yOffset: 'Y ofseti',
        moveZF: 'Z ekseni hızlı hareket hızı',
        feedRate: 'Z ekseni işleme hızı',
        moveF: 'XY ekseni hızlı hareket hızı',
        benchmarkDrill: 'Referans matkap',
        addKnife: 'Takım ekle',
        deleteKnife: 'Takımı sil'
        },
      prefix: 'Sıra matkap öneki',
      suffix: 'Sıra matkap son eki',
      startCode: 'Sıra matkap başlangıç kodu',
      endCode: 'Sıra matkap bitiş kodu',
      combineKnife: 'Birleşik sıra matkap kesimi',
      combineTable: {
        prefix: 'Sıra matkap numarası öneki',
        suffix: 'Sıra matkap numarası son eki',
        mainHole: 'Ana delik',
        extraHole: 'Yan delik',
        notes: 'Birleşik notlar',
        firstUseNotes: 'İlk kullanım notları',
        addExtraHole: 'Yan delik ekle',
        deleteExtraHole: 'Yan deliği sil',
        example: 'Örnek'
        },
      tagPool: {
        drillRowNumber: 'Sıra matkap numarası'
        },
      processSetting: {
        title: 'İşleme ayarları',
        mode: 'Sıra matkap işleme modu',
        processTip: 'Bu mod seçildiğinde birleşik sıra matkap kesimi özelliği geçerli olmaz',
        recentHole: 'Yakındaki delikleri del (hızlı takım değişimi)',
        groupHole: 'Kategoriye göre del (bir kategori bitince takım değiştir)',
        drill_benchmark: 'Birleşik kesim referansı',
        drill_benchmark_Tip: '(Dikkat: Bu yöntem seçildiğinde birleşik sıra matkap kesimi özelliği geçerli olmaz)',
        mainHole: 'Ana delik',
        secondaryHole: 'Yan delik (kuyruk deliği)'
        },
      changeBenchDrillTip: 'Bu seçimi yapmadan önce sıra matkap numarasını girin'
      },
    NCExportSettings: {
      jumpSkipTip2: 'Büyük levha rengi, kalınlığı ve malzemesine göre farklı klasörlere ayırın (etiket dosyaları dahil); aynı boyuttaki büyük levhaların kesim dosyalarını aynı klasöre koyun',
      title: 'NC dışa aktarma ayarları',
      tab1: 'Kesim makinesi dosya adı ayarları',
      tab2: 'Kesim makinesi dosya adı birleştirme',
      tab3: 'Kesim makinesi dosyasındaki yorumlar',
      tab4: 'Kesim makinesi dosyasındaki türler',
      tab5: 'Kesim makinesi klasörleri',
      tab6: 'İşleme komutu ayarları',
      tab7: 'Dosya biçimi ayarları',
      fileNameSettings: {
        twoStationAutoSort: 'Çift istasyon otomatik sıralama',
        reparation: 'Panel seri numarası basamak telafisi',
        figure: 'Basamak',
        labelerBegin: 'Etiket makinesi öneki',
        machineCenter: 'İşleme merkezi öneki',
        front: 'Ön yüz:',
        back: 'Arka yüz:',
        customizeName: 'Özel dosya adı (biçim):',
        example: 'Özel dosya adı (örnek):',
        emptyTip: 'Ön ve arka dosya tanımlayıcıları aynı anda boş olamaz',
        labelPool: 'Veri etiket havuzu',
        dragTip: 'Etiket havuzundaki etiketleri sürükleyerek veya tıklayarak kopyalayıp giriş kutusuna yapıştırabilirsiniz'
        },
      fileMerge: {
        engravingMerge: 'Kesim makinesi dosyalarını birleştir',
        zfMerge: 'Ön ve arka yüz birleştirme',
        singleMerge: 'Tek istasyon birleştirme',
        doubleMerge: 'Çift istasyon birleştirme',
        fEndCode: 'Arka yüz bitiş kodu',
        zBeginCode: 'Ön yüz başlangıç kodu',
        displayfbInfo: 'Dosya adında ön ve arka yüz bilgisini göster',
        fBeginCode: 'Arka yüz başlangıç kodu',
        zEndCode: 'Ön yüz bitiş kodu'
        },
      marginalNotes: {
        addPlankInfo: 'Kesim dosyasının başına geçerli büyük levha bilgisini ekle:',
        plankInfo: 'Levha bilgisi:',
        addStationCodeFirst: 'Kesim dosyasının başına istasyon kodu ekle:',
        addStationCodeSecond: 'Kesim dosyasında takım değişiminden önce istasyon kodu ekle:'
        },
      fileType: {
        zAddtion: 'Z ekseni eki:',
        addSemicolon: 'Her NC satırının sonuna noktalı virgül ekle:',
        semicolonTip: 'İşaretlendiğinde boynuz kulplu parçaların işleme dosyaları için de geçerlidir',
        fileName: 'Dosya adı',
        defaultName: 'Varsayılan dosya adı',
        dedicatedName: 'Xinghui ekipmanına özel dosya adı',
        xhNotes: 'Xinghui E2-9 notları',
        format: 'Oyma makinesi çıktı dosya biçimi',
        example: 'Dosya örneği: NC dosyası',
        stillGenerate: 'Arka yüz işlenmese bile arka bitiş kodunu içeren arka NC dosyasını oluştur',
        generateTip: 'Bu özellik dosya birleştirme ile birlikte kullanılamaz',
        fileNameErrTip: 'Dosya adları şu karakterleri içeremez: / : * ? "'
        },
      categorize: 'Levha rengi, malzeme ve kalınlığına göre farklı klasörlere ayırın (etiket dosyaları dahil):',
      simplifyG: 'G kodu komutlarını kısalt',
      ZToW: 'Kodu Z ekseninden W eksenine değiştir',
      knives: 'Sıra matkap takımları',
      lineBreakSetting: 'Satır sonu biçimi ayarları',
      codeFormatSetting: 'Dosya kodlama biçimi ayarları',
      utf8bom: 'BOM içeren UTF-8',
      oneCodeSetting: 'Levha barkod ayarları',
      simplifyOneCode: 'Basitleştirilmiş biçimde etiket barkodu oluştur',
      codeLocation: 'Kod konumu ayarları',
      generateLocation: 'İstasyon bitiş kodu, arka yüz bitiş kodundan önce oluşturulur',
      emergencySetting: 'Acil durum ayarları',
      show: 'Acil durum ayarlarını göster',
      emergencyCode: 'Acil kod',
      params: 'Parametreler',
      emergencyTip: 'Satış sonrası personel iş birliğiyle bazı niş özellikler geçici olarak uygulanabilir',
      holeSetting: 'Delik delme dosyası ayarları',
      holeFileCategorize: 'Delik dosyalarını farklı siparişlere göre ayrı klasörlere yerleştir',
      holeTip: 'Gömülü dolap istemcisinin bulut düzeninde geçerli değildir',
      specialCodeErr: 'Özel karakter girişi desteklenmez!',
      copySuccess: 'Kopyalama başarılı!',
      copyErr: 'Kopyalama başarısız, etiketi sürüklemeyi deneyin!',
      lengthLimit: 'Yalnızca 15 karakter girişi desteklenir!',
      plankInfo: 'Levha bilgisi',
      otherInfo: 'Diğer bilgiler',
      uniqueBarCode: 'Levha için benzersiz barkod',
      uniqueBarCodeForPack: 'Levha için benzersiz barkod (yalnızca paketleme)',
      machineOrder: 'Kesim dosya adından işleme sıra numarası oluştur',
      folderSetting: 'Aynı boyuttaki büyük levhaların kesim dosyalarını aynı klasöre koy',
      labelImageINCFolder: 'Etiket görsellerini etiket dosyalarıyla birlikte NC klasörüne koy',
      custom: 'Özel sipariş',
      folderSettingTip: 'Not: Gömülü düzen bu özelliği henüz desteklemiyor',
      settingMoveTip: 'Orijinal "{func}" işlevi "{module}" sayfasına taşındı!',
      fileManagerFunction: 'Delik dosyalarını farklı sipariş dosyalarına göre ayrı klasörlere yerleştir',
      gotoSetting: 'Ayarlara git',
      singleFileTitle: 'Tek dosya işleme ayarları',
      slectSingleProcess: 'Tek çıktı sürecini seçin',
      slectSingleProcessTip: 'Ücretli ikincil işleme süreçleri mevcut, lütfen silip yeniden kaydedin',
      setSingleRegularSize: 'Tek çıktı için standart delik ve kanal boyutunu ayarlayın',
      holeRange: 'Delik geçerli aralığı',
      slotRange: 'Kanal geçerli aralığı',
      holeRangeTip: 'Delik geçerli aralığı boş olamaz, lütfen doldurun!',
      slotRangeTip: 'Kanal geçerli aralığı boş olamaz, lütfen doldurun!',
      yhzc: 'Yay bükümlü bölümdeki düz kanal',
      xbgy: 'Eğimli Haitang köşesi ve eğimli kulp',
      nbyx: 'İç düzensiz şekil',
      secondaryProcessingMerge: 'İkincil işleme dosya birleştirme',
      secondaryProcessingMergeName: 'Birleştirilmiş dosya adı',
      secondaryProcessingMergeTip: 'Açıldığında, dışa aktarılan panelde birden fazla ikincil işlem varsa tek bir işleme dosyasında birleştirilir',
      singleFileSetting: 'Eğimli kenar, begonya köşesi ve eğimli kulp için tek dosya işleme çıktısı',
      straightArcSlot: 'Yay büküm bölgelerinde düz oluklar için tek dosya işleme çıktısı'
      },
    aioMachineSetting: {
      openFunction: 'Bağlantı için aşağıdaki işlevlerin etkinleştirilmesi gerekir',
      openCarving: 'Oyma makinesini etkinleştir',
      xyReverseFunction: 'XY eksen takası işlevi',
      carvingStartSet: 'Oyma makinesi istasyon başlangıç noktası şu şekilde ayarlansın:',
      rightTop: 'Sağ üst',
      carvingEdgeSet: 'Oyma makinesi ön yüz ek kenar düzeltme değeri şu şekilde ayarlansın:',
      finalEdgeSame: 'Toplam kenar düzeltme değeri ile aynı',
      beginCode: 'Program başlangıç kodu',
      endCode: 'Program bitiş kodu',
      drillHole: 'Delik del',
      pullTrough: 'Oluk çek',
      showDataTemp: 'Veri örneğini göster',
      dataTemp: 'Veri örneği',
      title: 'Hepsi bir arada makine ayarları',
      outputFile: 'Hepsi bir arada makine işleme dosyasını dışa aktar',
      outputFileTips: 'Bazı hepsi bir arada markalar XY takası, dosya birleştirme ve düzensiz delikleri delmeme ile uyumlu değildir; dikkatli kullanın',
      fileType: 'Dosya biçimi',
      select: 'Lütfen seçin',
      diameter: 'Kenar düzeltme takımı çapı',
      jidongTip: 'Jidong hepsi bir arada kullanırken oyma istasyonu başlangıcını sağ üst köşeye ayarlayın ve A işlevini açın',
      skill: 'İşlev',
      clampHandLength: 'Tutucu uzunluğu (L)',
      clampHandWidth: 'Tutucu genişliği (W)',
      clampHandMargin1: 'Tutucu 1 kenar mesafesi (H1)',
      clampHandMargin2: 'Tutucu 2 kenar mesafesi (H2)',
      duchClampHand: 'Oluk/rölyef tutucu konumundan kaçın',
      clampHandDirection: 'Tutucu yönü',
      left: 'sol',
      right: 'sağ',
      top: 'üst',
      bottom: 'alt'
      },
    oneDragTwo: {
      title: 'Bire iki oyma makinesi',
      outputMachineFile: 'Bire iki oyma makinesi işleme dosyasını dışa aktar',
      outputMachineFileTips: 'Bire iki oyma makinesi etkinleştirildikten sonra kesim makinesi dosya birleştirmesi ile uyumlu değildir; dikkatli kullanın',
      fileType: 'Dosya biçimi',
      select: 'Lütfen seçin',
      machineStart: 'İstasyon başlangıç noktası',
      positionClose: 'Kapalıyken kesim parametrelerindeki istasyon başlangıç ayarını izler',
      engravingPlus: 'Hızlı oyma makinesi'
      },
    sawEngraving: {
      title: 'Testere ve oyma makinesi',
      preLayNav: 'Testere-oyma makinesi ayarları',
      preLayKnifeInput: 'Testere bıçağı enine kesim çapı',
      enableSaw: 'Testere-oyma makinesini etkinleştir',
      sawAioTip: 'Kaynaklı plaka AIO çıktısı için izniniz yok; etkinleştirmek için satışla iletişime geçin.',
      cutSet: 'Kaynaklı plaka kesim ayarları',
      weldingPlank: 'Kaynaklı plaka',
      doorFrame: 'Kaynaklı plaka',
      doorFrameTip1: 'Testere bıçağı kullanımı',
      doorFrameTip2: '2.Testere bıçağı kullanımı 3.Testere bıçağı kullanımı',
      sawUsing: 'Testere bıçağı kullanımı',
      trim: 'Kenar düzeltme',
      cutBlank: 'Kesim ve boşaltma',
      backTrimOblique: 'Arka kenar düzeltme',
      holeSlotOblique: 'Arka kenar düzeltme',
      plankThicknessUnit: 'Tahta kalınlığı yığılması',
      sawUseCond: 'Testere bıçağı kullanım koşulları',
      exportPartData: 'Küçük levha veri dosyasını dışa aktar (ban, mpr, xml vb.)',
      sawAioTip2: 'Çevirmesiz testere kesim hepsi bir arada makinelere uygundur',
      hasUsing: 'Kullanılabilir yol varsa kullan',
      onlyUse: 'yalnızca gerekli olduğunda kullan',
      cutMethod: 'Kesim yöntemi',
      oneKnifePull: 'Büyük levhayı tek kesimde boyuna kes',
      onlyOneKnifePull: 'yalnızca o zaman doğrudan tek kesimde boyuna geçilir',
      enableSawThick: 'Testere kalınlığına göre yerleşimi etkinleştir',
      edgedDir: 'Kenarı kapatılmış ve tekrar kesilmeyecek büyük levha kenarı',
      sameWidthPart: 'Her büyük levhada yalnızca aynı genişlikte küçük levhalar yerleştir',
      emptyPath: 'Kesim sırasında boş gezinme yolu oluşturma',
      sawUsePlank: 'Kaynaklı levhalar yalnızca testere bıçağı ile işlenir',
      paibanGap: 'Kaynaklı levha yerleşim aralığı',
      minSurplusWidthDiff: 'Minimum artık parça eşleştirme genişlik farkı',
      minSurplusWidthDiffTip: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
      sawReplaceEnable: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
      minSawLength: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
      keepDistance: 'Küçük levha ile artık malzeme genişlik farkı bu değerden küçük olduğunda küçük levha artığa yerleştirilir',
      keepDistanceTip: 'Kenar levhalara kesilmemesi için yeterince boşluk bırakın',
      sortByLength: 'Levha uzunluğuna göre sırala',
      sortByLengthTip: 'Kesim yönü alttan üste; yerleşim önce genişliğe sonra uzunluğa göre',
      plankAtTop: 'Küçük levha üstte',
      plankAtBottom: 'Küçük levha altta',
      useSawTipOne: 'Etkinleştirildiğinde yalnızca dolapta kaynaklı levha özelliği olan küçük levhalar testere ile işlenir; kaynaklı olmayanlar düz bıçakla kesilir',
      useSawTipTwo: 'Özel büyük levha sırası açıkken kaynaklı levhalar standart büyük levha ile yerleştirilmez; karışık yerleşim için özel büyük levhaya kaynaklı ve petek levha ham verilerini ekleyin',
      useSaiTipThree: 'Bu işlev açıldıktan sonra yerleşim çözümü testere kesim yerleşimini kullanmalıdır',
      surplusStoreAndLabeling: 'Kesilen artık malzeme depolanabilir ve etiket basılabilir',
      surplusMinLength: 'Artık malzeme minimum kullanılabilir uzunluk',
      surplusMinSize: 'Artık malzeme minimum kullanılabilir boyut',
      crossCutOnlyMinSurplusSize: 'Artık malzeme minimum kullanılabilir boyutu sağladığında yalnızca çapraz kesim yolu oluşturulur',
      surplusStoreAndLabelingTip: '1. Büyük levhada üstte veya altta mavi artık alanı oluşur; bu alan normal şekilde depolanıp etiketlenebilir',
      surplusStoreAndLabelingTip2: '2. Kaynaklı levhalar için Artık Otomatik Kırpma işlevi geçerli olmaz',
      surplusStoreAndLabelingTip3: '（Etkinleştirme sonrası',
      backCutSurplus: 'Arka yüzden artık kes',
      cutSurplusTip: 'Etkinleştirdikten sonra arka yüz kenar düzeltme sırasını Arka yüz oluk işleminden sonra kenar düzelt olarak ayarlayın',
      top: 'üst',
      bottom: 'alt',
      left: 'sol',
      right: 'sağ',
      dockTip: 'Çıkıntı kaynaklı levha işlemi için dikdörtgen levhanın dört kenarı kapatılmalı ve toplam kenar düzeltme ile uyumlu olmalı; tek sıra yerleşim manuel yapılmalıdır',
      sawToLayoutTip: 'Bu işlev açıldığında yerleşimde küçük levhalar arasında yalnızca testere kalınlığına eşit kesim payı bırakılır',
      sawToLayoutTip2: 'Testere yerleşimi şu an belirtilen boşaltma bıçağını desteklemiyor',
      tempPaiabanTip: 'Testere kesimi etkinleştirildikten sonra yerleşime doğrudan özel şekilli levha eklenemez; eklemek için kesim listesine gidin',
      generateCutSurplusPath: 'Önce artığı kesen enine kesim yolu oluştur',
      curSurplusPathTip: 'Etkinleştirdikten sonra arka yüz kenar düzeltme sırasını Arka yüz delik/oluk işleminden sonra kenar düzelt olarak ayarlayın'
      },
    robotArmDocking: {
      autoLine: 'Otomatik çizgi bağlantısı',
      autoLineTip: 'Otomatik çizgi kullanma izni yok veya açabileceğiniz otomatik çizgi sayısı yetersiz',
      title: 'Robot kol bağlantısı',
      enable: 'Robot kol bağlantısını etkinleştir',
      enableTip: 'Açıldığında üretim dosyası çıktısında robot kol bağlantı dosyası da üretilir'
      },
    laserCuttingMachine: {
      title: 'Lazer kesim hepsi bir arada',
      enable: 'Lazer kesim hepsi bir aradayı etkinleştir',
      backSafeHeight: 'Arka yüz boşta iken Z yüksekliği (H)',
      laserDistance: 'Ön/arka lazer bıçağı keserken levha yüzeyine uzaklık',
      coordinateAxis: 'Koordinat ekseni',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Kesim ayarları',
      backKnifeStore: 'Arka bıçak mağazası',
      noSupportOriginalMaterialKnife: 'Ham malzeme kesim bıçağı seçimi şu an desteklenmiyor',
      laserKnifeTip: 'Kesim açma: İçte delinmemiş özel şekiller için',
      laserKnifeTip2: 'Lazer bıçağı: Delinmiş delik/oluklar, iç şekiller, dış kontur kesimi',
      laserKnifeTip3: 'Dikkat: Arka Z ekseni varsayılan olarak tezgah yüzeyine göre göreli koordinat kullanır',
      laserKnifeTip4: 'Bıçak sayısı 1den az olamaz',
      laserKnifeTip5: 'Kesim açma bıçağı silinemez',
      laserKnifeTip6: 'Kesim açma için seçili bıçak yok; en az bir bıçak seçin',
      laserKnifeTip7: 'Lazer bıçağı içte tam kesilmemiş özel şekilleri işleyemez; Kesim açma seçimi otomatik kaldırıldı',
      laserKnifeTip8: 'Bıçak kütüphanesinde Kesim açma seçeneği işaretli bıçakları seçin; aksi halde içte tam kesilmemiş şekiller işlenemez',
      laserKnifeTip9: 'Kesim açma kütüphanesindeki lazer bıçak çapı ile lazer hepsi bir aradaki uyuşmuyor; kontrol edin',
      laserKnifeTip10: 'Kesim açma kütüphanesindeki boşaltma bıçak çapı ile lazer hepsi bir aradaki uyuşmuyor; kontrol edin',
      laserKnifeTip11: 'Cihaz bağlantı parametreleri değişti; lütfen yeniden yerleştirin',
      noLaserPermission: 'Lazer hepsi bir arada kullanım izniniz yok; kullanmak için satın alın',
      laserOpenCode: 'Lazer açma kodu',
      laserCloseCode: 'Lazer kapatma kodu',
      laserToolSettings: 'Ön/arka lazer bıçağı ayarları'
      },
    firstSave: 'Bulut yerleşimi ilk kullanımınız tespit edildi; ayarları kaydettikten sonra dosyadaki kenar düzeltme yönünün makul olup olmadığını kontrol edin',
    knives: {
      xOffset1: 'X koordinat ofseti',
      yOffset1: 'Y koordinat ofseti',
      zOffset1: 'Z koordinat ofseti',
      insert: 'Satır ekle',
      delete: 'Satırı sil',
      tip: '(Not: Bıçak kütüphanesi bilgisini veya ayarları değiştirdikten sonra dolap yerleşimi üreten kullanıcıların değişiklikleri uygulamak için dolap istemcisini yeniden başlatması gerekir.)',
      number: 'numara',
      name: 'Ad',
      diameter: 'Bıçak çapı Φ',
      sawDiameter: 'Testere kalınlığı Φ',
      cutting: 'Malzeme kesimi',
      use: 'Amaç',
      moveZF: 'Z ekseni hızlı hareket hızı',
      axis_offset: 'Eksen ofseti',
      arc_radius: 'Yay yarıçapı ayarı',
      cutZF: 'Z ekseni işleme hızı',
      moveF: 'XY ekseni hızlı hareket hızı',
      cutF: 'XY ekseni işleme hızı',
      startCode: 'Takım değiştirme başlangıç kodu',
      stopCode: 'Takım değiştirme bitiş kodu',
      startCode2: 'İstasyon 2 takım değiştirme başlangıç kodu',
      stopCode2: 'İstasyon 2 takım değiştirme bitiş kodu',
      knifeLength: 'Bıçak uzunluğu',
      maximum_single_depth: 'Tek seferde maksimum işleme derinliği',
      specialShapeKnifeTip: 'Yalnızca içteki düzensiz şekiller için geçerlidir',
      preStartCode: 'Ön başlatma kodu',
      punchHoles: 'Delik delme',
      pullSlots: 'Kanal çekme',
      millHoles: 'Freze delikleri',
      millSlots: 'Freze yuvası',
      sawBlade: 'Testere bıçağı',
      doubleSaw: 'Çift istasyon için farklı takım değiştirme başlangıç kodunu etkinleştir',
      singleStation: 'Tek istasyon',
      doubleStation: 'Çift istasyon',
      sawBladeTip: 'Bu işlev bire iki oyma makineleri ve hepsi bir arada makinelerde geçerli değildir',
      serialNum: 'Seri numarası',
      sawWidth: 'Bıçak genişliği',
      sawType: 'Testere bıçağı tipi',
      cutDirection: 'Kesim yönü',
      moveSpeed: 'Boşta hız',
      cutSpeed: 'İşleme hızı',
      endCode: 'Takım değiştirme bitiş kodu',
      sawDownCode: 'Bıçak indirme kodu',
      sawUpCode: 'Bıçağı toplama kodu',
      abscissa: 'Apsis (yatay) ön eki',
      ordinate: 'Ordinat (dikey) ön eki',
      sawHor: 'Enine kesim testere bıçağı',
      sawVer: 'Boyuna kesim testere bıçağı',
      towardsZero: '0 noktası koordinatına doğru kes',
      awayFromZero: '0 koordinatından uzağa kes',
      diameterDesc: 'Bıçak çapı Φ',
      xOffset: 'Yatay koordinat ofseti',
      yOffset: 'Dikey koordinat ofseti',
      zOffset: 'Yükselti koordinatı ofseti',
      offsetX: 'Ofset X',
      offsetY: 'Ofset Y',
      offsetZ: 'Ofset Z',
      offsetNo: 'Ofset numarası',
      knifeWidth: 'Bıçak genişliği',
      drill: 'Bıçak indirme',
      cut: 'İşleme',
      speed: 'Devir hızı',
      type: 'Tür',
      millHoleSlot: 'Freze delik/yuva',
      rapidFeedSpeed: 'Hızlı ilerleme hızı',
      typeOption1: 'Matkap ucu',
      typeOption2: 'Freze ucu',
      typeOption3: 'Profil bıçağı',
      typeTip: 'Takım türü ayarlandıktan sonra delik ve yuvalar ilgili türdeki takımla işlenir'
      },
    other: {
      title: 'Diğer',
      tip: '(Not: Tek istasyonlu cihazlarda İstasyon 1 ve İstasyon 2 için aynı otomatik besleme kodunu girin)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'Daha fazla ayar',
    sideStartCode: 'Ön yüz işleme yüz değiştirme kodu üretir',
    useArcCode: 'Yay interpolasyonu ile yay kesimi',
    coordSwitch: 'Koordinat referansını değiştir',
    updownCoordSwitch: 'Yükselti koordinatı referansını değiştir',
    xCoordSwitch: 'Yatay koordinat referanslarını değiştir',
    yCoordSwitch: 'Dikey koordinat referanslarını değiştir',
    knifes: {
      number: 'Numara',
      diameter: 'Bıçak genişliği',
      type: 'Tür',
      moveSpeed: 'Hızlı ilerleme hızı',
      doSpeed: 'İşleme hızı',
      startCode: 'Takım değiştirme başlangıç kodu',
      endCode: 'Takım değiştirme bitiş kodu'
      },
    ymSetting: 'Yimu bağlantı ayarları',
    flanking: 'Yan yüz işleme',
    frontProcess: 'Ön yüz işleme',
    oldSetting: 'Eski sürüm ayarları',
    equipParamsSetting: 'Cihaz parametre ayarları',
    holeSetting: 'Delik ayarları',
    raminoSetting: 'Ramino bağlantı ayarları',
    mortiseTenonSetting: 'Çıkıntı ve oyuk bağlantı ayarları',
    straight: 'Düz tip',
    eccentric: 'Eksantrik tip',
    pbSize: 'Üst ve alt kırma levhası boyutu',
    slotOverlapRate: 'Freze yuvası örtüşme oranı',
    breakingBoardDirection: 'Üst ve alt kırma levhası yönü',
    coordinateValue: 'Koordinat değeri',
    codeFormat: 'Dosya kodlama biçimi',
    suffixSetting: 'Dosya uzantısı ayarı',
    insertRow: 'Satır ekle',
    deleteRow: 'Satır sil',
    equipmentParams: {
      equipPauseCode: 'Cihaz duraklatma kodu',
      wiggleCode: 'Salınım kodu',
      equipStartCode: 'Cihaz başlatma kodu:',
      flipPauseCode: 'Yüz çevirme duraklatma kodu',
      equipEndCode: 'Cihaz bitiş kodu:',
      equipStartCodePlaceholder: 'Cihaz başlatma kodunu girin',
      retractingCode: 'Bıçağı geri çekme komut kodu',
      retractingCodePlaceholder: 'Bıçağı geri çekme komut kodunu girin',
      flipPauseCodePlaceholder: 'Yüz çevirme duraklatma kodunu girin',
      equipEndCodeTip: 'Cihaz bitiş kodunu girin',
      sideChangeSetting: 'Yan yüz değiştirme ayarı',
      workTip: 'Varsayılan olarak soldan ① başlayarak saat yönünün tersine işler',
      frontTurnCode: 'Üst yüz başlangıç kodu:',
      frontTurnEndCode: 'Üst yüz bitiş kodu',
      frontTurnCodePlaceholder: 'Üst yüz başlangıç kodunu girin',
      frontTurnEndCodePlaceholder: 'Üst yüz bitiş kodunu girin',
      leftTurnCode: 'Sol yüz başlangıç kodu:',
      leftTurnEndCode: 'Sol yüz bitiş kodu:',
      leftTurnCodePlaceholder: 'Sol yüz başlangıç kodunu girin',
      leftTurnEndCodePlaceholder: 'Sol yüz bitiş kodunu girin',
      downTurnCode: 'Alt yüz başlangıç kodu:',
      downTurnEndCode: 'Alt yüz bitiş kodu:',
      downTurnCodePlaceholder: 'Alt yüz başlangıç kodunu girin',
      downTurnEndCodePlaceholder: 'Alt yüz bitiş kodunu girin',
      rightTurnCode: 'Sağ yüz başlangıç kodu:',
      rightTurnEndCode: 'Sağ yüz bitiş kodu:',
      rightTurnCodePlaceholder: 'Sağ yüz başlangıç kodunu girin',
      rightTurnEndCodePlaceholder: 'Sağ yüz bitiş kodunu girin',
      topFlipCode: 'Yüz çevirme kodu - üst',
      downFlipCode: 'Yüz çevirme kodu - alt',
      leftFlipCode: 'Yüz çevirme kodu - sol',
      rightFlipCode: 'Yüz çevirme kodu - sağ',
      cylinderOutCode: 'Silindir çıkarma kodu',
      cylinderbackCode: 'Silindir geri çekme kodu',
      cylinderbackDirective: 'Silindir geri çekme komutu',
      moveDirective: 'Hareket komutu',
      moveAxisCode: 'Eksen hareketi',
      pushAxisCode: 'Silindir itme ekseni',
      swingAxisCode: 'Salınım ekseni',
      moveCode: 'Hareket kodu',
      punchCode: 'İşleme kodu',
      free: 'Boşta gezinme',
      punchPart: 'İşleme bölümü',
      cutFaceCode: 'İşleme düzlemi kodu',
      horVerCutFace: 'Yatay ve dikey düzlem',
      horCutFace: 'Yatay yükselti düzlemi',
      verCutFace: 'Dikey yükselti düzlemi',
      specifySmallBoardMaterialNoCut: 'Belirtilen küçük levha malzemesinde kesim yok',
      specifySmallBoardMaterialNoCutTip: 'Malzeme içinde ilgili anahtar kelimeler bulunan levhalar yalnızca 5/6 yüz delik işleminden delik ve yuva dosyası üretir, kesim olmaz',
      addMaterialKeyword: 'Malzeme anahtar kelimesi ekle',
      keyword: 'Anahtar kelime'
      },
    tagPool: 'Veri etiket havuzu',
    dragTip: 'Etiket havuzundaki etiketleri sürükleyin',
    knives: 'İşleme takımları:',
    directives: 'İşleme komutları:',
    slot: 'Düz kanal işleme',
    cirWork: 'Yay işleme',
    cirInter: 'Dairesel interpolasyon',
    cirOption1: 'Saat yönü: G03 Saat yönünün tersi: G02',
    cirOption2: 'Saat yönü: G02 Saat yönünün tersi: G03',
    coordinate: {
      xPointSymbol: 'X koordinatı:',
      yPointSymbol: 'Y koordinatı:',
      zPointSymbol: 'Z koordinatı:',
      upright: 'Pozitif değer',
      negative: 'Negatif değer'
      },
    encodeFormat: {
      format: 'Dosya kodlama biçimi:',
      wrap: 'Satır sonu biçimi ayarı:',
      formatOption1: 'UTF-8 biçimi',
      formatOption2: 'ANSI biçimi'
      },
    suffix: 'Dosya uzantısı ayarı:',
    enableFP: 'Ön yüz işlemeyi etkinleştir',
    slotSetting: 'Kanal çekme ayarı',
    slotMillSetting: 'Kanal çekme / freze delik ve kanal ayarı',
    millSlot: 'Freze delik ve kanalı destekler',
    millingSlotOverlapRate: 'Freze kanalı örtüşme oranı',
    millingHoleSlotOverlapRate: 'Freze delik ve kanal örtüşme oranı',
    takeUpDirective: 'Bıçağı toplama komutu',
    workSeparately: 'Ön ve arka yüzdeki geçiş kanalını iki aşamada işle',
    secondSlotLong: 'İkinci kanal parçası uzunluğu',
    enableOld: 'Eski yan delik makinesi ayarlarını etkinleştir',
    default: 'Varsayılan ayar',
    customizable1: 'Özel 1',
    customizable2: 'Özel 2',
    customizable3: 'Özel 3',
    customizable4: 'Özel 4',
    knifeSetting: 'Takım ayarı',
    soltTip: '(Freze delik/kanal dahil)',
    specialSetting: 'Özel ayar',
    ramino: 'Ramino',
    sun: 'Çıkıntı ve oyuk',
    please: 'Yakında',
    designatedKnives: 'Belirtilen takım',
    designated: 'Belirtilen',
    workOrder: 'İşleme komutu',
    other: 'Diğer',
    nameSetting: 'Uzantı adı ayarı',
    repeatErr: 'Numara tekrarlı, lütfen yeniden ayarlayın'
    },
  electronicSaw: {
    importMaterial: 'Ham malzeme listesini içe aktar',
    formSetting: 'Elektronik testere form ayarı',
    fileFormat: 'Kesim listesi çıktı dosya biçimi:',
    isSmallFile: 'Küçük levha görüntü dosyasını dışa aktar:',
    fileGroupRule: 'Elektronik testere dosyalarını renk, malzeme ve levha kalınlığına göre ayrı tablolara böl:',
    roomsByCategory: 'Elektronik testere dosyalarını odaya göre ayrı tablolara böl:',
    delimiter: 'Ayırıcı:',
    fileName: 'Kesim listesi dosya adı:',
    fineNameTip: 'Kesim listesi dosya adı boş olamaz!',
    fileNamePlaceholder: 'Özel kesim listesi',
    outputFileEncoding: 'Çıktı listesi kodlama biçimi:',
    utf8: 'UTF-8 BOM ile',
    cellTab: 'Hücre sekme oluştur:',
    texture: 'Doku gösterimi:',
    special: 'Özel şekil gösterimi:',
    notSpecial: 'Özel şekil değil',
    genSimpleLabelBarcode: 'Basit biçimli etiket barkodu oluştur',
    uniqueBarCode: 'Levha için benzersiz barkod',
    uniqueBarCodeTip: 'Açıldığında basit biçimli etiket barkodu oluşturma çalışmaz',
    roboticArmDocking: 'Robot kol bağlantısı',
    customeForm: 'Özel form',
    tagPool: 'Veri etiket havuzu',
    tagPoolTips: 'Etiket havuzundan etiketleri sürükleyin veya kopyalamak için tıklayın',
    displayHead: 'Tablo başlığını gizle',
    addTableHead: 'Tablo başlığı ekle',
    deleteTableHead: 'Tablo başlığını sil',
    generateExample: 'Çıktı formu örneği oluştur',
    importExample: 'Form örneğini içe aktar',
    importExampleTip: 'İçe aktarılan form örneği yalnızca elektronik testere özelleştirme için referanstır',
    importExampleErrTip: 'Ham malzeme listesi içe aktarılmadı; lütfen önce içe aktarın',
    outputExample: 'Çıktı formu örneği',
    outputExampleTip: 'Özel formun çıktı örneği',
    outputExampleErrTip: 'Çıktı formu örneği henüz oluşturulmadı; lütfen oluşturun',
    defaultTableHead: 'Varsayılan tablo başlığı',
    deleteHeadErrTip: 'Silinecek tablo başlığı yok!',
    genNonString: 'Metin olmayan veri türü oluştur',
    genNonStringTip: 'Oluşturulan tablo verisini elektronik testere okuyamıyorsa etkinleştirmeyi deneyin',
    revertWidth: 'Dokulu levhanın uzunluk ve genişliğini değiştir'
    },
  lockModal: {
    passwordInput: 'Parolayı girin',
    lockPassword: 'Kilit parolası',
    lockPasswordInput: 'Kilidi açma parolasını girin',
    passwordInputPlaceholder: 'Dört haneli parola girin',
    editPassword: 'Parolayı değiştir',
    confirmPassword: 'Parolayı onayla',
    setLockPwd: 'Kilidi açma parolasını ayarla',
    pwdFormatErr: 'Parola biçimi hatalı',
    sendMessageTo: 'SMS doğrulama kodu şu adrese gönderilecek:',
    captchaPlaceholder: 'Doğrulama kodunu girin',
    sendCaptcha: 'Doğrulama kodu gönder',
    sendSeccess: 'SMS başarıyla gönderildi',
    sendFail: 'SMS gönderilemedi, sonra tekrar deneyin',
    updateSeccess: 'Parola başarıyla ayarlandı',
    editSuccess: 'Parola başarıyla değiştirildi',
    lockSeccess: 'Kilit açma başarılı',
    lock: 'Kilidi aç',
    lockSeccessTip: 'Kilitleme başarılı',
    inputErrLimit: 'Hata sayısı sınıra ulaştı; kilidi açma parolasını sıfırlayın!'
    },
  dock56Drill: {
    equipType: 'Cihaz türü',
    equipment: 'Cihaz',
    fiveDock: 'Beş yüz delik',
    sixDock: 'Altı yüz delik',
    fileType: 'Oluşturulan dosya türü',
    templateOffline: 'Kullanılan şablon devre dışı bırakıldı!',
    showExample: 'Veri örneğini göster',
    conNoticeTip: 'Bağlantı notları:',
    conNoticeTip1: '1. “XY ekseni takası” açık oyma makinelerinde ön-arka yüz değişimli 5/6 yüz delik özel şablonu kullanılmalıdır',
    conNoticeTip2: '2. Beş/altı yüz delikte levha özel şekil kısmını göstermek veya işlemek için şablonda özel şekil verilerini yapılandırın',
    conNoticeTip3: '3. Beş/altı yüz deliği ilk kez kullandıktan veya şablonu değiştirdikten sonra lütfen <span style="color:#f00">dolap deneme üretimi</span> yapın; hatasız doğruladıktan sonra rutin üretime geçin',
    conNoticeTip4: '4. Deneme üretiminde ön ve arka yüzdeki delik ve kanalların boyut, derinlik, yüz ve konumunu dikkatle kontrol edin; <span style="color:#f00">dolap ayna görüntüsü</span> sorunundan kaçının',
    example: 'Veri örneği',
    commonSetting: 'Genel parametre ayarları',
    throughHoleSetting: 'Geçiş deliği iki yüzden delinir',
    throughSlotSetting: 'Geçiş kanalı iki yüzden açılır',
    nonHolesNotFiles: 'Dikdörtgen levha delik/kanalsızsa dosya çıktısı yok:',
    frontFileIdentifier: 'Ön yüz dosya tanımlayıcısı:',
    oppositeFileIdentifier: 'Arka yüz dosya tanımlayıcısı:',
    oppositeFileIdentifierTips: 'Oluşturma: Orijinal 13 haneli parça kodu + tanımlayıcı karakter',
    arcDescription: 'Yay tanımlama yöntemi',
    linePoints: 'Doğru parçası oluşum tanımı',
    arcCommand: 'Yay komutu tanımı',
    slotWidthSplit: 'Geniş kanalı işlem için birden çok dar kanala böl:',
    slotSplitWidth: 'Bölme sonrası tek kanal genişliği:',
    mm: 'Not: Bölme hedefi normal dikdörtgen kanaldır',
    isNotMergeSlot: 'Bitişik eş genişlik ve derinlikteki kanalları birleştir:',
    slotPunchTip: 'Bu işlev yalnızca özel şablon kullanan arka panel ve çekmece tabanı kanalları için geçerlidir',
    sizeRange: 'Bitişik ölçü şundan küçük veya eşit',
    enableWorningTip: 'Bu işlev ön bant yerleştirme yönü ile aynı anda açılamaz',
    longDirection: 'Levha uzun kenar yerleştirme yönü',
    horizontal: 'Yatay',
    vertical: 'Dikey',
    slotDirection: '5/6 yüz delik kanalı veya özel şekil yerleştirme yönü',
    default: 'Sistem varsayılanı',
    frontLeft: 'Ön ve sol',
    frontRight: 'Ön ve sağ',
    backLeft: 'Arka ve sol',
    backRight: 'Arka ve sağ',
    frontDirection: 'Ön bant yerleştirme yönü',
    enableTip: 'Not: Yalnızca bulut yerleşiminde geçerlidir',
    fixedOn: 'Sabitlenmiş:',
    front: 'Ön',
    back: 'Arka',
    left: 'Sol',
    right: 'Sağ',
    coordinateValue: 'Koordinat değeri ondalık basamak sayısı:',
    decimalPlaces: 'Basamak',
    slotLengthCompensation: 'Kanal uzunluğu telafisi',
    curveholesLengthCompensation: 'İç özel şekil köşe temizliği',
    slotCompensationEqualZero: 'Kenara mesafe 0 iken kanal kenarı telafisi',
    slotCompensationNotEqualZero: 'Kenara mesafe 0 değilken kanal kenarı telafisi',
    slotCompensationTip: 'İşlemde küçük yuvarlatılmamış köşeler veya yetersiz uzunluk olduğunda kullanın',
    curveholesCompensationEqualZero: 'Kenara mesafe 0 iken iç özel şekil kenarı telafisi',
    curveholesCompensationTip: 'Önerilen giriş: İç özel şekil freze takımı yarıçapı',
    curveholesCompensationTip2: 'Levha dış dikdörtgen kenarı boyunca işlenen iç özel şekilde temiz kesilmemiş küçük yuvarlak köşe olduğunda kullanın',
    specialParameter: 'Özel parametre ayarları',
    output5FDrillSlotKnifeCode: 'XML2 freze kanalı takım numarası',
    output5FDrillShapeKnifeCode: 'XML2 freze şekil takım numarası',
    plankTexture: 'XML2 levha dokusu',
    offset: 'XML2 şekil frezeleme takım telafisi',
    mprConHoleDir: 'Beş/altı yüzlü matkap MPR dosyası yan delik Z ekseni referans düzlemi',
    plankTop: 'Levha üst yüzeyi',
    plankBottom: 'Levha alt yüzeyi',
    codeInfo: 'ban biçimli dosya Code bilgisini içerir:',
    bomFile: 'bom biçimli dosyayı dışa aktar:',
    plankHeight: 'Levha yüksekliği açıklaması:',
    plankNum: 'Levha numarası açıklaması:',
    backZpoint: 'Arka oluk Z koordinatı:',
    plankThick: 'Levha kalınlığı',
    slotDeep: 'Oluk derinliği',
    outputMprFile: 'Dosya türü',
    oldMPR: 'Eski MPR',
    newMPR: 'Yeni MPR',
    mprFileZside: 'Beş/altı yüzlü matkap MPR dosyasında yan delikler için Z ekseni referans düzlemi',
    fileTypeOffline: 'Seçili beş/altı yüzlü matkap dosya türü kullanımdan kaldırıldı, lütfen onaylayın!',
    permissionErr: 'Kimlik bilgileri kayboldu, lütfen bu sayfayı Guigui üzerinden yeniden açın!',
    banFileSetting: 'ban biçimli dosya ayarları',
    banFileCodeInfo: 'ban biçimli dosya Code bilgisini içerir:',
    huahuaLine: 'Huahua otomatik hat',
    huahuaLineTip: '(Etiket konumlandırma standartıyla uyumsuz)',
    huahuaPartFlag: {
      longSide: 'Uzun kenar <',
      shortSide: 'veya kısa kenar <',
      partFlag: 'levhalar için küçük levha kimliği oluştur',
      tip: '(Etikette göstermek için "levha kimliği-küçük levha işareti" verisi eklenmelidir; Huahua otomatik hat dosyasında ilgili veriler otomatik eklenir)'
      },
    plankPutWay: 'Levha yerleştirme yöntemi',
    plankPutWayTip: 'Eğer mevcut üretim hattı açıksa, levha yerleştirme yöntemi ayarı desteklenmez',
    autoHandle: 'Kıskaca otomatik kaçınma',
    manualHandle: 'Manuel kaçınma ayarı',
    fixedFront: 'Ön kenar bantlaması sabit',
    plankNamePlacement: 'Levha adına göre yerleştirme',
    plankNamePlacementTip1: '1. Ayarlandıktan sonra levha adı belirlenen alanı içeriyorsa, levhanın ilgili kenarı ayara göre cihazın belirtilen tarafına sabitlenir',
    plankNamePlacementTip2: '2. Bu ayarın önceliği, yukarıdaki levha yerleştirme yöntemi ayarından daha yüksektir',
    plankNamePlacementTip3: '3. Bu özellik yalnızca bulut yerleşimi için geçerlidir; mevcut üretim hattında Huahua otomatik hat açıksa ayrı levha yerleştirme ayarı desteklenmez',
    addRow: 'Satır ekle',
    plankNameTip: 'Lütfen levha adını girin',
    plankSide: 'Levha kenarı',
    deviceSide: 'Cihazda sabit',
    weldingPlatePlacementEnable: 'Kıskaca sabit tutma',
    onlyBluen: 'Yalnızca bulut dizilimi için geçerlidir',
    fixedEdge: 'Ön kenar bantlaması sabit',
    fixedEdgeRule: 'Kural: Levhanın konumunu belirleme',
    fixedEdgeRuleItem1: 'Uzun kenar kıskacıya yakın',
    fixedEdgeRuleItem2: 'Ön kenar bantlaması sabit',
    fixedEdgeRuleItem3: 'Ön kenar bantlaması sabit',
    fixedEdgeRuleItem4: 'Öncelik sırası',
    satisfiedCondition: 'Öncelik sırası',
    handDirection: 'Kıskacın bulunduğu yön',
    handleMachineTip: 'Döndürme ile oluk ve özel şekiller, kıskacın bulunduğu tarafa otomatik kaçınır; levha işlemeyi kolaylaştırır',
    handleWidth: 'Kıskıç genişliği',
    handleLength: 'Kıskıç uzunluğu',
    handleMaxWidth: 'İşlenebilir maksimum genişlik',
    usefulRange: 'Geçerli aralık',
    plankLongSide: 'Levha uzun kenarı',
    usefulRangeTip: 'Uzun kenar yerleştirme açıkken ve levhanın uzun kenarı bu geçerli aralıktaysa, oluk ve özel şekil konumu önceliklendirilir',
    moveTip: 'Ön/arka dosya tanımlayıcı işlevi şuraya taşındı',
    millingOuter: 'Dış özel şekil frezeleme',
    millingInner: 'İç özel şekil frezeleme',
    drilling: 'Delik işleme',
    slotting: 'Oluk işleme',
    knivesTip1: '1. Özel şekil freze takımı ayarlandıktan sonra kesim yolu bıçak yarıçapını telafi eder',
    knivesTip2: '2. Özel şekil kesim şu an XY eksen değişimini desteklemeyen oyma makinelerinde desteklenmez',
    internalCutting: 'İç özel şekil kesimde bıçak inişi ve kalkışı levhanın içindedir',
    externalCutting: 'Dış özel şekil kesimde bıçak inişi ve kalkışı levhanın dışındadır',
    externalCuttingDirection: 'Dış özel şekil kesimde, özel şekli de içeren tüm kenar eşzamanlı kesilir',
    allExternalCutting: 'Tüm dış özel şekiller',
    onlyArcExternalCutting: 'Yalnızca dış yay özel şekli'
    },
  doorWallCabinet: {
    tempErrTip: 'Kapı-duvar-dolap entegre makinesi için kullanılan şablonun eklenmediği tespit edildi, bu nedenle işleme dosyası dışa aktarılamıyor. Not: ekleme tamamlandıktan sonra yeniden yerleştirme yapılmalıdır.',
    title: 'Duvar ve dolap yapan makine',
    guifang: 'Kareleme',
    processingTechnology: 'İşlem Teknolojisi',
    longPlateSecondarySquaring: 'Varsayılan biçimde dosya dışa aktar',
    slotOnDoorPlate: 'Kapı panosundaki delikler',
    setting: 'Duvar ve dolap yapan makine ayarları'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Çıktı dosya biçimi',
    outputDefaultFileFormat: 'Varsayılan biçimde dosya dışa aktar',
    outputMPRFormat: 'MPR biçiminde dosya dışa aktar',
    fileFormatSettings: 'Dosya biçimi ayarları',
    wrapSettings: 'Satır sonu biçimi ayarları:',
    enCodeSettings: 'Dosya kodlama biçimi ayarları:',
    utf8bom: 'BOM ile UTF-8',
    partCoordinate: 'Parça koordinatı',
    xPointSymbol: 'Yatay (X) koordinat:',
    yPointSymbol: 'Dikey (Y) koordinat:',
    zPointSymbol: 'Z ekseni koordinatı:',
    upRight: 'Pozitif değer',
    negative: 'Negatif değer',
    plankMirroring: 'Levha aynalama',
    plankMirrorSetting: 'Levha aynalama ayarları:',
    xAxis: 'X ekseni aynalama',
    yAxis: 'Y ekseni aynalama',
    mirrorTip: '(Levhayı aynalarken bu özelliği kullanın)',
    knifeTable: {
      type: 'Tür',
      diameter: 'Çap Φ',
      offsetX: 'Ofset X',
      offsetY: 'Ofset Y',
      offsetZ: 'Ofset Z',
      offsetNo: 'Ofset numarası',
      drillVelocity: 'İniş hızı [F] mm/dk',
      cutVelocity: 'İşleme hızı [F] mm/dk',
      rotationSeep: 'Dönüş hızı [S] dev/dk',
      insertRow: 'Satır ekle',
      deleteRow: 'Satır sil'
      },
    labelPool: 'Veri etiket havuzu',
    dragTip: 'Etiket havuzundan etiketi sürükleyin veya tıklayarak giriş kutusuna kopyalayın',
    procedure: 'Program',
    beginCode: 'Program başlangıç kodu:',
    endCode: 'Program bitiş kodu:',
    zzdKnifeBeginCode: 'Ana mil takım değişimi başlangıç kodu:',
    spindleCutter: 'Ana mil takımı',
    zzdKnifeEndCode: 'Ana mil takım değişimi bitiş kodu:',
    verticalDrill: 'Dikey matkap',
    czzBeginCode: 'Dikey matkap başlatma kodu:',
    czzEndCode: 'Dikey matkap kapatma kodu:',
    czzKnifeBeginCode: 'Dikey matkap takım değişimi başlangıç kodu:',
    czzKnifeEndCode: 'Dikey matkap takım değişimi bitiş kodu:',
    sidetrack: 'Yan matkap',
    czBeginCode: 'Yan matkap başlatma kodu:',
    czEndCode: 'Yan matkap kapatma kodu:',
    czKnifeBeginCode: 'Yan matkap takım değişimi başlangıç kodu:',
    czKnifeEndCode: 'Yan matkap takım değişimi bitiş kodu:',
    pauseCode: 'Duraklatma kodu:',
    zSafeHeight: 'Güvenli mesafe',
    spindleKnife: 'Ana mil takımı ve dikey matkap Z ekseni güvenlik yüksekliği',
    sideDrillZ: 'Yan matkap Z ekseni güvenlik yüksekliği',
    sideDrillXY: 'Yan matkap X/Y ekseni güvenli mesafesi',
    auxiliaryFunction: 'Yardımcı işlev',
    xhDedicatedInfo: 'Xinghui cihazları için özel bilgi oluştur',
    xhCheckBox: 'Veri:',
    outputSettings: 'Çıktı ayarları:',
    partExegesis: 'Dosyada parça boyutu açıklamaları oluştur',
    knifeNo: 'Takım numarası',
    specailKnifeNo: 'Özel şekil işleme takım numarası:',
    slotKnifeNo: 'Oluk açma takım numarası:',
    fileNamePlaceholder: 'Özel kesim listesi',
    slotDrill: 'Düzleştirici takım'
    },
  glassEquip: {
    title: 'Cam kesim makinesi',
    fileType: 'İşleme dosya türü:',
    sizeReparation: 'Levha boyutu telafisi:',
    cutPreSpace: 'Levha kesimi için ayrılmış boşluk:',
    divideIntoFolders: 'Cam rengi, malzeme ve kalınlığa göre farklı klasörlere ayırın:'
    },
  translate: {
    search: 'Girişi bulmak için Çince veya resmi çeviriyi girin',
    en: 'İngilizce',
    es: 'İspanyolca',
    ar: 'Arapça',
    kz: 'Kazakça',
    vi: 'Vietnamca',
    th: 'Tayca',
    id: 'Endonezce',
    ug: 'Uygurca',
    customTranslate: 'Özel çeviri eklemek için tıklayın',
    customText: 'Özel çeviri',
    text: 'Çince',
    targetLang: 'Resmi çeviri',
    zh_hant: 'Geleneksel Çince'
    },
  preLayoutSetting: {
    title: 'Ön yerleşim ayarları',
    titleTip: 'Önce yerleşim parametrelerini önayarlayabilir, önce yerleşim yapıp ardından üretim hattını seçebilirsiniz',
    settingTip: 'Üretim hattında ayarlanan parametreler, üretim dosyasını çıkarmak için aşağıdaki ön yerleşim parametreleriyle uyumlu olmalıdır; yalnızca kesim makineleri için geçerlidir',
    emptyKnife: 'Takım doldurulmadı',
    noModify: 'Ayarlarda değişiklik yok, kaydetmeye gerek yok',
    reSet: 'Sıfırla',
    gayPosition: 'Gri kareler fazla malzeme yerleşim konumunu değiştirebilir',
    surplusPosition: 'Mevcut fazla malzeme yerleşim konumu',
    click: 'Tıklayın',
    grayStart: 'Gri kareler istasyon başlangıç noktasını değiştirebilir',
    currentStart: 'Mevcut istasyon başlangıç noktası',
    holeSlotSetting: 'Delik ve oluk işleme ayarları',
    knifeDiameter: 'Kesim takımı çapı',
    currentVersion: 'Mevcut sürüm',
    on: 'Açık',
    off: 'Kapalı',
    firstShort: 'İlk kesim - kısa kenar payı',
    firstLong: 'İlk kesim - uzun kenar payı',
    cuttingSplitLong: 'Uzun levha iki geçişte kesim - uzun kenar aşımı',
    cuttingSplitShort: 'Uzun levha iki geçişte kesim - kısa kenar aşımı',
    plankThick: 'Normal levha kalınlığı ≥ ',
    singleDoorThick: 'Kapı paneli kalınlığı ≥ ',
    normalPlank: 'Normal levha',
    confilictTip: 'Ayar çakışması var: {confilictTotal} öğe',
    selectLine: 'Üretim hattını seçin',
    selectLinePlaceholder: 'Lütfen bir üretim hattı seçin',
    lineConfilictTip: 'Seçilen üretim hattı {line} ile çakışıyor',
    preWay: 'Ön yerleşim şeması',
    paibanErrTip: 'Uzun levha işlemede [uzun ve kısa kenar payı] değişiklikleri yerleşim hatasına yol açabilir',
    paibanTip: 'Büyük levha malzemesi için belirtilen kesim takımı nedeniyle yerleşimin yenilenmesi gerekir',
    reLayout: 'Mevcut üretim hattıyla yeniden yerleşim',
    fetchErr: 'Ön yerleşim ayarları alınamadı',
    resetSuccess: 'Sıfırlama başarılı',
    resetConfirm: 'Geçmiş sürüme dönmek istediğinizden emin misiniz?',
    prolineName: 'Üretim hattı adı',
    layoutGap: 'Yerleşim boşluğu',
    generalThickness: 'İkincil kesim nesnesi - normal levha kalınlığı',
    cutGeneralPlank: 'İkincil kesim nesnesi - normal levha',
    cutSingleDoor: 'İkincil kesim nesnesi - kapı paneli',
    secondary_cutting_board_list: 'Belirtilen levha adları ve kesim levha adları listesi',
    changeProline: 'Üretim hattını değiştir',
    backTip: 'Üretim hattı seçmek için genel yerleşime dönün',
    preLayout: 'Ön yerleşim şemasına göre yerleşim',
    preWayEmpty: '(Boş) Ön yerleşim şeması',
    specialConfilictTip: 'Yay taban frezeleme süreci yerleşim sonucunu etkiledi; yeniden yerleşim gerekir'
    },
  lunbo: {
    tips: 'İşletme ipuçları',
    introduction: 'İşlev tanıtımı',
    qtDownloadText: 'Hatırlatma: İndirilen dosya eksikse lütfen bulut dizilimi web sayfasından indirin!'
    },
  sendModal: {
    paibanImgType: 'Yerleşim dosya biçim türleri'
    },
  authenticationModal: {
    title: 'Doğrulama için QR kodunu tarayın',
    tip: 'Doğrulama başarılı olmadan iletişim kutusunu kapatmayın!',
    countdownTip: '{countdown} sonra süresi dolacak',
    refreshTip: 'QR kodunu yenile',
    qrcodeTip: 'İşlemi tamamlamak için QR kodunu WeChat ile tarayın',
    qrcodeTip2: 'Tarama kaydı başarısız olursa Guigui genel ayarlar - kullanıcı yetkilendirme ayarlarından sistem düzenleme iznini verin.',
    waiting: 'Tarama bekleniyor',
    scanning: 'Kod tarandı, doğrulama bekleniyor',
    success: 'Doğrulama başarılı',
    error: 'Doğrulama başarısız',
    expired: 'QR kodunun süresi doldu',
    tip2: 'Hesap verilerinizin güvenliği için lütfen mevcut operatör bilgilerini doğrulayın'
    },
  printTag: {
    partName: 'Levha adı'
    },
  userAccessToken: {
    createTime: 'Oluşturulma zamanı',
    lastUsedTime: 'Son kullanım zamanı',
    expireTime: 'Son kullanma zamanı',
    status: 'Durum',
    tokenNamePlaceholder: 'Lütfen jeton adını girin',
    expireTimeSelectPlaceholder: 'Lütfen son kullanma zamanını seçin',
    securityBannerTip: 'Kişisel erişim jetonunuzu başkalarıyla paylaşmayın veya tarayıcıda veya diğer istemci kodunda açığa çıkarmayın. Hesabınızı korumak için herkese açık yerde sızdırılan jetonlar otomatik olarak devre dışı bırakılabilir.',
    expired: 'Süresi doldu',
    valid: 'Geçerli',
    remove: 'Kaldır',
    previewOnceWarning: 'Bu jeton yalnızca bir kez gösterilir. Bu sırrı güvenli ve erişilebilir bir yerde saklayın. Başkalarıyla paylaşmayın veya tarayıcıda veya diğer istemci kodunda açığa çıkarmayın.',
    token: 'Jeton',
    deleteConfirm: 'Bu jetonu silmek istediğinizden emin misiniz?',
    userAccessToken: 'Kullanıcı erişim jetonu',
    dayUnit: 'gün',
    custom: 'Özel',
    previewModalTitle: 'Yeni kişisel erişim jetonu',
    addModalTitle: 'Yeni kişisel erişim jetonu ekle'
    },
  bujianStore: {
    inputPlaceholder: 'Panoya eklemek için pano barkodunu girin',
    noData: 'Veri yok',
    loadingErr: 'Panoya eklemek için pano barkodunu girin',
    bujianStore: 'Panoya eklemek için pano barkodunu girin',
    awaitStore: 'Panoya eklemek için pano barkodunu girin',
    noDrag: 'Panoya eklemek için pano barkodunu girin',
    outOfCanvas: 'Panoya eklemek için pano barkodunu girin'
    },
  alginTexture: {
    tip: 'Bu işlem parçanın doku hizalama bilgisini temizleyecektir. Devam etmek istediğinizi onaylıyor musunuz?',
    tip2: 'Bu işlem parçalar arasındaki mesafeyi değiştirecek ve işleme sorunlarına yol açacaktır. Devam etmek istediğinizi onaylıyor musunuz?',
    group: 'Tekstür Grubu',
    groupTemp: 'Tekstür Grubu Bir',
    textureAlignmentPlank: 'Doku hizalama paneli taşınamaz'
    },
  customizeFolder: {
    customizeFolder: 'Klasör Özelleştirme',
    customizeFolderTip: 'Not: Klasör özelleştirmesini etkinleştirdikten sonra, daha önce ayarlanan klasör bölme kuralları artık geçerli olmayacaktır',
    processingFilesTitle: 'Dosya verilerini işleme',
    dragToFolderTip: 'Sol klasöre alt klasör veya dosya olarak sürüklenebilir',
    folderNameEmpty: 'Klasör adı boş olamaz',
    folderNameExists: 'Aynı ada sahip bir klasör var',
    fileNotFound: 'Doğru dosya alınamadı',
    fileCannotBeClassified: 'Bu dosya türü herhangi bir sınıflandırma klasörü altında yerleştirilemez',
    cannotAddAtThisPosition: 'Bu konuma ekleyemezsiniz',
    fileAlreadyExists: '【{name}】bu klasörde zaten var',
    confirmDeleteFolder: 'Bu klasörü silmek istediğinizden emin misiniz?',
    confirmDeleteItem: '【{name}】 silmek istediğinizden emin misiniz?',
    confirmDeleteFolderWithChildren: 'Bu klasörün altında başka klasörler/dosyalar var, silmek istediğinizden emin misiniz?',
    deleteFile: 'Dosya sil',
    addSubFolder: 'Alt klasör ekle',
    editFolder: 'Klasörü düzenle',
    deleteFolder: 'Klasörü sil',
    rootCannotDelete: 'Kök dizini silinemez',
    newFolder: 'Yeni klasör',
    fileUsedCanDrag: 'Kullanıldı - Tekrar tekrar sürüklenebilir',
    fileDraggable: 'Sürüklenebilir',
    addFileToFolder: '【{fileName}】 {folderName} ekle',
    addFolderTitle: 'Klasör ekle',
    editFolderTitle: 'Klasörü düzenle',
    folderNameLabel: 'Klasör adı',
    folderNamePlaceholder: 'Lütfen klasör adını girin',
    sequenceStartLabel: 'Artan dizi başlangıç ​​değeri',
    classifyMethodLabel: 'Sınıflandırma yöntemi',
    nameLengthLimitLabel: 'Karakter uzunluğu sınırı',
    tagInsertTip: 'Klasör adına eklemek için etiketi tıklayın',
    classifyTagInsertTip: 'Klasör adına eklemek için etiketi tıklayın, dosyalar belirtilen etikete göre sınıflandırılacaktır',
    engraving_front: 'Oymak makinesi ön dosyası',
    engraving_opposite: 'Oymak makinesi ters dosyası',
    engraving_merge: 'Oymak makinesi birleştirme dosyası',
    engraving_mill: 'İkincil işleme boynuz oluk frezeleme',
    engraving_haitang: 'İkincil işleme eğimli Haitang köşesi dosyası',
    engraving_arc_slot: 'İkincil işleme freze taban yay aralığı',
    engraving_line_slot: 'İkincil işleme özel araç yolu',
    engraving_straight_arc_slot: 'İkincil işleme yay bükülme parça düz aralığı',
    engraving_frame_door: 'İkincil işleme kemik kapı dosyası',
    engraving_inner_shape: 'İkincil işleme iç şekil',
    engraving_hole: 'İkincil işleme düz aralığı',
    engraving_slot: 'İkincil işleme düz aralığı',
    engraving_single_file_merge: 'İkincil işleme dosya birleştirme',
    electronic_saw: 'Elektronik testere dosyası',
    glass: 'Cam kesme makinesi dosyası',
    glass_machine: 'Cam kesme makinesi',
    side_machine: 'Kenar delik makinesi dosyası',
    side_machine_xml3: 'Eski sürüm kenar delik makinesi XML3 dosyası',
    side_machine_txt: 'Eski sürüm kenar delik makinesi TXT dosyası',
    side_machine_nc: 'Eski sürüm kenar delik makinesi NC dosyası',
    dock56F: 'Beş/altı taraflı delme dosyası',
    ptp: 'PTP dosyası',
    aio: 'Tüm-in-bir makine dosyası',
    aio_anc: 'Çok işlevli makinenin ön ANC dosyası',
    labeling_1: 'Etiketleme makinesi dosyası 1',
    labeling_2: 'Etiketleme makinesi dosyası 2',
    labeling_3: 'Etiketleme makinesi dosyası 3',
    robotic_arm: 'Robot kolu dosyası',
    label_image: 'Etiket resim dosyası',
    label_pdf: 'Etiket PDF dosyası',
    paiban_image: 'Tipografi görüntü dosyası',
    paiban_pdf: 'Tipografi görüntü PDF dosyası',
    engraving: 'Oyma makinesi',
    electronic: 'Elektronik testere',
    side_hole: 'Kenar delik makinesi',
    drilling: 'Beş/altı taraflı delme',
    labeling: 'Etiketleme makinesi',
    robotic: 'Robot kolu',
    label: 'Etiket',
    warningTip: 'Lütfen dikkat edin: Süslü parantezler 【{}】 ve içerikleri eksiksiz kalmalıdır; elle silmeyin veya eklemeyin!',
    fileClassifyError: 'Bu dosya {classifyNames} göre sınıflandırılamaz',
    folderClassifyByTextureColorThickSize: 'Renk, malzeme, kalınlık ve büyük tahta boyutuna göre farklı klasörlere sınıflandırın (etiket dosyaları birlikte)',
    unnamed: 'İsimsiz',
    specialText: 'Özel',
    surplusText: 'Fazla malzeme',
    normalText: 'Normal',
    plankText1: 'Panel',
    resetTemplate: 'Normal',
    resetTemplateConfirm: 'Şablonu sıfırlamak istediğinizden emin misiniz?',
    clearTemplate: 'Şablonu temizle',
    clearTemplateConfirm: 'Şablonu temizlemek istediğinizden emin misiniz?',
    legendFixedFolder: 'Sabit klasör',
    legendClassifyFolder: 'Sınıflandırılmış klasör',
    legendFixedTag: 'Sabit veri',
    legendNormalTag: 'Dinamik veri',
    legendClassifyTag: 'Sınıflandırılmış dinamik veri',
    door_wall_aio: 'Duvar ve dolap yapan makine',
    noPermission: 'Şu anda özel klasör kullanma izniniz yok. Kullanmadan önce satın almak için lütfen satış ekibiyle iletişime geçin.',
    enableCustomFolder: 'Özel klasörleri etkinleştir',
    exporttagTip: "Etiket PDF'i ve görüntüyü aynı anda dışa aktarırken, varsayılan olarak PDF gönderilir"
    },
  paibanTask: {
    pausedTip: 'Duraklatılmış Görevler',
    deleteTip: '«{taskBatch}» görevini silmek istediğinize emin misiniz? Silindiğinden sonra geri alınamaz.',
    continueTip: 'Görevi sürdür',
    completed: 'Tamamlandı',
    failed: 'Görev başarısız',
    paused: 'Duraklatılmış Görevler',
    pending: 'Görevi sürdür',
    running: 'Görevi sürdür',
    extraTip: 'Düzenleme görevleri sadece geçen haftanın verilerini gösterir. Görev tamamlandıktan sonra el ile görevi geçmişe kaydedin!',
    taskStatus: 'Görev durumu',
    createTaskTip: 'Düzenleme görevini oluştur, düzenlemeye git',
    taskBatchTitle: 'Görev partisi',
    relatedOrderNosTitle: 'İlgili sipariş numaraları',
    progressTitle: 'Düzenleme ilerlemesi',
    boardCountTitle: 'Levha kullanımı tahmini',
    optimizedAreaTitle: 'Optimize edilmiş alan tahmini',
    productionLineTitle: 'Üretim hattı',
    operationTitle: 'İşlem',
    optimizeRateTitle: 'Levha optimizasyon oranını tahmin et',
    optimizeRateTip: 'Kesim artıklaması kullanımı hesaplanmamaktadır.',
    optimizeRateTip2: 'Düzenleme sayfasına dayalı özel optimizasyon oranı',
    boardCountTip: 'Düzenleme sayfasına dayalı özel levha kullanımı',
    optimizedAreaTip: 'Düzenleme sayfasına dayalı özel optimize edilmiş alan',
    paibanSettingTip: 'Mevcut görev üretim hatının ayarları değişti. Mevcut düzenleme sonuçları üretim dışa aktarım dosyalarıyla çakışabilir. Üretimi yeniden düzenlemeyi öneririz.',
    dataException: 'Veri hatası, lütfen sayfayı yenileyin ve tekrar deneyin'
    },
  paibanSetting: {
    advancedSetting: 'Gelişmiş ayarlar',
    advancedFeature: 'Gelişmiş özellikler',
    surplusCutSpeedUp: 'Kalan malzeme kesiminin otomatik hızlandırılması',
    surplusCutSpeedUpTip4: 'Özellik geliştirme sürecinde, lütfen bekleyin',
    surplusCutSpeedUpTip: 'Artık malzeme yerleşim aralığı otomatik olarak 0 yapılır',
    surplusCutSpeedUpTip2: 'Artık malzeme kesimi, verimliliği artırmak için kesilmiş ve kenar düzeltme yollarını otomatik olarak atlar',
    surplusCutSpeedUpTip3: 'Bu özellik yalnızca işleme makineleri ve bir dönüş işleme makineleri için geçerlidir (ortak kenar kesim ve ortak kenar hızlandırma ile birlikte kullanmayın)',
    surplusCutSpeedUpTip5: 'Yalnızca işleme makineleri ve bir dönüş işleme makineleri için geçerlidir',
    featureDisplay: 'Özellik görünümü',
    featureDisplayTip: 'Bu sayfa yalnızca özellik girişlerinin görüntülenmesini kontrol eder; özelliğin kendisinin etkin durumunu ve parametre yapılandırmasını değiştirmez'
    },
  alignedPlan: {
    deepSearch: 'Derin Arama',
    deepSearchTip: 'Özel özellik: yeniden yerleşimle hesaplama derinliğini artırarak daha iyi sonuç alın',
    deepSearchTip2: 'Deep Search yükseltmesinden sonra yeniden yerleşimle hesaplama derinliğini artırın. Şu an denenebilir',
    deepSearchTip3: 'Deep Search daha az levha kullanan bir yerleşim sunar',
    deepSearchTip4: 'Şu an Deep Search yerleşim yetkiniz yok. Satın almak için satış ile iletişime geçin.',
    deepSearchTip5: 'Deep Search yükseltmesinden sonra özel sunucu hesaplama gücüyle kalite artar. Şu an önizlenebilir'
    }
  }